<template>
  <div id="app" @click="menuShow=false">
    <div class="mmm">
      <div class="menu">
        <dl>
          <dd @click.stop="handleMenuClick"><img src="@/img/menu.png"></dd> 
          <dd @click="handleClick(0,'/home')" :class="{'on': currentIndex === 0}">
            <div>
              <img v-if="currentIndex !== 0" src="@/img/bn1.png" style="filter: brightness(0) saturate(100%) invert(65%) sepia(0%) saturate(0%) hue-rotate(166deg) brightness(85%) contrast(90%);">
              <img v-else src="@/img/bno1.png">
              <span>大厅</span>
            </div>
          </dd>
          <dd @click="handleClick(1,'/promotion')" :class="{'on': currentIndex === 1}">
            <div>
              <img v-if="currentIndex !== 1" src="@/img/bn2.png" style="filter: brightness(0) saturate(100%) invert(65%) sepia(0%) saturate(0%) hue-rotate(166deg) brightness(85%) contrast(90%);">
              <img v-else src="@/img/bno2.png">
              <span>优惠</span>
            </div>
          </dd>
          <dd @click="showDeposit();" :class="{'on': currentIndex === 2}">
            <div>
              <img v-if="currentIndex !== 2" src="@/img/bn3.png" style="filter: brightness(0) saturate(100%) invert(65%) sepia(0%) saturate(0%) hue-rotate(166deg) brightness(85%) contrast(90%);">
              <img v-else src="@/img/bno3.png">
              <span>充值</span>
            </div>
          </dd>
          <dd @click="showCommend();" :class="{'on': currentIndex === 3}">
            <div>
              <img v-if="currentIndex !== 3" src="@/img/bn4.png" style="filter: brightness(0) saturate(100%) invert(65%) sepia(0%) saturate(0%) hue-rotate(166deg) brightness(85%) contrast(90%);">
              <img v-else src="@/img/bno4.png">
              <span>推荐</span>
            </div>
          </dd>
          <dd @click="orderShow=true;queryOrderListByGameAsync(1);" :class="{'on': currentIndex === 4}">
            <div>
              <img src="@/img/bn6.png" style="filter: brightness(0) saturate(100%) invert(65%) sepia(0%) saturate(0%) hue-rotate(166deg) brightness(85%) contrast(90%);">
              <span>注单</span>
            </div>
          </dd>
          <dd @click="handleClick(5,'/pgpromo')" :class="{'on': currentIndex === 5}" v-if="false">
            <div>
              <img v-if="currentIndex !== 5" src="@/img/bn2.png" style="filter: brightness(0) saturate(100%) invert(65%) sepia(0%) saturate(0%) hue-rotate(166deg) brightness(85%) contrast(90%);">
              <img v-else src="@/img/bno2.png">
              <span>专题</span>
            </div>
          </dd>
        </dl>
      </div>
      <div class="center">
        <div class="nav">
          <p class="logo"></p>
          <dl class="btns-nologin" v-show="userData.account === ''">
            <dd @click="openApp(appData.quanzhan_android.apps)"><img src="@/img/download.png"></dd>
            <dd @click="clickService()"><img src="@/img/csl1.png"></dd>
            <dd @click="maskShow = true; loginShow = true">立即登录</dd>
            <dd @click="maskShow = true; registerShow = true">立即注册</dd>
          </dl>
          <dl class="btns-login" v-show="userData.account !== ''">
            <dd @click="openApp(appData.quanzhan_android.apps)"><img src="@/img/download.png"></dd>
            <dd @click="clickService()" ><img src="@/img/csl1.png"></dd>
            <dd @click="walletShow=true;walletShow = true;showDeposit();">
              <span data-v-a945d1c2="" style="width: 0.4rem; height: 0.4rem; display: flex; padding: 0.04rem; background: rgb(43, 183, 101); border-radius: 0.12rem; margin: 0px 0.06rem;"><svg data-v-a945d1c2="" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16"><g data-v-a945d1c2=""><path data-v-a945d1c2="" data-follow-fill="#fff" d="M13.332 4.667V3.333c0-.735-.598-1.333-1.333-1.333H3.332c-1.103 0-2 .897-2 2v8c0 1.467 1.196 2 2 2h10c.735 0 1.333-.598 1.333-1.333V6c0-.735-.598-1.333-1.333-1.333Zm-1.333 6h-1.334V8H12v2.667Zm-8.667-6a.667.667 0 0 1 0-1.334h8.667v1.334H3.332Z" fill="#fff"></path></g></svg></span>
              <span class="balance">{{userData.amount}}</span>
              <span class="refresh" @click="queryDetailsAsync();"></span>
            </dd>
            <dd @click="dataShow=true;qeuryVipDetailsAsync();queryAccountReportIntlAsync();">
              <span data-v-a945d1c2="" style="display: block;width: 0.4rem; height: 0.4rem;border-radius: 0.5rem;overflow: hidden;border: 1px solid #fff;"><img src="@/img/uico.jpg" /></span>
              <span class="more" style="display: flex;align-items: center;justify-content: center;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20C11.4696 20 10.9609 19.7893 10.5858 19.4142C10.2107 19.0391 10 18.5304 10 18C10 17.4696 10.2107 16.9609 10.5858 16.5858C10.9609 16.2107 11.4696 16 12 16C12.5304 16 13.0391 16.2107 13.4142 16.5858C13.7893 16.9609 14 17.4696 14 18ZM14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12ZM12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8Z" fill="white"/>
                </svg>
              </span>
            </dd>
            <dd :class="{active:messageCount>0}" @click="noticeShow=true;currentIndexNotice=1;querySiteChatAsync(1);">
              <img src="@/img/sts5.png">
            </dd>
          </dl>
        </div>
        <router-view />
      </div>
    </div>
    <div class="mask" v-show="maskShow" @click.stop :style="'z-index:'+(affShow?'1004':'1002')">
      <div class="login" v-show="loginShow">
        <div class="logb">
          <span class="title">登录</span> 
          <span class="close" @click="maskShow = false; loginShow = false"></span>
        </div>
        <div class="form">
          <div class="form-item">
            <p>账户名</p>
            <div class="user">
              <input type="text" placeholder="请输入账户名" v-model="userName" @input="showE1 = false">
            </div>
            <span class="error_line" v-show="showE1">请输入正确的账户名</span>
          </div>
          <div class="form-item">
            <p>密码</p>
            <div class="pwd">
              <input type="password" placeholder="请输入密码" v-model="password" @input="showE2 = false">
              <span class="showpwd"> </span>
            </div>
            <span class="error_line" v-show="showE2">请输入正确的密码</span>
          </div>
        </div>
        <div class="btns">
          <button class="login_btn" @click="verify()" v-if="requiredVerify">登录</button>
          <button class="login_btn" @click="loginAsync()" v-else>登录</button>
          <a class="forget_pwd">忘记密码？</a>
          <a class="register" @click="registerShow = true; loginShow = false">没有账号？<span>注册</span></a>
        </div>
      </div>
      <div class="login" v-show="registerShow">
        <div class="logb">
          <span class="title">注册</span> 
          <span class="close" @click="maskShow = false; registerShow = false"></span>
        </div>
        <div class="form">
          <div class="form-item">
            <p>账户名</p>
            <div class="user">
              <input type="text" placeholder="请输入账户名" v-model="userName" @input="showE3 = false">
            </div>
            <span class="error_line" v-show="showE3">请输入4-10位字母或数字的账户名</span>
          </div>
          <div class="form-item">
            <p>密码</p>
            <div class="pwd">
              <input type="password" placeholder="请输入密码" v-model="password" @input="showE4 = false">
              <span class="showpwd"> </span>
            </div>
            <span class="error_line" v-show="showE4">请输入6-20位字符串的密码</span>
          </div>
          <div class="form-item">
            <p>手机号</p>
            <div class="phone">
              <span class="left">+86</span>
              <input type="text" placeholder="请输入手机号" v-model="phone" @input="showE5 = false">
            </div>
            <span class="error_line" v-show="showE5">请输入11位数字的手机号</span>
          </div>
          <div class="form-item">
            <p>验证码</p>
            <div>
              <input type="text" placeholder="请输入验证码" v-model="phoneCode" @input="showE6 = false">
              <span class="getcode" @click="sendMessageForNotLoginAsync()">{{
                seconds ? seconds + "s后重试" : "发送验证码"
              }}</span>
            </div>
            <span class="error_line" v-show="showE6">请输入正确的验证码</span>
          </div>
        </div>
        <div class="btns">
          <button class="login_btn" @click="verifyForRegister" v-if="requiredVerify">注册</button>
          <button class="login_btn" @click="registerAsync" v-else>注册</button>
          <a class="register" @click="registerShow = false; loginShow = true">已经有账号？<span>登录</span></a>
        </div>
      </div>
      <div class="wallet" v-show="walletShow">
        <p class="title">
          <span>钱包</span>
          <a @click="recordShow=true;queryRecordClick();">交易明细</a>    
          <span class="close" @click="maskShow=false;walletShow=false"></span>
        </p>
        <div class="content">
          <div class="types">
            <ul>
              <li :class="{on: walletIndex==0}" @click="showDeposit();" v-show="affShow==false">充值</li>
              <li :class="{on: walletIndex==1}" @click="walletIndex=1;queryWithdrawAsync();betReportRequestAsync();transferReceiveAllAsync();">提款</li>
            </ul>
          </div>
          <div class="deposit" v-show="walletIndex==0">
              <div class="option">
                <ul :style="hideOption?'height:1.1rem;overflow:hidden;':''">
                  <li v-for="o,index in payList" :key="index" @click="currentIndexDeposit=index;currentIndexMerchant=0;currentIndexBank=0;needToPayFeeAsync();" :class="{on:index == currentIndexDeposit}"><img :src="o.navilogo" /></li>
                </ul>
                <p @click="hideOption=!hideOption">点击{{hideOption?'展开':'收起'}}充值渠道</p>
              </div>
              <div class="merchants" v-if="payList[currentIndexDeposit]">
                <p>选择通道</p>
                <ul>
                  <li v-for="o,index in payList[currentIndexDeposit].merchants" :key="index" @click="currentIndexMerchant=index;currentIndexBank=0;needToPayFeeAsync();" :class="{on:index == currentIndexMerchant}">{{o.name.split("【")[0]}}&nbsp;<span v-if="false">{{o.min}}起</span></li>
                </ul>
              </div>
              <template v-if="!showCrypto&&!showBank&&!showQr">
                <div class="merchants" v-if="payList[currentIndexDeposit]&&payList[currentIndexDeposit].merchants[currentIndexMerchant]&&payList[currentIndexDeposit].merchants[currentIndexMerchant].banklist[currentIndexBank]">
                  <p>选择方式</p>
                  <ul>
                    <li v-for="o,index in payList[currentIndexDeposit].merchants[currentIndexMerchant].banklist" :key="index" @click="currentIndexBank=index;" :class="{on:index == currentIndexBank}">{{o.name}}</li>
                  </ul>
                </div>
                <div class="amount">
                  <p>
                    <span>充值金额</span>
                    <span v-if="payList[currentIndexDeposit]&&payList[currentIndexDeposit].dkey!=7">手续费 <span>{{feecent}}%</span></span>
                    <span v-else>1 USDT≈<span>{{rate}}</span>人民币</span>
                  </p>
                  <ul class="abox">
                    <li :class="{usdt: payList[currentIndexDeposit]&&payList[currentIndexDeposit].dkey==7}"><input type="number" v-model="amount" v-if="payList[currentIndexDeposit]&&payList[currentIndexDeposit].merchants[currentIndexMerchant]" :placeholder="payList[currentIndexDeposit].merchants[currentIndexMerchant].min + '～' + payList[currentIndexDeposit].merchants[currentIndexMerchant].max" /></li>
                    <li>
                      <span v-if="payList[currentIndexDeposit]&&payList[currentIndexDeposit].dkey!=7">{{(Number(amount) - Number(amount) * (feecent / 100)).toFixed(2) || 0}}</span>
                      <span v-else>{{(Number(amount) * rate).toFixed(2) || 0}}</span>
                    </li>
                  </ul>
                  <ul class="faster" v-if="payList[currentIndexDeposit]&&payList[currentIndexDeposit].merchants[currentIndexMerchant]">
                      <li v-for="o, index in payList[currentIndexDeposit].merchants[currentIndexMerchant].fastpay.split(',')" :key="index" :class="{ on: amount == o }" @click="amount = o">{{ o }}</li>
                  </ul>
                </div>
                <div class="name" v-if="payList[currentIndexDeposit]&&payList[currentIndexDeposit].merchants[currentIndexMerchant]&&payList[currentIndexDeposit].merchants[currentIndexMerchant].requirename">
                  <p>存款姓名</p>
                  <div>
                    <input type="text" v-model="name" />
                  </div>
                </div>
                <div class="promotion">
                  <p>优惠活动</p>
                  <ul v-if="payList[currentIndexDeposit]">
                    <li v-for="o,index in payList[currentIndexDeposit].promos" :key="index" @click="currentIndexPromo=index;" :class="{on:index==currentIndexPromo}">{{o.s_text}}</li>
                  </ul>
                </div>
              </template>
              <div class="receivable" v-if="showCrypto">
                 <div class="info">
                  <p>充值金额</p>
                  <ul>
                    <li>
                      <span class="usdt">{{cryptoInfo.currency}}</span><span @click="doCopy(cryptoInfo.value)">{{cryptoInfo.value}}</span>
                    </li>
                    <li>
                      1USDT≈<span>{{cryptoInfo.xrate}}</span>人民币
                    </li>
                  </ul>
                 </div>
                 <div class="address">
                  <p>收款地址</p>
                  <ul>
                    <li @click="doCopy(cryptoInfo.wallet)">{{cryptoInfo.wallet}}</li>
                    <li>
                      <div id="qrcode_crypto"></div>
                    </li>
                  </ul>
                 </div>
                 <a @click="showCrypto=false">返回</a>
              </div>
              <div class="receivable" v-if="showBank">
                <div class="info">
                  <p>充值金额</p>
                  <ul>
                    <li>
                      <span>人民币</span><span @click="doCopy(bankInfo.amount)">{{bankInfo.amount}}</span>
                    </li>
                    <li>
                      倒计时 <span>{{seconds1}}</span>
                    </li>
                  </ul>
                 </div>
                 <div class="bank">
                    <p>收款信息</p>
                    <ul>
                        <li @click="doCopy(bankInfo.bank_acc_name)">{{bankInfo.bank_acc_name}}</li>
                        <li @click="doCopy(bankInfo.bank_card_num)">{{bankInfo.bank_card_num}}</li>
                        <li>{{bankInfo.collection_bank_id}}</li>
                    </ul>
                    <div>账户随时更换，请勿保存</div>
                 </div>
                 <a @click="showBank=false">返回</a>
              </div>
              <div class="receivable" v-if="showQr">
                 <div class="address">
                  <p>二维码</p>
                  <ul>
                    <li @click="doCopy(cryptoInfo.link)">{{cryptoInfo.link}}</li>
                    <li>
                      <div id="qrcode_crypto"></div>
                    </li>
                  </ul>
                 </div>
                 <a @click="showQr=false">返回</a>
              </div>
          </div>
          <div class="withdraw" v-show="walletIndex==1">
            <div class="option">
              <ul>
                <li v-for="o,index in withdrawList" :key="index" :class="{on:currentIndexWithdraw==index}" @click="currentIndexWithdraw=index;currentIndexWithdrawBank=0;"><img :src="o.navilogo"/></li>
              </ul>
            </div>
            <div class="amount">
              <p>
                  <span>提款金额</span>
                  <span>余额{{affShow==false?userData.amount:agentData.activeAmount}}</span>
              </p>
              <div>
                <input type="number" v-model="wAmount" />
              </div>
              <span v-if="affShow==false" class="desc" :class="{done: betReportData.remainingBet===0}" @click="betReportRequestAsync()">消费{{betReportData.minTotalBet}}<span v-show="betReportData.remainingBet!==0">还需{{betReportData.remainingBet}}</span>&nbsp;&nbsp;<span v-show="betReportData.remainingBet===0">完成</span></span>
            </div>
            <div class="crypto" v-show="withdrawList[currentIndexWithdraw] && withdrawList[currentIndexWithdraw].category==1">
              <p class="t">可兑换</p>
              <div>
                <p class="i"><span>USDT-TRC20</span><span>{{(wAmount/rate).toFixed(2)}}</span></p>
                <span class="b"><span>1</span>≈<span>{{rate}}</span>人民币</span>
              </div>
            </div>
            <div class="banks">
              <ul v-if="withdrawList[currentIndexWithdraw]">
                <li v-for="o,index in withdrawList[currentIndexWithdraw].banks" :key="index" :class="{on:index==currentIndexWithdrawBank}" @click="currentIndexWithdrawBank=index">
                   <div>
                      <p>钱包名称</p>
                      <span>{{o.name}}</span>
                   </div>
                   <div>
                      <p>收款地址</p>
                      <span>{{o.cardno}}</span>
                   </div>
                   <a @click="deleteCardAsync(o.cardno, o.cardsec)">删除</a>
                </li>
                <li class="add" @click="walletIndex=2">
                  <p></p>
                  <span>点击添加提款卡</span>
                </li>
              </ul>
            </div>
            <div class="pwd">
              <p>登录密码</p>
              <div>
                <input type="password" v-model="wPwd" />
              </div>
            </div>
          </div>
          <div class="card" v-show="walletIndex==2">
            <ul>
              <li @click="showCardBank=!showCardBank">
                <div v-if="withdrawList[currentIndexWithdraw]" >
                  <img :src="withdrawList[currentIndexWithdraw].navilogo" /> <span>{{withdrawList[currentIndexWithdraw].dvalue}}</span>
                </div>
                <dl v-show="showCardBank" @click.stop>
                  <dd v-for="o,index in withdrawList" :key="index" :class="{on:currentIndexWithdraw==index}" @click="currentIndexWithdraw=index;currentIndexCardBank=-1;">
                    <img :src="o.navilogo" /> <span>{{o.dvalue}}</span>
                  </dd>
                </dl>
              </li>
              <li @click="showCardBank=!showCardBank">
                <div v-if="banklist[currentIndexCardBank]">
                  <img :src="banklist[currentIndexCardBank].url" /> <span>{{banklist[currentIndexCardBank].name}}</span>
                </div>
                <div v-else>
                  <span>请选择</span>
                </div>
                <dl v-show="showCardBank" @click.stop>
                  <dd v-for="o,index in banklist" :key="index" :class="{on:currentIndexCardBank==index}" @click="currentIndexCardBank=index;showCardBank=false" v-show="o.category==withdrawList[currentIndexWithdraw].category">
                    <img :src="o.url" /> <span>{{o.name}}</span>
                  </dd>
                </dl>
              </li>
            </ul>
            <div class="ibox">
                <div class="c" v-if="withdrawList[currentIndexWithdraw]&&withdrawList[currentIndexWithdraw].category<2">
                  <p class="t">{{withdrawList[currentIndexWithdraw].category==0?'卡号':'钱包地址'}}</p>
                  <div><input type="text" v-model="cardNo" /></div>
                </div>
                <div class="c" v-if="withdrawList[currentIndexWithdraw]&&withdrawList[currentIndexWithdraw].category<2">
                  <p class="t">{{withdrawList[currentIndexWithdraw].category==0?'支行':'钱包名称'}}</p>
                  <div><input type="text" v-model="bankAddress" /></div>
                </div>
                <div class="add" v-show="imgLen == 0" v-if="withdrawList[currentIndexWithdraw]&&withdrawList[currentIndexWithdraw].category>1">
                  <p></p>
                  <span>点击上传二维码</span>
                  <input id="upload-input" type="file" accept="image/gif, image/jpg, image/png" ref="inputer" @change="addImg()" />
                </div>
                <div class="addc qrimg" v-show="imgLen > 0" v-for="(o, key) in imgs" :key="key">
                  <img :src="getObjectURL(o)" alt="" style="height:100%;width:100%;" />
                  <span class="del" @click="delImg(key)">删除</span>
                </div>
                <div class="c">
                  <p class="t">验证码</p>
                  <div class="v"><input type="text" v-model="verifyCode" /> <a @click="sendMessageForLoginAsync()">{{ seconds ? seconds + '秒后重发' : "发送验证码" }}</a></div>
                </div>
            </div>
          </div>
          <div class="btns" v-show="walletIndex==0 &&!showCrypto&&!showBank&&!showQr">
             <a @click="requestPayAsync()">提交</a>
          </div>
          <div class="btns" v-show="walletIndex==1">
            <a @click="requestWithdrawAsync()">提交</a>
          </div>
          <div class="btns" v-show="walletIndex==2">
            <a @click="addCardType()">提交</a>
            <a class="back" @click="walletIndex=1;">返回</a>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="infoShow">
      <div class="settings">
        <p class="title">
          <span>设置</span>
          <span class="close" @click="infoShow=false;"></span>
        </p>
        <div class="content">
          <div class="option">
            <p :class="{on:currentIndexSettings==0}" @click="currentIndexSettings=0">完善资料</p>
            <p :class="{on:currentIndexSettings==1}" @click="currentIndexSettings=1">修改密码</p>
          </div>
          <div class="info" v-show="currentIndexSettings==0&&!userData.realname">
            <div class="ibox">
              <p class="t">姓名</p>
              <div>
                <input type="text" v-model="editData.realName" />
              </div>
            </div>
            <div class="ibox">
              <p class="t">性别</p>
              <div class="s">
                <span :class="{on:editData.sex==0}" @click="editData.sex=0">男</span><span :class="{on:editData.sex==1}" @click="editData.sex=1">女</span>
              </div>
            </div>
            <div class="ibox">
              <p class="t">生日</p>              
              <div>
                <input type="text" v-model="editData.birthday" placeholder="示例：1990-02-01（1990年2月1日）" />
              </div>
            </div>
            <div class="ibox">
              <p class="t">邮箱</p>
              <div>
                <input type="text" v-model="editData.email" placeholder="示例：123456@qq.com" />
              </div>
            </div>
            <a @click="upadteDataAsync();">提交</a>
          </div>
          <div class="info" v-show="currentIndexSettings==0&&userData.realname">
            <div class="ibox">
              <p class="t">姓名</p>
              <div>
                <input type="text" :value="userData.realname" readonly/>
              </div>
            </div>
            <div class="ibox">
              <p class="t">性别</p>
              <div class="s">
                <span :class="{on:userData.sex==0}" >男</span><span :class="{on:userData.sex==1}" >女</span>
              </div>
            </div>
            <div class="ibox">
              <p class="t">生日</p>              
              <div>
                <input type="text" :value="userData.birthday" readonly />
              </div>
            </div>
            <div class="ibox">
              <p class="t">邮箱</p>
              <div>
                <input type="text" :value="userData.email" readonly />
              </div>
            </div>
          </div>
          <div class="info" v-show="currentIndexSettings==1">
            <div class="ibox">
              <p class="t">当前密码</p>
              <div>
                <input type="password" v-model="settings.pwd" />
              </div>
            </div>
            <div class="ibox">
              <p class="t">新密码</p>              
              <div>
                <input type="password" v-model="settings.newPwd" />
              </div>
            </div>
            <div class="ibox">
              <p class="t">确认新密码</p>
              <div>
                <input type="password" v-model="settings.confirmPwd" />
              </div>
            </div>
            <a @click="updatePasswordAsync();">提交</a>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="dataShow">
      <div class="udata">
        <p class="title">
          <span>用户资料</span>
          <span class="close" @click="dataShow=false;"></span>
        </p>
        <div class="content">
          <div class="user">
            <div>
              <dl>
                <dd>
                  <span>
                    <img src="@/img/uico.jpg" />
                  </span>
                  <span>Lv.{{userData.viplevel}}</span>
                </dd>
                <dd>
                  <span>{{userData.account}}</span>
                </dd>
              </dl> 
            </div>
          </div>
          <div class="count">
            <p class="t">数据统计</p>
            <div>
              <ul>
                  <li>
                    <p class="i">今日输赢</p>
                    <span>{{vipBetData.currentDayWinlost}}</span>
                  </li>
                  <li>
                    <p class="i">今日投注</p>
                    <span>{{vipBetData.currentDayWaggered}}</span>
                  </li>
                  <li>
                    <p class="i">今日充值</p>
                    <span>{{vipBetData.currentDayDeposit}}</span>
                  </li>
                  <li>
                    <p>昨日输赢</p>
                    <span>{{vipBetData.dailyWinlost}}</span>
                  </li>
                  <li>
                    <p>昨日投注</p>
                    <span>{{vipBetData.dailyTotalbets}}</span>
                  </li>
                  <li>
                    <p>昨日充值</p>
                    <span>{{vipBetData.dailyDeposit}}</span>
                  </li>
              </ul>
            </div>
          </div>
          <div class="membership">
            <p class="t">VIP俱乐部</p>
            <div class="v-banner">
              <van-swipe v-if="dataShow" class="my-swipe" :autoplay="3000" indicator-color="white" :show-indicators="false" @change="onSwipeChange">
                <van-swipe-item v-for="o,index in vipData.vipDetailModels" :key="index">
                  <div class="vip" :class="'vip_'+ (index+1)">
                    <div class="progress">
                      <p>VIP进度</p>
                      <p v-if="false">({{(userData.monthdeposit/o.vipUpLevelTaskModel.depositMin + userData.monthlybets/o.vipUpLevelTaskModel.betMin)*100/2 }}%)</p>
                      <div>
                        <span style="'width:0%"></span>
                      </div>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
          <div class="bonus" v-if="vipData.vipDetailModels&&vipData.vipDetailModels.length>0">
            <ul>
              <li>
                <div>
                  <p>升级奖金</p>
                  <span>{{ vipData.vipDetailModels[vipIndex].vipPromoModel.uplevelPromo }}</span>
                </div>
              </li> 
              <li>
                <div>
                  <p>每月免费筹码</p>
                  <span>{{ vipData.vipDetailModels[vipIndex].vipPromoModel.freeBets }}</span>
                </div>
              </li> 
              <li>
                <div>
                  <p>生日礼金</p>
                  <span>{{vipData.vipDetailModels[vipIndex].vipPromoModel.birthPromo}}</span>
                </div>
              </li> 
              <li>
                <div>
                  <p>每月最低投注</p>
                  <span>{{ vipData.vipDetailModels[vipIndex].vipUpLevelTaskModel.betMin }}</span>
                </div>
              </li> 
              <li>
                <div>
                  <p>提现次数</p>
                  <span>{{ vipData.vipDetailModels[vipIndex].vipPromoModel.dailyWithdrawTimes }}</span>
                </div>
              </li> 
              <li>
                <div>
                  <p>每日上限</p>
                  <span>{{ vipData.vipDetailModels[vipIndex].vipPromoModel.dailyWithdrawLimit || '无' }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="recordShow" :style="'z-index:'+(affShow?'1004':'1002')">
      <div class="record">
        <p class="title">
          <span>交易明细</span>
          <span class="close" @click="recordShow=false;"></span>
        </p>
        <div class="content">
          <div class="option" v-show="!affShow">
            <div class="dd" @click="clickRecordOption(0)">
              <span>{{record.types[record.type]}}</span>
              <dl v-show="showRecordOption == 0">
                <dd v-for="o,index in record.types" :key="index" @click="clickRecord(index)">{{o}}</dd>
              </dl>
            </div>
            <div class="dd" @click="clickRecordOption(1)">
              <span>{{record.timeTypeAsName[record.timeType]}}</span>
              <dl v-show="showRecordOption==1">
                <dd v-for="o,index in record.timeTypeAsName" :key="index" @click="record.timeType=index;queryRecordDetailsAsync(1);">{{o}}</dd>
              </dl>
            </div>
            <a @click="queryRecordDetailsAsync(1)" v-if="false">点击查询</a>
          </div>
          <div class="option" v-show="affShow">
            <div class="dd" @click="clickRecordOption(0)">
              <span>提款</span>
              <dl v-show="showRecordOption == 0">
                <dd @click="agentWithdrawRecordsAsync(1)">提款</dd>
              </dl>
            </div>
            <a @click="queryRecordDetailsAsync(1)" v-if="false">点击查询</a>
          </div>
          <div class="list-box" v-show="!affShow">
            <dl> 
              <dd class="t"><div><span>金额</span><span>状态</span><span>时间</span></div></dd>
              <dd class="b" :class="{active:o.active}" v-for="o,index in record.list" :key="index">
                <div @click="o.active=!o.active"><span><img v-show="o.iconUrl" :src="o.iconUrl" />{{(o.isSrypto)?o.cryptoModel.cryptoAmount : o.amount}}</span><span :class="record.type == 0 ? record.stateClass1[o.status] : record.stateClass[o.status]">{{o.statusDesc}}</span><span>{{ o.requesttime.format('yyyy-MM-dd') }}</span></div>
                <template v-if="record.type==0">
                  <p><span>通道</span><span>{{o.name}}</span></p>
                  <p><span>单号</span><span>{{o.merchantno}}</span></p>
                  <p><span>申请时间</span><span>{{o.requesttime}}</span></p>
                  <p><span>手续费</span><span>{{o.fee}}</span></p>
                  <p v-if="o.isSrypto"><span>汇率</span><span>{{o.cryptoModel.cryptoRate}}</span></p>
                </template>
                <template v-if="record.type==5">
                  <p><span>游戏</span><span>{{o.gamename}}</span></p>
                  <p><span>总投注</span><span>{{o.totalbets}}</span></p>
                  <p><span>输赢</span><span :class="{t:o.winlost<0,f:o.winlost>0}">{{o.winlost}}</span></p>
                  <p><span>申请时间</span><span>{{o.requesttime}}</span></p>
                  <p><span>派发时间</span><span>{{o.endtime}}</span></p>
                </template>
              </dd>
              <dd class="n" v-show="record.list.length==0">
                <img src="@/img/nodata.png" />
                <span>暂无数据</span>
              </dd>
              <dd class="m" v-if="record.list.length > 0 && record.pageCount > record.pageIndex" @click="queryRecordDetailsAsync(record.pageIndex + 1, true);">点击加载更多</dd>
            </dl>
          </div>
          <div class="list-box" v-show="affShow">
            <dl> 
              <dd class="t"><div><span>金额</span><span>状态</span><span>时间</span></div></dd>
              <dd class="b" :class="{active:o.active}" v-for="o,index in record1.list" :key="index">
                <div @click="o.active=!o.active"><span><img v-show="o.iconUrl" :src="o.iconUrl" />{{(o.isSrypto)?o.cryptoModel.cryptoAmount : o.amount}}</span><span :class="record.type == 0 ? record.stateClass1[o.status] : record.stateClass[o.status]">{{o.statusDesc}}</span><span>{{ o.requesttime.format('yyyy-MM-dd') }}</span></div>
              </dd>
              <dd class="n" v-show="record1.list.length==0">
                <img src="@/img/nodata.png" />
                <span>暂无数据</span>
              </dd>
              <dd class="m" v-if="record1.list.length > 0 && record1.pageCount > record1.pageIndex" @click="agentWithdrawRecords(record1.pageIndex + 1, true);">点击加载更多</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="taksShow">
      <div class="record">
        <p class="title">
          <span>任务中心</span>
          <span class="close" @click="taksShow=false;"></span>
        </p>
        <div class="content">
          <ul class="topt">
            <li v-for="o,index in taskMenu" :key="index" @click="currentIndexTask=index;" :class="{on:index==currentIndexTask}">{{o.title}}</li>
          </ul>
          <dl class="task">
            <dd v-for="o,index in taskList" :key="index" v-show="taskMenu[currentIndexTask] && o.category==taskMenu[currentIndexTask].category">
              <p>{{o.title}}</p>
              <div><span>{{o.subTitle}}</span><a href="#" @click="taskAsync(o.callAction,o.taskId);">{{o.submitName}}</a></div>
              <span class="times">{{o.betTimes}}</span>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="mask" v-show="noticeShow">
      <div class="record">
        <p class="title">
          <span>通知</span>
          <span class="close" @click="noticeShow=false;"></span>
        </p>
        <div class="content">
          <ul class="nopt">
            <li @click="currentIndexNotice=0;queryNoticePageAsync(1);" :class="{on:currentIndexNotice==0}">公告</li>
            <li @click="currentIndexNotice=1;querySiteChatAsync(1);" :class="{on:currentIndexNotice==1}">站内信</li>
          </ul>
          <dl class="notice">
            <template v-if="currentIndexNotice==0">
              <dd v-for="o,index in noticeMessage.list" :key="index">
                <p v-if="false">公告</p>
                <div>{{o.body}}</div>
                <span>{{o.createtime}}</span>
              </dd>
              <dd class="n" v-show="noticeMessage.list.length==0">
                <img src="@/img/nodata.png" />
                <span>暂无数据</span>
              </dd>
              <dd class="m" v-if="noticeMessage.list.length > 0 && noticeMessage.pageCount > noticeMessage.pageIndex" @click="queryNoticePageAsync(noticeMessage.pageIndex + 1, true);">点击加载更多</dd>
            </template>
            <template v-if="currentIndexNotice==1">
              <dd v-for="o,index in siteMessage.list" :key="index">
                <p >{{o.title}}</p>
                <div>{{o.content}}</div>
                <span>{{o.createtime}}</span>
              </dd>
              <dd class="n" v-show="siteMessage.list.length==0">
                <img src="@/img/nodata.png" />
                <span>暂无数据</span>
              </dd>
              <dd class="m" v-if="siteMessage.list.length > 0 && siteMessage.pageCount > siteMessage.pageIndex" @click="querySiteChatAsync(siteMessage.pageIndex + 1, true);">点击加载更多</dd>
            </template>
          </dl>
        </div>
      </div>
    </div>
    <div class="mask" v-show="commendShow">
      <div class="record">
          <p class="title">
            <span>推荐</span>
            <span class="close" @click="commendShow=false;"></span>
          </p>
          <div class="content">
            <div class="option">
              <div class="dd" @click="clickCommendOption(0)">
                <span>{{commend.types[commend.type]}}</span>
                <dl v-show="showCommendOption == 0">
                  <dd v-for="o,index in commend.types" :key="index" @click="clickCommend(index)">{{o}}</dd>
                </dl>
              </div>
              <div class="dd" @click="clickCommendOption(1)" v-show="commend.type==1">
                <span>{{commend.timeTypeAsName[commend.timeType]}}</span>
                <dl v-show="showCommendOption==1">
                  <dd v-for="o,index in commend.timeTypeAsName" :key="index" @click="commend.timeType=index;qeuryReferralPlayesDataAsync(1);">{{o}}</dd>
                </dl>
              </div>
            </div>
            <div class="qr" v-show="commend.type==0">
              <div class="title">
                <p>推荐</p>
                <ul v-if="false"><li>链接1</li><li>链接2</li></ul>
              </div>
              <div class="i">
                  <div class="qrbox">
                    <div id="qrcode_invite"></div>
                  </div>
              </div>
              <p><span><span>链接&nbsp;&nbsp;&nbsp;</span>{{userData.levelurl+'?v='+userData.friendcode}}</span><span @click="doCopy(userData.levelurl+'?v='+userData.friendcode)"></span></p>
              <p v-if="false"><span><span>代码&nbsp;&nbsp;&nbsp;</span>{{userData.friendcode}}</span><span></span></p>
            </div>
            <div class="list-box" v-show="commend.type==0">
              <dl>
                <dd class="t">
                  <div>
                    <span>比例</span>
                    <span>推荐奖</span>
                  </div>
                </dd>
                <dd class="b">
                  <div>
                    <span><img src="@/img/cny.png"/>{{refData.yesterdayData.rate}}</span>
                    <span><img src="@/img/cny.png"/>{{refData.yesterdayData.commission}}</span>
                  </div>
                </dd>
              </dl>
            </div>
            <div class="btips" v-show="commend.type==0">
              <p>详细了解我们的推荐计划</p>
              <span>例如，您邀请的会员中，昨天有5名会员达到有效标准，累计充值金额为15万。所以你的奖励是150,000*1%=1500</span>
            </div>
            <div class="data" v-show="commend.type==1">
              <ul>
                <li>
                  <p>总存款</p>
                  <span>{{commend.total.depositamount}}</span>
                </li>
                <li>
                  <p>推荐奖</p>
                  <span>{{commend.total.commission}}</span>
                </li>
              </ul>
            </div>
            <div class="list-box" v-show="commend.type==1">
              <dl>
                <dd class="t">
                  <div>
                    <span style="width:50%">用户名</span>
                    <span style="width:50%">存款</span>
                  </div>
                </dd>
                <dd class="b" v-for="o,index in commend.list" :key="index">
                  <div>
                    <span style="width:50%">{{o.account}}</span>
                    <span style="width:50%">{{o.depositamount}}</span>
                  </div>
                </dd>
                <dd class="n" v-if="commend.list.length < 1">
                  <img src="@/img/nodata.png" />
                  <span>暂无数据</span>
                </dd>
                <dd class="m" v-if="commend.list.length > 0 && commend.pageCount > commend.pageIndex" @click="qeuryReferralPlayesDataAsync(commend.pageIndex + 1, true);">点击加载更多</dd>
              </dl>
            </div>
            <div class="data" v-show="commend.type==2">
              <ul>
                <li>
                  <p>推荐</p>
                  <span>{{ refData.report.referrals }}</span>
                </li>
                <li>
                  <p>活跃</p>
                  <span>{{ refData.report.activeNumbers }}</span>
                </li>
                <li>
                  <p>存款</p>
                  <span>{{ refData.report.depositAmount }}</span>
                </li>
                <li>
                  <p>佣金</p>
                  <span>{{ refData.report.commission }}</span>
                </li>
              </ul>
            </div>
            <div class="list-box" v-show="commend.type==2">
              <dl>
                <dd class="t">
                  <div>
                    <span>推荐</span>
                    <span>活跃</span>
                    <span>佣金</span>
                  </div>
                </dd>
                <dd class="b" v-for="o, index in historyData" :key="index" :class="{active:o.active}">
                  <div @click="o.active=!o.active">
                    <span>{{o.referrals}}</span>
                    <span>{{o.activeNumbers }}</span>
                    <span>{{o.commission }}</span>
                  </div>
                  <p><span>状态</span><span :class="{t:o.status==1,f:o.status==0}">{{o.statusDes}}</span></p>
                  <p><span>时间</span><span>{{o.billDate.format('yyyy-MM-dd hh:mm:ss')}}</span></p>
                </dd>
              </dl>
            </div>
          </div>
      </div>
    </div>
    <div class="mask" v-show="affShow">
      <div class="record">
          <p class="title">
            <span v-show="!aff.reportAccount">合营</span>
            <span v-show="aff.reportAccount" class="acc" @click="aff.reportAccount='';aff.reportBalance=0;">{{aff.reportAccount}}</span>
            <span class="close" @click="affShow=false;"></span>
            <a v-show="aff.reportAccount" >
              <span style="width: 0.24rem; height: 0.24rem; display: flex; padding: 0.04rem; background: rgb(43, 183, 101); border-radius: 0.08rem; margin: 0px 0.06rem;"><svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16"><g ><path data-follow-fill="#fff" d="M13.332 4.667V3.333c0-.735-.598-1.333-1.333-1.333H3.332c-1.103 0-2 .897-2 2v8c0 1.467 1.196 2 2 2h10c.735 0 1.333-.598 1.333-1.333V6c0-.735-.598-1.333-1.333-1.333Zm-1.333 6h-1.334V8H12v2.667Zm-8.667-6a.667.667 0 0 1 0-1.334h8.667v1.334H3.332Z" fill="#fff"></path></g></svg></span>
              <span class="balance">{{aff.reportBalance}}</span>
              <span class="refresh" @click="agentQueryPlayerBalanceIntlAsync();"></span>
            </a>
          </p>
          <div class="content">
            <div class="option" v-show="!aff.reportAccount">
              <div class="dd" @click="clickCommendOption(0)">
                <span>{{aff.types[aff.type]}}</span>
                <dl v-show="showCommendOption == 0">
                  <dd v-for="o,index in aff.types" :key="index" @click="clickAff(index)">{{o}}</dd>
                </dl>
              </div>
              <div class="dd" @click="clickCommendOption(1)" v-show="aff.type==1">
                <span>{{aff.timeTypeAsName[aff.timeType]}}</span>
                <dl v-show="showCommendOption==1">
                  <dd v-for="o,index in aff.timeTypeAsName" :key="index" @click="aff.timeType=index;playersFinanceReportListINRAsync(1);">{{o}}</dd>
                </dl>
              </div>
              <div class="dd" @click="clickCommendOption(2)" v-show="aff.type==3">
                <span>{{member.timeTypeAsName[member.timeType]}}</span>
                <dl v-show="showCommendOption==2">
                  <dd v-for="o,index in member.timeTypeAsName" :key="index" @click="member.timeType=index;memberClick();">{{o}}</dd>
                </dl>
              </div>
              <div class="dd" @click="clickCommendOption(3)" v-show="aff.type==3">
                <span>{{member.type==0?'首存':'会员列表'}}</span>
                <dl v-show="showCommendOption==3">
                  <dd @click="member.type=0;agentFirstDepositRecordsAsync(1);">首存</dd>
                  <dd @click="member.type=1;agentRegisterRecordsAsync(1);">会员列表</dd>
                </dl>
              </div>
            </div>
            <div class="qr" v-show="aff.type==0">
              <div class="title">
                <p>合营</p>
                <ul v-if="agentData.adlink"><li v-for="o, index in agentData.adlink.split(' ')" :key="index" @click="currentIndexAffLink = index;" :class="{on:currentIndexAffLink == index}">链接{{ index + 1 }}</li></ul>
              </div>
              <div class="i">
                  <div class="qrbox" v-if="agentData.adlink">
                    <div :id="'qrcode_invite_' + index" v-for="o, index in agentData.adlink.split(' ')" :key="index" v-show="currentIndexAffLink == index"></div>
                  </div>
              </div>
              <p v-if="agentData.adlink"><span><span>链接&nbsp;&nbsp;&nbsp;</span>{{agentData.adlink.split(' ')[currentIndexAffLink]}}</span><span @click="doCopy(agentData.adlink.split(' ')[currentIndexAffLink])"></span></p>
              <p><span><span>代码&nbsp;&nbsp;&nbsp;</span>{{agentData.adcode}}</span><span @click="doCopy(agentData.adcode)"></span></p>
            </div>
            <div class="aff-balane" v-show="aff.type==0">
              <p>合营余额</p>
              <div>
                <span>{{agentData.balance}}</span>
                <a @click="maskShow=true;walletShow=true;walletIndex=1;queryWithdrawAsync();">提款</a>
              </div>
            </div>
            <div class="btips" v-show="aff.type==0">
              <p>了解更多关于我们的联盟计划</p>
              <span>下表显示了奖励方式</span>
            </div>
            <div class="aff-list" v-show="aff.type==0">
              <div class="tt">
                <p><span>等级</span><span>盈亏</span><span>活跃用户</span><span>比例</span></p>
              </div>
              <div class="tb">
                <p v-for="o, index in affRulesData.agentBillRuleModels" :key="index"><span>{{ o.level }}</span><span>{{ o.profit }}</span><span>{{ o.activeMember }}</span><span>{{ o.ratio }}</span></p>
              </div>
            </div>
            <div class="btips" v-show="aff.type==0">
              <span>备注: 净利润的计算方式：线下会员在所有场馆的总输赢-会员红利-手续费-场馆费用。</span>
            </div>
            <div class="aff-rules" v-show="aff.type==0">
              <p>有条件陈述</p>
              <div>
                1.要获得活跃玩家资格，每月累积充值金额≥1000，并且必须有至少5名活跃会员结算当月佣金。<br/><br/>
                2.佣金结算时间定于每月5日-10内。<br/><br/>
                3.佣金计算方式：[（投注盈亏-100%折扣）-（存款+取款）手续费-平台手续费*8%]*佣金比例。<br/><br/>
              </div>
            </div>
            <div class="list-box" v-show="aff.type==1 && !aff.reportAccount">
              <dl>
                <dd class="t">
                  <div>
                    <span>用户名</span>
                    <span>存款</span>
                    <span>提款</span>
                  </div>
                </dd>
                <dd class="b" :class="{active:aff.totalActive}">
                  <div @click="aff.totalActive=!aff.totalActive">
                    <span>总计</span>
                    <span><img src="@/img/cny.png"/>{{aff.total.depositAmount}}</span>
                    <span><img src="@/img/cny.png"/>{{aff.total.withdrawAmount}}</span>
                  </div>
                   <p><span>输赢</span><span>{{aff.total.winlost}}</span></p>
                   <p><span>流水</span><span>{{aff.total.bets}}</span></p>
                   <p><span>返水</span><span>{{aff.total.turnover}}</span></p>
                   <p><span>红利</span><span>{{aff.total.bonus}}</span></p>
                </dd>
                <dd class="b" v-for="o,index in aff.list" :key="index" :class="{active:o.active}">
                  <div @click="o.active=!o.active">
                    <span @click.stop="aff.reportAccount=o.account;agentQueryPlayerBalanceIntlAsync();recordDetailsAsync(1);">{{o.account}}</span>
                    <span><img src="@/img/cny.png"/>{{o.depositAmount}}</span>
                    <span><img src="@/img/cny.png"/>{{o.withdrawAmount}}</span>
                  </div>
                   <p><span>输赢</span><span>{{o.winlost}}</span></p>
                   <p><span>流水</span><span>{{o.bets}}</span></p>
                   <p><span>返水</span><span>{{o.turnover}}</span></p>
                   <p><span>红利</span><span>{{o.bonus}}</span></p>
                </dd>
                <dd class="n" v-if="aff.list.length < 1">
                  <img src="@/img/nodata.png" />
                  <span>暂无数据</span>
                </dd>
                <dd class="m" v-if="aff.list.length > 0 && aff.pageCount > aff.pageIndex" @click="agentFirstDepositRecordsAsync(aff.pageIndex + 1, true);">点击加载更多</dd>
              </dl>
            </div>
            <div class="inside" v-show="aff.reportAccount">
                <ul>
                  <li :class="{on:affInside.type==0}" @click="affInside.type=0;recordDetailsAsync(1);">充值</li>
                  <li :class="{on:affInside.type==1}" @click="affInside.type=1;recordDetailsAsync(1);">提现</li>
                  <li :class="{on:affInside.type==4}" @click="affInside.type=4;recordDetailsAsync(1);">奖励</li>
                  <li :class="{on:affInside.type==5}" @click="affInside.type=5;recordDetailsAsync(1);">返水</li>
                </ul>
                <div class="list-box" v-show="aff.type==1">
                  <dl>
                    <dd class="t">
                      <div>
                        <span>用户名</span>
                        <span>金额</span>
                        <span>时间</span>
                      </div>
                    </dd>
                    <dd class="b" v-for="o,index in affInside.list" :key="index" :class="{active:o.active}">
                      <div @click="o.active=!o.active">
                        <span>{{o.account}}</span>
                        <span><img src="@/img/cny.png"  v-if="!o.iconUrl"/><img v-if="o.iconUrl" :src="o.iconUrl"/>{{o.amount}}</span>
                        <span>{{o.requesttime.format('yyyy-MM-dd')}}</span>
                      </div>
                      <template v-if="affInside.type==0" >
                        <p><span>订单号</span><span>{{o.merchantno}}</span></p>
                        <p><span>通道</span><span>{{o.name}}</span></p>
                        <p><span>状态</span><span>{{o.statusDesc}}</span></p>
                        <p><span>申请时间</span><span>{{o.requesttime}}</span></p>
                        <p><span>处理时间</span><span>{{o.endtime}}</span></p>
                        <p><span>手续费</span><span>{{o.fee}}</span></p>
                        <p><span>汇率</span><span v-if="o.cryptoModel">{{o.cryptoModel.cryptoRate}}</span></p>
                      </template>
                      <template v-if="affInside.type==1" >
                        <p><span>方式</span><span>{{o.cardbank}}</span></p>
                        <p><span>状态</span><span>{{o.statusDesc}}</span></p>
                        <p><span>申请时间</span><span>{{o.requesttime}}</span></p>
                        <p><span>处理时间</span><span>{{o.endtime}}</span></p>
                        <p><span>汇率</span><span v-if="o.cryptoModel">{{o.cryptoModel.cryptoRate}}</span></p>
                      </template>
                      <template v-if="affInside.type==4" >
                        <p><span>类型</span><span>{{o.remarks}}</span></p>
                        <p><span>状态</span><span>{{o.statusDesc}}</span></p>
                        <p><span>申请时间</span><span>{{o.requesttime}}</span></p>
                        <p><span>处理时间</span><span>{{o.endtime}}</span></p>
                        <p><span>流水倍数</span><span>{{o.betTimes}}</span></p>
                      </template>
                      <template v-if="affInside.type==5" >
                        <p><span>游戏</span><span>{{o.gamename}}</span></p>
                        <p><span>状态</span><span>{{o.statusDesc}}</span></p>
                        <p><span>申请时间</span><span>{{o.requesttime}}</span></p>
                        <p><span>处理时间</span><span>{{o.endtime}}</span></p>
                        <p><span>流水</span><span>{{o.totalbets}}</span></p>
                        <p><span>输赢</span><span>{{o.winlost}}</span></p>
                      </template>
                    </dd>
                    <dd class="n" v-if="affInside.list.length < 1">
                      <img src="@/img/nodata.png" />
                      <span>暂无数据</span>
                    </dd>
                    <dd class="m" v-if="affInside.list.length > 0 && affInside.pageCount > affInside.pageIndex" @click="recordDetailsAsync(aff.pageIndex + 1, true);">点击加载更多</dd>
                  </dl>
                </div>
            </div>
            <div class="data" v-show="aff.type==4">
              <ul>
                <li>
                  <p>总存款</p>
                  <span>{{commend.total.depositamount}}</span>
                </li>
                <li>
                  <p>推荐奖</p>
                  <span>{{commend.total.commission}}</span>
                </li>
              </ul>
            </div>
            <div class="list-box" v-show="aff.type==2">
              <dl>
                <dd class="t">
                  <div>
                    <span style="width:50%">本月佣金</span>
                    <span style="width:50%">历史累计</span>
                  </div>
                </dd>
                <dd class="b">
                  <div>
                    <span style="width:50%"><img src="@/img/cny.png" />{{affcommissionData.totalAmount}}</span>
                    <span style="width:50%"><img src="@/img/cny.png" />{{affcommissionData.totalUnSettleAmount}}</span>
                  </div>
                </dd>
              </dl>
            </div>
            <div class="data" v-show="aff.type==2">
              <ul>
                <li>
                  <p>存款</p>
                  <span>{{ affReportData.depositAmount }}</span>
                </li>
                <li>
                  <p>提款</p>
                  <span>{{ affReportData.withdrawAmount}}</span>
                </li>
                <li>
                  <p>投注额</p>
                  <span>{{ affReportData.wagered }}</span>
                </li>
                <li>
                  <p>输赢</p>
                  <span :class="{ t: affReportData.winlost > 0, f: affReportData.winlost < 0 }">{{ affReportData.winlost }}</span>
                </li>
                <li>
                  <p>红利</p>
                  <span>{{ affReportData.rewards }}</span>
                </li>
                <li>
                  <p>返水</p>
                  <span>{{ affReportData.rebate }}</span>
                </li>
                <li>
                  <p>手续费</p>
                  <span>{{ affReportData.fee }}</span>
                </li>
                <li>
                  <p>平台费</p>
                  <span>{{ affReportData.totalGameFee }}</span>
                </li>
              </ul>
            </div>
            <div class="list-box" v-show="aff.type==2">
              <dl>
                <dd class="t">
                  <div>
                    <span>金额</span>
                    <span>状态</span>
                    <span>时间</span>
                  </div>
                </dd>
                <dd class="b" v-for="o, index in affBill.list" :key="index" :class="{active:o.active}">
                  <div @click="o.active=!o.active">
                    <span><img src="@/img/cny.png" />{{o.unSettleAmount}}</span>
                    <span :class="{ t: o.statusDesc == '审核完成', w: o.statusDesc != '审核完成' }">{{o.statusDesc }}</span>
                    <span>{{o.date }}</span>
                  </div>
                  <p><span>存款</span><span>{{o.depositamount}}</span></p>
                  <p><span>提款</span><span>{{o.withdrawamount}}</span></p>
                  <p><span>流水</span><span>{{o.bet}}</span></p>
                  <p><span>输赢</span><span>{{o.grossamount}}</span></p>
                  <p><span>红利</span><span>{{o.bonus}}</span></p>
                  <p><span>返水</span><span>{{o.turnover}}</span></p>
                  <p><span>手续费</span><span>{{o.withdraw_fee}}</span></p>
                  <p><span>平台费</span><span>{{o.platformfee}}</span></p>
                  <p><span>结算比例</span><span>{{o.proportionToP}}</span></p>
                  <p><span>历史累计</span><span>{{o.unSettleAmountPre}}</span></p>
                  <p><span>时间</span><span>{{o.date}}</span></p>
                </dd>
              </dl>
            </div>
            <div class="list-box" v-show="aff.type==3&&member.type==0">
              <dl>
                <dd class="t">
                  <div>
                    <span>账户</span>
                    <span>首存</span>
                    <span>时间</span>
                  </div>
                </dd>
                <dd class="b" v-for="o, index in member.list" :key="index" >
                  <div>
                    <span>{{o.account}}</span>
                    <span><img src="@/img/cny.png" />{{o.amount}}</span>
                    <span>{{o.paytime.format('yyyy-MM-dd') }}</span>
                  </div>
                </dd>
                <dd class="n" v-if="member.list.length < 1">
                  <img src="@/img/nodata.png" />
                  <span>暂无数据</span>
                </dd>
                <dd class="m" v-if="member.list.length > 0 && member.pageCount > member.pageIndex" @click="agentFirstDepositRecordsAsync(member.pageIndex + 1, true);">点击加载更多</dd>
              </dl>
            </div>
            <div class="list-box" v-show="aff.type==3&&member.type==1">
              <dl>
                <dd class="t">
                  <div>
                    <span>账户</span>
                    <span>首存</span>
                    <span>时间</span>
                  </div>
                </dd>
                <dd class="b" v-for="o, index in register.list" :key="index" >
                  <div>
                    <span>{{o.account}}</span>
                    <span><img src="@/img/cny.png" />{{o.amount}}</span>
                    <span>{{o.createtime.format('yyyy-MM-dd') }}</span>
                  </div>
                </dd>
                <dd class="n" v-if="register.list.length < 1">
                  <img src="@/img/nodata.png" />
                  <span>暂无数据</span>
                </dd>
                <dd class="m" v-if="register.list.length > 0 && register.pageCount > register.pageIndex" @click="agentRegisterRecordsAsync(register.pageIndex + 1, true);">点击加载更多</dd>
              </dl>
            </div>
          </div>
      </div>
    </div>
    <div class="mask" v-show="orderShow">
        <div class="record">
          <p class="title">
            <span>注单</span>
            <span class="close" @click="orderShow=false;"></span>
          </p>
          <div class="content">
            <div class="game-list">
              <ul>
                <li v-for="o,index in orderPlat" :key="index" @click="order.gameId = o.id; queryOrderListByGameAsync(1);" :class="{on:o.id==order.gameId}">{{o.gameName}}</li>
              </ul>
            </div>
            <div class="total">
              <dl>
                <dd>总计&nbsp;<span>{{order.totalData.count}}</span></dd>
                <dd>投注&nbsp;<span>{{order.totalData.betAmount}}</span></dd>
                <dd v-if="order.settled">输赢&nbsp;<span :class="{t:order.totalData.winLost>0,f:order.totalData.winLost<0}">{{order.totalData.winLost}}</span></dd>
                <dd v-if="!order.settled && order.totalData.maxWinAmount != 0">总可赢&nbsp;<span>{{order.totalData.maxWinAmount}}</span></dd>
              </dl>
            </div>
            <div class="btn">
              <dl>
                <dd :class="{on:order.settled}" @click="order.settled=true;queryOrderListByGameAsync(1);">已结算</dd>
                <dd :class="{on:!order.settled}" @click="order.settled=false;order.dateType=2;queryOrderListByGameAsync(1);">未结算</dd>
                <dd  @click="showOrderDate = !showOrderDate;">
                  {{ order.dateType == 0 ? '昨天' : order.dateType == 2 ? '最近一周' : '今天' }}
                  <ul v-show="showOrderDate">
                    <li @click.stop="showOrderDate = false; order.dateType = 0; queryOrderListByGameAsync(1);" :class="{on:order.dateType==0}"
                      v-if="order.settled">昨天</li>
                    <li @click.stop="showOrderDate = false; order.dateType = 1; queryOrderListByGameAsync(1);" :class="{on:order.dateType==1}"
                      v-if="order.settled">今天</li>
                    <li @click.stop="showOrderDate = false; order.dateType = 2; queryOrderListByGameAsync(1);" :class="{on:order.dateType==2}">最近一周
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <div class="list-box">
              <dl>
                <dd class="b active" style="padding-top:0.16rem;" v-for="o, index in order.list" :key="index">
                  <p><span style="color:#fff">{{ o.gameTitle }}</span><span class="o" :class="{f:o.statusDesc=='输',t:o.statusDesc=='赢',c:o.statusDesc=='和'}">· {{ o.statusDesc }}</span></p>
                  <p><span>订单号</span><span>{{ o.id }}</span></p>
                  <p><span>投注时间</span><span>{{ o.betTime }}</span></p>
                  <p><span>投注金额</span><span>{{ o.betAmount }}</span></p>
                  <p v-show="!order.settled&&o.maxWinAmount"><span>可赢金额</span><span>{{ o.maxWinAmount == 0 ? '' :  o.maxWinAmount }}</span></p>
                  <p v-show="order.settled"><span>输赢</span><span :class="{f:o.winLost<0,t:o.winLost>0}">{{ o.winLost }}</span></p>
                  <p><span>下注详情</span><span>{{ o.betContent }}</span></p>
                </dd>
                <dd class="n" v-if="order.list.length < 1">
                  <img src="@/img/nodata.png" />
                  <span>暂无数据</span>
                </dd>
                <dd class="m" v-if="order.pageCount > order.pageIndex" @click="queryOrderListByGameAsync(order.pageIndex + 1, true);">点击加载更多</dd>
              </dl>
            </div>
          </div>
        </div>
    </div>
    <div class="mask" v-show="promoShow">
      <div class="record">
        <p class="title">
          <span>领取记录</span>
          <span class="close" @click="promoShow=false;"></span>
        </p>
        <div class="content">
          <div class="option1">
            <ul>
              <li @click="promo.showIndex==0?promo.showIndex=-1:promo.showIndex=0" :class="{on:promo.showIndex==0}">
                <span>{{promo.timeTypeAsName[promo.timeIndex]}}</span>
                <dl v-show="promo.showIndex==0">
                  <dd v-for="o,index in promo.timeTypeAsName" :key="index" @click="promo.timeIndex=index;applicationPGPromoRecordAsync();" :class="{on:promo.timeIndex==index}">{{o}}</dd>
                </dl>
              </li>
              <li @click="promo.showIndex==1?promo.showIndex=-1:promo.showIndex=1" :class="{on:promo.showIndex==1}">
                <span>{{promo.statusAsName[promo.statusIndex]}}</span>
                <dl v-show="promo.showIndex==1">
                  <dd v-for="o,index in promo.statusAsName" :key="index" @click="promo.statusIndex=index;applicationPGPromoRecordAsync();" :class="{on:promo.statusIndex==index}">{{o}}</dd>
                </dl>
              </li>
            </ul>
          </div>
          <div class="list-box1">
              <dl>
                <dd class="b" v-for="(item, idx) in promo.list" :key="idx">
                  <div class="tt">
                    <p><span>{{ item.remarks }}</span></p>
                    <p><span :class="{t:item.status==1,w:item.status==0,f:item.status==2}">{{ item.statusDesc}}</span></p>
                  </div>
                  <div>
                    <p><span>存款金额&nbsp;&nbsp;<span>{{ item.amount }}</span></span></p>
                    <p><span>奖金&nbsp;&nbsp;<span>{{ item.reward }}</span></span></p>
                  </div>
                  <div>
                    <p><span>时间&nbsp;&nbsp;<span>{{ item.createtime }}</span></span></p>
                    <p><span>流水倍数&nbsp;&nbsp;<span>{{ item.bet }}</span></span></p>
                  </div>
                </dd>
                <dd class="n" v-if="!promo.list || promo.list.length < 1">
                  <img src="@/img/nodata.png" />
                  <span>暂无数据</span>
                </dd>
              </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="promo1Show!=-1">
        <div class="record">
          <p class="title">
            <span v-show="promo1Show==2">每日流水彩金 最高8888</span>
            <span v-show="promo1Show==0">救援金无上限</span>
            <span v-show="promo1Show==1">每日注单挑战金 最高18888</span>
            <span class="close" @click="promo1Show=-1;"></span>
          </p>
          <div class="content p" v-show="promo1Show==1">
            <p>在PG电子游戏，当日有效投注达到50单以上，不计输赢，次日即可自助领取最高18888元PG注单挑战金。</p>
            <table>
              <thead>
                <tr>
                  <th>有效注单量</th>
                  <th>平均注单金额≥3彩金</th>
                  <th>平均注单金额≥10彩金</th>
                  <th>流水要求</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>50单+</td>
                  <td>2元</td>
                  <td>5元</td>
                  <td rowspan="12">3倍</td>
                </tr>
                <tr><td>100单+</td><td>5元</td><td>8元</td></tr>
                <tr><td>300单+</td><td>8元</td><td>18元</td></tr>
                <tr><td>500单+</td><td>18元</td><td>28元</td></tr>
                <tr><td>1000单+</td><td>28元</td><td>38元</td></tr>
                <tr><td>3000单+</td><td>38元</td><td>58元</td></tr>
                <tr><td>5000单+</td><td>88元</td><td>188元</td></tr>
                <tr><td>1万单+</td><td>188元</td><td>388元</td></tr>
                <tr><td>3万单+</td><td>388元</td><td>888元</td></tr>
                <tr><td>5万单+</td><td>888元</td><td>2888元</td></tr>
                <tr><td>10万单+</td><td>2888元</td><td>5888元</td></tr>
                <tr><td>50万单+</td><td>5888元</td><td>18888元</td></tr>
              </tbody>
            </table>
            <p>举例：会员当日于【PG电子】达到总有效投注50万，累积注单10万单；单注值【50万÷10万单≥5元】，即可获得2888元PG注单彩金，单注值计算方式为【当天电子总有效投注÷电子注单总数】.</p>
            <div class="rule">
              <span>条款与规则</span>
              <p>
                1.此优惠仅限PG投注流水有效，每日统计时间为北京时间00:00:00~23:59:59;<br/>
                2.如发现任何团体或个人，以不诚实方式套取红利或任何威胁、滥用公司优惠等行为，本公司保留冻结、取消该团体或个人账户及账户结余的权利。
              </p>
            </div>
          </div>
          <div class="content p" v-show="promo1Show==2">
            <p>投注PG电子游戏，不计输赢，当天PG有效投注达到1000+以上，次日16点后可自助领取PG流水彩金，最高8888元。</p>
            <table>
              <thead>
                <tr>
                  <th>有效投注</th>
                  <th>得意彩金</th>
                  <th>提款要求</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1000+</td>
                  <td>1元</td>
                  <td rowspan="12">3倍</td>
                </tr>
                <tr><td>6000+</td><td>5元</td></tr>
                <tr><td>3万+</td><td>18元</td></tr>
                <tr><td>6万+</td><td>38元</td></tr>
                <tr><td>10万+</td><td>58元</td></tr>
                <tr><td>30万+</td><td>88元</td></tr>
                <tr><td>60万+</td><td>188元</td></tr>
                <tr><td>100万+</td><td>288元</td></tr>
                <tr><td>300万+</td><td>388元</td></tr>
                <tr><td>500万+</td><td>888元</td></tr>
                <tr><td>1000万+</td><td>3888元</td></tr>
                <tr><td>3000万+</td><td>8888元</td></tr>
              </tbody>
            </table>
            <div class="rule">
              <span>条款与规则</span>
              <p>
                1. 此优惠仅限PG投注流水有效，每日统计时间为北京时间00:00:00~23:59:59；<br/>
                2. 如发现任何团体或个人，以不诚实方式套取红利或任何威胁、滥用公司优惠等行为，本公司保留冻结、取消该团体或个人账户及账户结余的权利。
              </p>
            </div>
          </div>
          <div class="content p" v-show="promo1Show==0">
            <p>新老会员凡是于【电子/棋牌/捕鱼】一时失手，失利金额1元起，即可享有救援金！每天救援一次，单笔救援高达10.0%，救援金额无上限。</p>
            <table>
              <thead>
                <tr>
                  <th>注单最高失利金额</th>
                  <th>可获救援金</th>
                  <th>流水倍数</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>100元+</td>
                  <td>亏损金额的1%</td>
                  <td rowspan="8">3倍</td>
                </tr>
                <tr><td>2000元+</td><td>亏损金额的2%</td></tr>
                <tr><td>10000元+</td><td>亏损金额的3%</td></tr>
                <tr><td>50000元+</td><td>亏损金额的4%</td></tr>
                <tr><td>100000元+</td><td>亏损金额的5%</td></tr>
                <tr><td>200000元+</td><td>亏损金额的6%</td></tr>
                <tr><td>500000元+</td><td>亏损金额的8%</td></tr>
                <tr><td>1000000元+</td><td>亏损金额的10%</td></tr>
              </tbody>
            </table>
            <p>例如：当日在电子游艺 捕鱼机中亏损2000元，红利获得优惠10 返水10元（2000-10-10=1980元），即可申请获得的彩金为1980*1%=19.8元。</p>
            <div class="rule">
              <span>条款于规则</span>
              <p>
                1、历史充值3次+且金额100+的会员<br/>
                2、电子救援金3倍流水要求；<br/>
                3、电子游艺中的百家乐、龙虎斗、红黑大战、奔驰宝马类游戏注单，不在活动赠送范围之内；<br/>
                4、若发现任何违规或套利行为，将保留取消参与的权利。
              </p>
            </div>
          </div>
        </div>
    </div>
    <div class="menu-list" :class="{on:menuShow}" @click.stop>
      <div class="top">
        <p @click="menuShow=false;"><img src="@/img/menu.png"></p>
        <p><img src="@/img/logo.png"></p>
      </div>
      <div class="info">
        <div style="width: 0.48rem; height: 0.48rem;border-radius: 0.5rem;overflow: hidden;border: 1px solid #fff;">
          <img src="@/img/uico.jpg" />
   
        </div>
        <div>
          <dl>
           <dd>{{userData.account}}<span class="vip" v-if="userData.level">Lv.{{userData.level.split('VIP')[0]}}</span></dd>
           <dd><span class="copy"></span></dd>
          </dl>
          <dl>
           <dd class="balance">￥{{userData.amount}}</dd>
           <dd><span class="refresh"></span></dd>
          </dl>
        </div>
      </div>
      <div class="dw">
        <ul>
          <li @click="showDeposit();">充值</li>
          <li @click="maskShow = true; walletShow = true; walletIndex=1; queryWithdrawAsync();betReportRequestAsync();transferReceiveAllAsync();">提款</li>
        </ul>
      </div>
      <div class="settings">
        <ul>
          <li @click="dataShow=true;qeuryVipDetailsAsync();queryAccountReportIntlAsync();">个人中心</li>
          <li @click="recordShow=true;queryRecordDetailsAsync(1);">交易明细</li>
          <li @click="currentIndexSettings=0;infoShow=true">用户资料</li>
          <li @click="handleClick(1,'/promotion')">优惠中心</li>
          <li @click="taksShow=true;currentIndexTask=0;queryTaskCategoryUI_INRAsync();">任务中心</li>
          <li @click="noticeShow=true;currentIndexNotice=0;queryNoticePageAsync(1);">公告中心</li>
        </ul>
        <ul>
          <li @click="commendShow=true;currentIndexCommend=0;qeuryWeekCommisionAsync();">推荐</li>
          <li @click="affShow=true;agentLoginAsync();">合营</li>
        </ul>
      </div>
      <div class="app">
        <p>APP下载</p>
        <ul>
            <li><svg data-v-a945d1c2="" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 135 40"><g data-v-a945d1c2=""><rect data-v-a945d1c2="" width="135" height="40" rx="8" fill="#fff" fill-opacity=".1"></rect><path data-v-a945d1c2="" d="M106.934 30h1.866V17.498h-1.866V30Zm16.807-7.998-2.139 5.42h-.064l-2.22-5.42h-2.01l3.33 7.575-1.899 4.214h1.946l5.131-11.789h-2.075Zm-10.583 6.578c-.61 0-1.463-.306-1.463-1.062 0-.965 1.062-1.334 1.978-1.334.82 0 1.207.176 1.705.418a2.262 2.262 0 0 1-2.22 1.978Zm.226-6.851c-1.351 0-2.75.595-3.329 1.914l1.656.691c.354-.691 1.013-.916 1.705-.916.965 0 1.946.578 1.962 1.608v.128c-.338-.193-1.062-.482-1.946-.482-1.786 0-3.603.98-3.603 2.814 0 1.673 1.464 2.75 3.104 2.75 1.254 0 1.947-.562 2.38-1.222h.065v.966h1.802v-4.794c0-2.22-1.658-3.457-3.796-3.457Zm-11.532 1.795h-2.654v-4.285h2.654c1.395 0 2.187 1.154 2.187 2.142 0 .969-.792 2.143-2.187 2.143Zm-.048-6.026h-4.472V30h1.866v-4.736h2.606c2.068 0 4.101-1.497 4.101-3.883 0-2.385-2.033-3.883-4.101-3.883ZM77.422 28.582c-1.289 0-2.368-1.08-2.368-2.56 0-1.5 1.08-2.595 2.368-2.595 1.273 0 2.272 1.095 2.272 2.594 0 1.482-.999 2.561-2.272 2.561Zm2.143-5.88H79.5c-.418-.5-1.224-.95-2.239-.95-2.127 0-4.076 1.869-4.076 4.27 0 2.383 1.95 4.236 4.076 4.236 1.015 0 1.82-.451 2.24-.967h.064v.612c0 1.628-.87 2.497-2.272 2.497-1.143 0-1.852-.821-2.142-1.514l-1.627.677c.467 1.127 1.707 2.513 3.77 2.513 2.19 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693ZM82.627 30h1.868V17.498h-1.868V30Zm4.623-4.124c-.048-1.644 1.273-2.481 2.223-2.481.742 0 1.37.37 1.58.902l-3.803 1.579Zm5.8-1.418c-.355-.95-1.434-2.706-3.641-2.706-2.192 0-4.012 1.723-4.012 4.253 0 2.384 1.805 4.253 4.22 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.967c-.483.71-1.143 1.176-2.094 1.176-.95 0-1.627-.435-2.062-1.289l5.687-2.352-.194-.483Zm-45.308-1.401v1.804h4.317c-.129 1.015-.467 1.756-.983 2.271-.628.628-1.611 1.321-3.334 1.321-2.659 0-4.737-2.142-4.737-4.8 0-2.659 2.078-4.801 4.736-4.801 1.434 0 2.481.564 3.255 1.289l1.273-1.273c-1.08-1.031-2.514-1.82-4.527-1.82-3.642 0-6.703 2.964-6.703 6.605 0 3.64 3.061 6.605 6.703 6.605 1.965 0 3.447-.645 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.221 0-.418-.033-.805-.097-1.127h-6.073Zm11.078 5.525c-1.289 0-2.4-1.063-2.4-2.577 0-1.53 1.111-2.578 2.4-2.578s2.4 1.047 2.4 2.578c0 1.514-1.111 2.577-2.4 2.577Zm0-6.83c-2.352 0-4.27 1.788-4.27 4.253 0 2.448 1.918 4.253 4.27 4.253 2.352 0 4.27-1.805 4.27-4.253 0-2.465-1.918-4.253-4.27-4.253Zm9.313 6.83c-1.288 0-2.4-1.063-2.4-2.577 0-1.53 1.112-2.578 2.4-2.578 1.29 0 2.4 1.047 2.4 2.578 0 1.514-1.11 2.577-2.4 2.577Zm0-6.83c-2.352 0-4.268 1.788-4.268 4.253 0 2.448 1.916 4.253 4.268 4.253 2.353 0 4.27-1.805 4.27-4.253 0-2.465-1.917-4.253-4.27-4.253Zm-23.656-8.518c-.897 0-1.668-.315-2.29-.937-.622-.622-.937-1.4-.937-2.306 0-.906.315-1.684.937-2.307.622-.622 1.393-.937 2.29-.937.456 0 .883.079 1.29.243.407.164.74.392 1.003.69l.062.071-.699.7-.07-.086a1.733 1.733 0 0 0-.676-.501 2.282 2.282 0 0 0-.91-.177 2.16 2.16 0 0 0-1.593.65v.001c-.428.445-.643.986-.643 1.653s.215 1.208.643 1.653a2.16 2.16 0 0 0 1.593.651c.578 0 1.056-.161 1.432-.48.35-.298.56-.7.634-1.212h-2.166v-.922h3.102l.014.085c.025.162.043.318.043.468 0 .86-.262 1.563-.777 2.08-.58.615-1.345.92-2.282.92Zm26.941 0c-.898 0-1.66-.315-2.274-.937-.615-.615-.92-1.394-.92-2.306 0-.913.305-1.692.92-2.307.614-.622 1.376-.937 2.274-.937.896 0 1.659.315 2.273.946.614.615.92 1.393.92 2.298 0 .912-.305 1.691-.92 2.306-.614.622-1.384.937-2.273.937ZM48.424 13.1V6.881h3.714v.94h-2.74V9.53h2.471v.922h-2.472v1.709h2.74v.939h-3.713Zm5.987 0V7.822H52.73v-.94h4.336v.94h-1.682V13.1h-.973Zm5.426 0V6.881h.973V13.1h-.973Zm3.423 0V7.822h-1.68v-.94h4.335v.94h-1.681V13.1h-.973Zm12.215 0V6.881h1.097l2.794 4.473-.024-.85V6.881h.973V13.1h-.963l-2.928-4.698.024.848v3.85h-.973Zm-4.057-.805c.632 0 1.147-.215 1.567-.65l.001-.001c.427-.427.635-.976.635-1.653 0-.676-.208-1.227-.634-1.653l-.001-.001c-.42-.435-.936-.65-1.568-.65s-1.148.214-1.576.65c-.418.436-.627.978-.627 1.654 0 .677.208 1.217.627 1.654.428.435.944.65 1.576.65Z" fill="#fff"></path><path data-v-a945d1c2="" d="m20.713 19.423-10.647 11.3.002.007a2.875 2.875 0 0 0 4.236 1.734l.034-.02 11.984-6.915-5.61-6.106Z" fill="#EA4335"></path><path data-v-a945d1c2="" d="m31.486 17.5-.01-.008-5.174-2.999-5.83 5.187 5.85 5.848 5.146-2.97a2.877 2.877 0 0 0 .018-5.059Z" fill="#FBBC04"></path><path data-v-a945d1c2="" d="M10.066 9.277a2.818 2.818 0 0 0-.097.74v19.967c0 .256.033.504.098.74L21.08 19.713 10.066 9.277Z" fill="#4285F4"></path><path data-v-a945d1c2="" d="m20.792 20 5.51-5.509-11.97-6.94a2.882 2.882 0 0 0-4.265 1.722v.004L20.791 20Z" fill="#34A853"></path></g></svg></li>
            <li><svg data-v-a945d1c2="" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 120 40"><g data-v-a945d1c2=""><rect data-v-a945d1c2="" data-follow-fill="#fff" width="120" height="40" rx="8" fill="#fff" fill-opacity=".1"></rect><path data-v-a945d1c2="" data-follow-fill="#fff" d="M81.527 19.201v2.291H80.09v1.503h1.436V28.1c0 1.743.788 2.44 2.772 2.44.349 0 .68-.041.971-.091v-1.486c-.249.025-.406.042-.68.042-.889 0-1.279-.415-1.279-1.362v-4.648h1.96v-1.503h-1.96v-2.29h-1.784Zm8.797 11.464c2.64 0 4.258-1.768 4.258-4.698 0-2.914-1.626-4.69-4.258-4.69-2.64 0-4.266 1.776-4.266 4.69 0 2.93 1.618 4.698 4.266 4.698Zm0-1.586c-1.552 0-2.424-1.137-2.424-3.113 0-1.959.872-3.104 2.424-3.104 1.544 0 2.424 1.146 2.424 3.105 0 1.967-.88 3.112-2.424 3.112Zm5.643 1.411h1.785v-5.337c0-1.27.955-2.125 2.308-2.125.315 0 .846.058.996.108v-1.76c-.191-.05-.532-.075-.797-.075-1.179 0-2.183.648-2.44 1.536h-.133v-1.386h-1.719v9.04Zm9.52-7.694c1.32 0 2.183.921 2.225 2.34h-4.566c.1-1.41 1.021-2.34 2.341-2.34Zm2.216 5.254c-.332.706-1.07 1.096-2.15 1.096-1.427 0-2.349-1.005-2.407-2.59v-.1h6.384v-.622c0-2.84-1.52-4.558-4.035-4.558-2.548 0-4.167 1.835-4.167 4.724 0 2.888 1.586 4.665 4.176 4.665 2.067 0 3.511-.996 3.918-2.615h-1.719Zm-37.88-.898c.138 2.22 1.988 3.64 4.74 3.64 2.943 0 4.784-1.489 4.784-3.863 0-1.867-1.05-2.9-3.596-3.493l-1.368-.336c-1.617-.379-2.271-.886-2.271-1.772 0-1.119 1.015-1.85 2.538-1.85 1.445 0 2.443.714 2.624 1.858h1.875c-.112-2.09-1.953-3.562-4.474-3.562-2.71 0-4.516 1.472-4.516 3.683 0 1.824 1.023 2.908 3.269 3.433l1.6.387c1.643.387 2.366.955 2.366 1.901 0 1.101-1.136 1.901-2.684 1.901-1.66 0-2.813-.748-2.977-1.927h-1.91Zm-18.487-5.851c-1.229 0-2.291.615-2.84 1.644h-.132v-1.494h-1.718v12.044h1.785v-4.374h.14c.474.954 1.495 1.519 2.781 1.519 2.283 0 3.736-1.801 3.736-4.674 0-2.872-1.453-4.665-3.752-4.665Zm-.507 7.737c-1.494 0-2.432-1.179-2.432-3.063 0-1.893.938-3.072 2.44-3.072 1.511 0 2.416 1.154 2.416 3.064 0 1.917-.905 3.07-2.424 3.07Zm10.504-7.737c-1.229 0-2.291.615-2.84 1.644h-.132v-1.494h-1.718v12.044h1.784v-4.374h.141c.474.954 1.495 1.519 2.781 1.519 2.283 0 3.736-1.801 3.736-4.674 0-2.872-1.453-4.665-3.752-4.665Zm-.507 7.737c-1.494 0-2.432-1.179-2.432-3.063 0-1.893.938-3.072 2.44-3.072 1.511 0 2.416 1.154 2.416 3.064 0 1.917-.905 3.07-2.424 3.07ZM43.444 30.49h2.047L41.01 18.076h-2.073L34.453 30.49h1.979l1.144-3.295h4.732l1.136 3.295Zm-3.57-10.16h.146l1.798 5.248h-3.751l1.806-5.248ZM35.652 8.71v5.99h2.163c1.784 0 2.818-1.1 2.818-3.013 0-1.885-1.042-2.976-2.818-2.976h-2.163Zm.93.847h1.129c1.24 0 1.976.789 1.976 2.142 0 1.374-.723 2.154-1.976 2.154h-1.129V9.557Zm7.216 5.23c1.32 0 2.13-.884 2.13-2.35 0-1.456-.814-2.344-2.13-2.344-1.32 0-2.133.888-2.133 2.345 0 1.465.809 2.349 2.133 2.349Zm0-.793c-.776 0-1.212-.569-1.212-1.556 0-.98.436-1.553 1.212-1.553.772 0 1.212.573 1.212 1.553 0 .983-.44 1.556-1.212 1.556Zm9.022-3.814h-.893l-.805 3.449h-.07l-.93-3.45h-.855l-.93 3.45h-.067l-.809-3.45h-.905l1.245 4.52h.918l.93-3.328h.07l.934 3.329h.925l1.241-4.52Zm1.027 4.52h.892v-2.644c0-.706.42-1.146 1.08-1.146.66 0 .975.361.975 1.088V14.7h.892v-2.926c0-1.075-.556-1.681-1.565-1.681-.68 0-1.129.303-1.349.805h-.066v-.718h-.86v4.52Zm5.244 0h.893V8.416h-.893V14.7Zm4.249.087c1.32 0 2.129-.884 2.129-2.35 0-1.456-.814-2.344-2.13-2.344-1.32 0-2.133.888-2.133 2.345 0 1.465.81 2.349 2.134 2.349Zm0-.793c-.777 0-1.212-.569-1.212-1.556 0-.98.435-1.553 1.212-1.553.772 0 1.212.573 1.212 1.553 0 .983-.44 1.556-1.212 1.556Zm4.787.029c-.485 0-.838-.236-.838-.643 0-.399.282-.61.905-.652l1.104-.07v.377c0 .56-.498.988-1.17.988Zm-.228.751c.594 0 1.088-.257 1.357-.71h.071v.636h.86v-3.088c0-.955-.64-1.52-1.773-1.52-1.025 0-1.756.499-1.847 1.275h.863c.1-.32.444-.502.942-.502.61 0 .926.27.926.747v.39l-1.225.07c-1.074.067-1.68.536-1.68 1.35 0 .825.635 1.352 1.506 1.352Zm5.315 0c.623 0 1.15-.294 1.42-.788h.07v.714h.855V8.416h-.892v2.482H74.6c-.244-.498-.767-.793-1.386-.793-1.141 0-1.876.905-1.876 2.333 0 1.432.727 2.336 1.876 2.336Zm.253-3.868c.748 0 1.216.594 1.216 1.536 0 .946-.464 1.531-1.216 1.531-.755 0-1.207-.577-1.207-1.535 0-.95.456-1.532 1.207-1.532Zm7.879 3.881c1.32 0 2.129-.884 2.129-2.35 0-1.456-.814-2.344-2.13-2.344-1.32 0-2.133.888-2.133 2.345 0 1.465.81 2.349 2.134 2.349Zm0-.793c-.776 0-1.212-.569-1.212-1.556 0-.98.436-1.553 1.212-1.553.772 0 1.212.573 1.212 1.553 0 .983-.44 1.556-1.212 1.556Zm3.31.706h.892v-2.644c0-.706.42-1.146 1.08-1.146.66 0 .975.361.975 1.088V14.7h.892v-2.926c0-1.075-.556-1.681-1.565-1.681-.68 0-1.129.303-1.349.805h-.066v-.718h-.859v4.52Zm7.949-5.645v1.146h-.718v.75h.718v2.553c0 .872.394 1.22 1.386 1.22.174 0 .34-.02.486-.045v-.743c-.125.012-.204.02-.34.02-.445 0-.64-.207-.64-.68v-2.324h.98V10.2h-.98V9.055h-.892Zm3.069 5.645h.893v-2.64c0-.685.407-1.145 1.137-1.145.63 0 .967.365.967 1.087V14.7h.892v-2.918c0-1.075-.593-1.685-1.556-1.685-.68 0-1.158.303-1.378.81h-.07V8.415h-.885V14.7Zm7.108-3.848c.66 0 1.092.461 1.113 1.17h-2.283c.05-.705.511-1.17 1.17-1.17Zm1.109 2.627c-.166.353-.536.548-1.075.548-.714 0-1.175-.502-1.204-1.295v-.05h3.192v-.31c0-1.42-.76-2.28-2.017-2.28-1.275 0-2.084.918-2.084 2.362 0 1.445.793 2.333 2.088 2.333 1.033 0 1.755-.498 1.959-1.308h-.859ZM24.77 20.301a4.989 4.989 0 0 1 2.357-4.152 5.128 5.128 0 0 0-3.992-2.158c-1.679-.176-3.307 1.005-4.163 1.005-.872 0-2.19-.987-3.608-.958a5.359 5.359 0 0 0-4.473 2.728c-1.934 3.348-.491 8.27 1.361 10.976.927 1.325 2.01 2.806 3.428 2.753 1.387-.057 1.905-.884 3.58-.884 1.658 0 2.144.884 3.59.85 1.489-.023 2.426-1.33 3.32-2.668a10.96 10.96 0 0 0 1.52-3.093 4.824 4.824 0 0 1-2.92-4.399Zm-2.732-8.09a4.873 4.873 0 0 0 1.115-3.49 4.958 4.958 0 0 0-3.208 1.66 4.679 4.679 0 0 0-1.143 3.36 4.147 4.147 0 0 0 3.236-1.53Z" fill="#fff"></path></g></svg></li>
        </ul>
      </div>
      <div class="logout" @click="menuShow=false;loginout();">
        退出账号
      </div>
      <div class="tools">
        <ul>
          <li>
            客服
          </li>
          <li>
            语言
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
        <div>
          <p>媒体</p>
          <ul>
            <li><svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 40 40"><!--?lit$019850578$--><g><rect data-follow-fill="#fff" opacity=".4" width="40" height="40" rx="8" fill="#fff" fill-opacity=".3"></rect><path data-follow-fill="#fff" d="M11.128 19.291s8.138-3.427 10.96-4.634c1.082-.483 4.751-2.028 4.751-2.028s1.694-.676 1.553.966c-.047.675-.424 3.04-.8 5.6-.564 3.62-1.176 7.579-1.176 7.579s-.094 1.11-.894 1.303c-.8.193-2.117-.676-2.352-.869-.188-.144-3.528-2.317-4.75-3.379-.33-.29-.706-.869.046-1.545a181.762 181.762 0 0 0 4.94-4.827c.564-.58 1.128-1.931-1.224-.29-3.34 2.365-6.632 4.586-6.632 4.586s-.753.483-2.164.048c-1.411-.434-3.058-1.013-3.058-1.013s-1.129-.724.8-1.497Z" fill="#fff"></path></g></svg></li>
            <li><svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 40 40"><!--?lit$019850578$--><g><rect data-follow-fill="#fff" fill-opacity=".3" fill="#fff" rx="8" height="40" width="40" opacity=".4"></rect><path data-follow-fill="#fff" fill="#fff" d="m10 29.26 1.435-5.336a9.867 9.867 0 0 1 2.664-12.67 9.91 9.91 0 0 1 12.94.837 9.87 9.87 0 0 1 1.005 12.907 9.912 9.912 0 0 1-12.655 2.823L10 29.26Zm5.65-3.435.333.198a8.011 8.011 0 0 0 9.689-1.177 7.981 7.981 0 0 0 1.337-9.652 7.996 7.996 0 0 0-3.861-3.41 8.012 8.012 0 0 0-9.432 2.506 7.978 7.978 0 0 0-1.654 4.874 7.887 7.887 0 0 0 1.17 4.14l.209.344-.803 2.978 3.011-.8Z"></path><path data-follow-fill="#fff" fill="#fff" d="M23.74 20.534a1.65 1.65 0 0 0-1.412-.322c-.367.153-.604.728-.842 1.016a.35.35 0 0 1-.452.101 6.398 6.398 0 0 1-3.197-2.735.383.383 0 0 1 .05-.53 2.21 2.21 0 0 0 .566-.942 2.05 2.05 0 0 0-.26-1.128 2.64 2.64 0 0 0-.82-1.236 1.133 1.133 0 0 0-1.214.187 2.494 2.494 0 0 0-.864 1.974c0 .209.027.417.079.62.13.487.332.953.598 1.382.192.329.402.647.627.953a9.624 9.624 0 0 0 2.718 2.515 8.19 8.19 0 0 0 1.695.807 3.75 3.75 0 0 0 1.971.31 2.37 2.37 0 0 0 1.786-1.325c.097-.212.127-.448.084-.677-.101-.468-.729-.745-1.113-.97Z" clip-rule="evenodd" fill-rule="evenodd"></path></g></svg></li>
            <li><svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 40 41"><!--?lit$019850578$--><g><rect data-follow-fill="#fff" y=".606" width="40" height="40" rx="8" fill="#fff" fill-opacity=".1"></rect><path data-follow-fill="#fff" d="M16.671 20.657a3.336 3.336 0 1 1 3.335 3.337 3.336 3.336 0 0 1-3.335-3.337Zm-1.803 0a5.139 5.139 0 1 0 5.138-5.14 5.139 5.139 0 0 0-5.138 5.14Zm9.279-5.343a1.202 1.202 0 0 0 2.05.85 1.201 1.201 0 0 0-.85-2.05 1.201 1.201 0 0 0-1.2 1.2Zm-8.183 13.49c-.976-.044-1.506-.207-1.859-.344a3.11 3.11 0 0 1-1.15-.749 3.088 3.088 0 0 1-.749-1.15c-.137-.352-.3-.883-.344-1.859-.049-1.055-.058-1.372-.058-4.045 0-2.672.01-2.988.058-4.044.044-.976.208-1.506.344-1.86.182-.466.399-.8.748-1.15a3.09 3.09 0 0 1 1.151-.749c.353-.137.883-.3 1.859-.344 1.054-.049 1.371-.059 4.042-.059 2.67 0 2.988.011 4.044.059.975.044 1.505.208 1.858.344a3.1 3.1 0 0 1 1.15.749c.351.35.567.684.75 1.15.137.353.299.884.343 1.86.049 1.056.059 1.372.059 4.044 0 2.673-.01 2.99-.059 4.045-.044.976-.207 1.506-.344 1.859-.182.467-.398.8-.748 1.15a3.11 3.11 0 0 1-1.151.749c-.352.137-.883.3-1.858.344-1.055.049-1.372.059-4.044.059-2.672 0-2.988-.01-4.042-.059ZM15.88 10.71c-1.066.049-1.793.218-2.429.465a4.909 4.909 0 0 0-1.772 1.154 4.89 4.89 0 0 0-1.155 1.773c-.247.637-.416 1.364-.464 2.43-.05 1.067-.061 1.408-.061 4.126 0 2.718.011 3.06.06 4.127.05 1.065.218 1.793.465 2.43a4.892 4.892 0 0 0 1.155 1.772 4.918 4.918 0 0 0 1.772 1.155c.637.247 1.364.416 2.429.465 1.067.048 1.408.06 4.125.06s3.058-.011 4.125-.06c1.066-.049 1.793-.218 2.429-.465a4.92 4.92 0 0 0 1.773-1.155 4.902 4.902 0 0 0 1.154-1.773c.247-.636.417-1.364.464-2.43.049-1.067.06-1.408.06-4.126 0-2.718-.011-3.059-.06-4.126-.048-1.066-.217-1.794-.464-2.43a4.922 4.922 0 0 0-1.154-1.773 4.898 4.898 0 0 0-1.772-1.154c-.637-.247-1.364-.417-2.429-.465-1.067-.048-1.408-.06-4.125-.06-2.718 0-3.059.01-4.126.06Z" fill="#fff"></path></g></svg></li>
            <li><svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 40 41"><!--?lit$019850578$--><g><rect data-follow-fill="#fff" y=".606" width="40" height="40" rx="8" fill="#fff" fill-opacity=".1"></rect><path data-follow-fill="#fff" d="m24.894 21.909.57-3.621h-3.51v-2.354c0-.99.49-1.958 2.057-1.958h1.618v-3.083a19.624 19.624 0 0 0-2.85-.244c-2.889 0-4.775 1.737-4.775 4.878v2.76H14.8v3.622h3.203v8.758h3.95V21.91h2.94Z" fill="#fff"></path></g></svg></li>
            <li><svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 40 41"><!--?lit$019850578$--><g><rect fill-opacity=".3" fill="#fff" rx="8" height="40" width="40" y=".866" opacity=".4"></rect><path fill="#fff" d="M31.126 15.364a2.863 2.863 0 0 0-2.017-2.021c-1.777-.477-8.908-.477-8.908-.477s-7.128 0-8.908.477a2.864 2.864 0 0 0-2.017 2.021C8.8 17.146 8.8 20.866 8.8 20.866s0 3.72.475 5.502a2.864 2.864 0 0 0 2.017 2.022c1.78.476 8.908.476 8.908.476s7.13 0 8.908-.476a2.863 2.863 0 0 0 2.017-2.022c.475-1.782.475-5.502.475-5.502s0-3.72-.475-5.502Z"></path><path fill-opacity=".3" fill="#000" d="m17.923 24.295 5.923-3.429-5.923-3.429v6.858Z"></path></g></svg></li>
          
          </ul>
        </div>
        <div>
          <p>APP下载</p>
          <ul>
            <li @click="openApp(appData.quanzhan_android.apps)">
              <svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 135 40"><!--?lit$019850578$--><g><rect width="135" height="40" rx="8" fill="#fff" fill-opacity=".1"></rect><path d="M106.934 30h1.866V17.498h-1.866V30Zm16.807-7.998-2.139 5.42h-.064l-2.22-5.42h-2.01l3.33 7.575-1.899 4.214h1.946l5.131-11.789h-2.075Zm-10.583 6.578c-.61 0-1.463-.306-1.463-1.062 0-.965 1.062-1.334 1.978-1.334.82 0 1.207.176 1.705.418a2.262 2.262 0 0 1-2.22 1.978Zm.226-6.851c-1.351 0-2.75.595-3.329 1.914l1.656.691c.354-.691 1.013-.916 1.705-.916.965 0 1.946.578 1.962 1.608v.128c-.338-.193-1.062-.482-1.946-.482-1.786 0-3.603.98-3.603 2.814 0 1.673 1.464 2.75 3.104 2.75 1.254 0 1.947-.562 2.38-1.222h.065v.966h1.802v-4.794c0-2.22-1.658-3.457-3.796-3.457Zm-11.532 1.795h-2.654v-4.285h2.654c1.395 0 2.187 1.154 2.187 2.142 0 .969-.792 2.143-2.187 2.143Zm-.048-6.026h-4.472V30h1.866v-4.736h2.606c2.068 0 4.101-1.497 4.101-3.883 0-2.385-2.033-3.883-4.101-3.883ZM77.422 28.582c-1.289 0-2.368-1.08-2.368-2.56 0-1.5 1.08-2.595 2.368-2.595 1.273 0 2.272 1.095 2.272 2.594 0 1.482-.999 2.561-2.272 2.561Zm2.143-5.88H79.5c-.418-.5-1.224-.95-2.239-.95-2.127 0-4.076 1.869-4.076 4.27 0 2.383 1.95 4.236 4.076 4.236 1.015 0 1.82-.451 2.24-.967h.064v.612c0 1.628-.87 2.497-2.272 2.497-1.143 0-1.852-.821-2.142-1.514l-1.627.677c.467 1.127 1.707 2.513 3.77 2.513 2.19 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693ZM82.627 30h1.868V17.498h-1.868V30Zm4.623-4.124c-.048-1.644 1.273-2.481 2.223-2.481.742 0 1.37.37 1.58.902l-3.803 1.579Zm5.8-1.418c-.355-.95-1.434-2.706-3.641-2.706-2.192 0-4.012 1.723-4.012 4.253 0 2.384 1.805 4.253 4.22 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.967c-.483.71-1.143 1.176-2.094 1.176-.95 0-1.627-.435-2.062-1.289l5.687-2.352-.194-.483Zm-45.308-1.401v1.804h4.317c-.129 1.015-.467 1.756-.983 2.271-.628.628-1.611 1.321-3.334 1.321-2.659 0-4.737-2.142-4.737-4.8 0-2.659 2.078-4.801 4.736-4.801 1.434 0 2.481.564 3.255 1.289l1.273-1.273c-1.08-1.031-2.514-1.82-4.527-1.82-3.642 0-6.703 2.964-6.703 6.605 0 3.64 3.061 6.605 6.703 6.605 1.965 0 3.447-.645 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.221 0-.418-.033-.805-.097-1.127h-6.073Zm11.078 5.525c-1.289 0-2.4-1.063-2.4-2.577 0-1.53 1.111-2.578 2.4-2.578s2.4 1.047 2.4 2.578c0 1.514-1.111 2.577-2.4 2.577Zm0-6.83c-2.352 0-4.27 1.788-4.27 4.253 0 2.448 1.918 4.253 4.27 4.253 2.352 0 4.27-1.805 4.27-4.253 0-2.465-1.918-4.253-4.27-4.253Zm9.313 6.83c-1.288 0-2.4-1.063-2.4-2.577 0-1.53 1.112-2.578 2.4-2.578 1.29 0 2.4 1.047 2.4 2.578 0 1.514-1.11 2.577-2.4 2.577Zm0-6.83c-2.352 0-4.268 1.788-4.268 4.253 0 2.448 1.916 4.253 4.268 4.253 2.353 0 4.27-1.805 4.27-4.253 0-2.465-1.917-4.253-4.27-4.253Zm-23.656-8.518c-.897 0-1.668-.315-2.29-.937-.622-.622-.937-1.4-.937-2.306 0-.906.315-1.684.937-2.307.622-.622 1.393-.937 2.29-.937.456 0 .883.079 1.29.243.407.164.74.392 1.003.69l.062.071-.699.7-.07-.086a1.733 1.733 0 0 0-.676-.501 2.282 2.282 0 0 0-.91-.177 2.16 2.16 0 0 0-1.593.65v.001c-.428.445-.643.986-.643 1.653s.215 1.208.643 1.653a2.16 2.16 0 0 0 1.593.651c.578 0 1.056-.161 1.432-.48.35-.298.56-.7.634-1.212h-2.166v-.922h3.102l.014.085c.025.162.043.318.043.468 0 .86-.262 1.563-.777 2.08-.58.615-1.345.92-2.282.92Zm26.941 0c-.898 0-1.66-.315-2.274-.937-.615-.615-.92-1.394-.92-2.306 0-.913.305-1.692.92-2.307.614-.622 1.376-.937 2.274-.937.896 0 1.659.315 2.273.946.614.615.92 1.393.92 2.298 0 .912-.305 1.691-.92 2.306-.614.622-1.384.937-2.273.937ZM48.424 13.1V6.881h3.714v.94h-2.74V9.53h2.471v.922h-2.472v1.709h2.74v.939h-3.713Zm5.987 0V7.822H52.73v-.94h4.336v.94h-1.682V13.1h-.973Zm5.426 0V6.881h.973V13.1h-.973Zm3.423 0V7.822h-1.68v-.94h4.335v.94h-1.681V13.1h-.973Zm12.215 0V6.881h1.097l2.794 4.473-.024-.85V6.881h.973V13.1h-.963l-2.928-4.698.024.848v3.85h-.973Zm-4.057-.805c.632 0 1.147-.215 1.567-.65l.001-.001c.427-.427.635-.976.635-1.653 0-.676-.208-1.227-.634-1.653l-.001-.001c-.42-.435-.936-.65-1.568-.65s-1.148.214-1.576.65c-.418.436-.627.978-.627 1.654 0 .677.208 1.217.627 1.654.428.435.944.65 1.576.65Z" fill="#fff"></path><path d="m20.713 19.423-10.647 11.3.002.007a2.875 2.875 0 0 0 4.236 1.734l.034-.02 11.984-6.915-5.61-6.106Z" fill="#EA4335"></path><path d="m31.486 17.5-.01-.008-5.174-2.999-5.83 5.187 5.85 5.848 5.146-2.97a2.877 2.877 0 0 0 .018-5.059Z" fill="#FBBC04"></path><path d="M10.066 9.277a2.818 2.818 0 0 0-.097.74v19.967c0 .256.033.504.098.74L21.08 19.713 10.066 9.277Z" fill="#4285F4"></path><path d="m20.792 20 5.51-5.509-11.97-6.94a2.882 2.882 0 0 0-4.265 1.722v.004L20.791 20Z" fill="#34A853"></path></g></svg>
            </li>
            <li @click="openApp(appData.quanzhan_ios.apps)">
              <svg preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 120 40"><!--?lit$019850578$--><g><rect data-follow-fill="#fff" width="120" height="40" rx="8" fill="#fff" fill-opacity=".1"></rect><path data-follow-fill="#fff" d="M81.527 19.201v2.291H80.09v1.503h1.436V28.1c0 1.743.788 2.44 2.772 2.44.349 0 .68-.041.971-.091v-1.486c-.249.025-.406.042-.68.042-.889 0-1.279-.415-1.279-1.362v-4.648h1.96v-1.503h-1.96v-2.29h-1.784Zm8.797 11.464c2.64 0 4.258-1.768 4.258-4.698 0-2.914-1.626-4.69-4.258-4.69-2.64 0-4.266 1.776-4.266 4.69 0 2.93 1.618 4.698 4.266 4.698Zm0-1.586c-1.552 0-2.424-1.137-2.424-3.113 0-1.959.872-3.104 2.424-3.104 1.544 0 2.424 1.146 2.424 3.105 0 1.967-.88 3.112-2.424 3.112Zm5.643 1.411h1.785v-5.337c0-1.27.955-2.125 2.308-2.125.315 0 .846.058.996.108v-1.76c-.191-.05-.532-.075-.797-.075-1.179 0-2.183.648-2.44 1.536h-.133v-1.386h-1.719v9.04Zm9.52-7.694c1.32 0 2.183.921 2.225 2.34h-4.566c.1-1.41 1.021-2.34 2.341-2.34Zm2.216 5.254c-.332.706-1.07 1.096-2.15 1.096-1.427 0-2.349-1.005-2.407-2.59v-.1h6.384v-.622c0-2.84-1.52-4.558-4.035-4.558-2.548 0-4.167 1.835-4.167 4.724 0 2.888 1.586 4.665 4.176 4.665 2.067 0 3.511-.996 3.918-2.615h-1.719Zm-37.88-.898c.138 2.22 1.988 3.64 4.74 3.64 2.943 0 4.784-1.489 4.784-3.863 0-1.867-1.05-2.9-3.596-3.493l-1.368-.336c-1.617-.379-2.271-.886-2.271-1.772 0-1.119 1.015-1.85 2.538-1.85 1.445 0 2.443.714 2.624 1.858h1.875c-.112-2.09-1.953-3.562-4.474-3.562-2.71 0-4.516 1.472-4.516 3.683 0 1.824 1.023 2.908 3.269 3.433l1.6.387c1.643.387 2.366.955 2.366 1.901 0 1.101-1.136 1.901-2.684 1.901-1.66 0-2.813-.748-2.977-1.927h-1.91Zm-18.487-5.851c-1.229 0-2.291.615-2.84 1.644h-.132v-1.494h-1.718v12.044h1.785v-4.374h.14c.474.954 1.495 1.519 2.781 1.519 2.283 0 3.736-1.801 3.736-4.674 0-2.872-1.453-4.665-3.752-4.665Zm-.507 7.737c-1.494 0-2.432-1.179-2.432-3.063 0-1.893.938-3.072 2.44-3.072 1.511 0 2.416 1.154 2.416 3.064 0 1.917-.905 3.07-2.424 3.07Zm10.504-7.737c-1.229 0-2.291.615-2.84 1.644h-.132v-1.494h-1.718v12.044h1.784v-4.374h.141c.474.954 1.495 1.519 2.781 1.519 2.283 0 3.736-1.801 3.736-4.674 0-2.872-1.453-4.665-3.752-4.665Zm-.507 7.737c-1.494 0-2.432-1.179-2.432-3.063 0-1.893.938-3.072 2.44-3.072 1.511 0 2.416 1.154 2.416 3.064 0 1.917-.905 3.07-2.424 3.07ZM43.444 30.49h2.047L41.01 18.076h-2.073L34.453 30.49h1.979l1.144-3.295h4.732l1.136 3.295Zm-3.57-10.16h.146l1.798 5.248h-3.751l1.806-5.248ZM35.652 8.71v5.99h2.163c1.784 0 2.818-1.1 2.818-3.013 0-1.885-1.042-2.976-2.818-2.976h-2.163Zm.93.847h1.129c1.24 0 1.976.789 1.976 2.142 0 1.374-.723 2.154-1.976 2.154h-1.129V9.557Zm7.216 5.23c1.32 0 2.13-.884 2.13-2.35 0-1.456-.814-2.344-2.13-2.344-1.32 0-2.133.888-2.133 2.345 0 1.465.809 2.349 2.133 2.349Zm0-.793c-.776 0-1.212-.569-1.212-1.556 0-.98.436-1.553 1.212-1.553.772 0 1.212.573 1.212 1.553 0 .983-.44 1.556-1.212 1.556Zm9.022-3.814h-.893l-.805 3.449h-.07l-.93-3.45h-.855l-.93 3.45h-.067l-.809-3.45h-.905l1.245 4.52h.918l.93-3.328h.07l.934 3.329h.925l1.241-4.52Zm1.027 4.52h.892v-2.644c0-.706.42-1.146 1.08-1.146.66 0 .975.361.975 1.088V14.7h.892v-2.926c0-1.075-.556-1.681-1.565-1.681-.68 0-1.129.303-1.349.805h-.066v-.718h-.86v4.52Zm5.244 0h.893V8.416h-.893V14.7Zm4.249.087c1.32 0 2.129-.884 2.129-2.35 0-1.456-.814-2.344-2.13-2.344-1.32 0-2.133.888-2.133 2.345 0 1.465.81 2.349 2.134 2.349Zm0-.793c-.777 0-1.212-.569-1.212-1.556 0-.98.435-1.553 1.212-1.553.772 0 1.212.573 1.212 1.553 0 .983-.44 1.556-1.212 1.556Zm4.787.029c-.485 0-.838-.236-.838-.643 0-.399.282-.61.905-.652l1.104-.07v.377c0 .56-.498.988-1.17.988Zm-.228.751c.594 0 1.088-.257 1.357-.71h.071v.636h.86v-3.088c0-.955-.64-1.52-1.773-1.52-1.025 0-1.756.499-1.847 1.275h.863c.1-.32.444-.502.942-.502.61 0 .926.27.926.747v.39l-1.225.07c-1.074.067-1.68.536-1.68 1.35 0 .825.635 1.352 1.506 1.352Zm5.315 0c.623 0 1.15-.294 1.42-.788h.07v.714h.855V8.416h-.892v2.482H74.6c-.244-.498-.767-.793-1.386-.793-1.141 0-1.876.905-1.876 2.333 0 1.432.727 2.336 1.876 2.336Zm.253-3.868c.748 0 1.216.594 1.216 1.536 0 .946-.464 1.531-1.216 1.531-.755 0-1.207-.577-1.207-1.535 0-.95.456-1.532 1.207-1.532Zm7.879 3.881c1.32 0 2.129-.884 2.129-2.35 0-1.456-.814-2.344-2.13-2.344-1.32 0-2.133.888-2.133 2.345 0 1.465.81 2.349 2.134 2.349Zm0-.793c-.776 0-1.212-.569-1.212-1.556 0-.98.436-1.553 1.212-1.553.772 0 1.212.573 1.212 1.553 0 .983-.44 1.556-1.212 1.556Zm3.31.706h.892v-2.644c0-.706.42-1.146 1.08-1.146.66 0 .975.361.975 1.088V14.7h.892v-2.926c0-1.075-.556-1.681-1.565-1.681-.68 0-1.129.303-1.349.805h-.066v-.718h-.859v4.52Zm7.949-5.645v1.146h-.718v.75h.718v2.553c0 .872.394 1.22 1.386 1.22.174 0 .34-.02.486-.045v-.743c-.125.012-.204.02-.34.02-.445 0-.64-.207-.64-.68v-2.324h.98V10.2h-.98V9.055h-.892Zm3.069 5.645h.893v-2.64c0-.685.407-1.145 1.137-1.145.63 0 .967.365.967 1.087V14.7h.892v-2.918c0-1.075-.593-1.685-1.556-1.685-.68 0-1.158.303-1.378.81h-.07V8.415h-.885V14.7Zm7.108-3.848c.66 0 1.092.461 1.113 1.17h-2.283c.05-.705.511-1.17 1.17-1.17Zm1.109 2.627c-.166.353-.536.548-1.075.548-.714 0-1.175-.502-1.204-1.295v-.05h3.192v-.31c0-1.42-.76-2.28-2.017-2.28-1.275 0-2.084.918-2.084 2.362 0 1.445.793 2.333 2.088 2.333 1.033 0 1.755-.498 1.959-1.308h-.859ZM24.77 20.301a4.989 4.989 0 0 1 2.357-4.152 5.128 5.128 0 0 0-3.992-2.158c-1.679-.176-3.307 1.005-4.163 1.005-.872 0-2.19-.987-3.608-.958a5.359 5.359 0 0 0-4.473 2.728c-1.934 3.348-.491 8.27 1.361 10.976.927 1.325 2.01 2.806 3.428 2.753 1.387-.057 1.905-.884 3.58-.884 1.658 0 2.144.884 3.59.85 1.489-.023 2.426-1.33 3.32-2.668a10.96 10.96 0 0 0 1.52-3.093 4.824 4.824 0 0 1-2.92-4.399Zm-2.732-8.09a4.873 4.873 0 0 0 1.115-3.49 4.958 4.958 0 0 0-3.208 1.66 4.679 4.679 0 0 0-1.143 3.36 4.147 4.147 0 0 0 3.236-1.53Z" fill="#fff"></path></g></svg>
            </li>
          </ul>
        </div>
        <div>
          <p>供应商</p>
          <ul>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
    </div>
    <div id="captcha"></div>
  </div>
</template>

<script>
import { sendMessageForNotLogin,login, register, queryDetails,  queryPayList, needToPayFee, requestPay, queryWithdraw,requestWithdrawNew,betReportRequest, deleteCard, sendMessageForLogin, addCard, updateDetails, updatePassword, queryRecordDetails, queryTaskCategoryUI_INR,downloadApp,firstDepositBonus,firstUsdtDepositBonus,referralFirstActivePlayerBonus,appWeeklyBonus,firstDepositWeeklyBonus, queryNoticePage, querySiteChat, readMessage, qeuryMessageCount, qeuryWeekCommision,postTask,qeuryReferralPlayesData,qeuryYestodayReferralReport, qeuryReferralReportHistory,qeuryVipDetails,queryAccountReportIntl,queryAgentMonthlyCommission,queryAgentBillRulesINR,agentLogin,  playersFinanceReportListINR, queryServiceLines,queryAppData,agentQueryPlayerBalanceIntl,recordDetails,agentBillRecords,queryAgentMonthlyReportData,agentFirstDepositRecords, agentRegisterRecords, qeuryUISettingForWithdrawV1, agentWithdrawV1_S, queryAgentWallet, agentWithdrawRecords, queryOrderListByGame, applicationPGPromoRecord,transferReceiveAll   } from "./api";
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import { getStore,setStore,removeStore } from "~/config/utils";
import QRCode from 'qrcodejs2'

export default {
  name: 'App',
  data() {
    return {
      userData:{account:''},
      qrcode:null,
      fpClient: null,
      currentIndex: 0,
      walletIndex:0,
      currentIndexDeposit:0,
      currentIndexMerchant:0,
      currentIndexBank:0,
      currentIndexPromo:0,
      currentIndexWithdraw:0,
      currentIndexWithdrawBank:0,
      currentIndexCardBank:-1,
      showCardBank:false,
      showRecordOption:-1,
      showCommendOption:-1,
      dataShow:false,
      maskShow: false,
      loginShow: false,
      registerShow: false,
      walletShow: false,
      menuShow:false,
      infoShow:false,
      recordShow:false,
      taksShow:false,
      noticeShow:false,
      commendShow:false,
      affShow:false,
      orderShow:false,
      promoShow:false,
      promo1Show:-1,
      hideOption:true,
      userName: '',
      password: '',
      phone: '',
      phoneCode: '',
      inviteCode: '',
      validate: '',
      isSpreadRegister: 0,
      seconds: 0,
      seconds1: 500,
      isOk: false,
      ing: false,
      showConfirm: false,
      showSignuped: false,
      errorObj: {code: 0, msg: ''},     
      showE1: false,
      showE2: false,
      showE3: false,
      showE4: false,
      showE5: false,
      showE6: false,
      payList:[],
      feecent:0,
      amount:'',
      name:'',
      bankInfo: {},
      cryptoInfo: {
        
      },
      showCrypto: false,
      showBank: false,
      showQr:false,
      qrcode_crypto: null,
      withdrawList:[],
      banklist:[],
      rate:0,
      fastPay: '',
      min: 0,
      max: 0,
      wAmount:'',
      wPwd:'',
      pid:-1,
      betReportData:{
        minTotalBet:'--',
        remainingBet:'--'
      },
      cardNo:'',
      bankAddress:'',
      verifyCode:'',
      timer:null,
      imgLen: 0,
      imgs: {},
      uploadImgs: [],
      currentIndexSettings:0,
      editData: {
        sex:0,
        realName:'',
        birthday:'',
        email:'',
        phone:'',
        qq:'',
        fb:''
      },
      settings:{
        pwd:'',
        newPwd:'',
        confirmPwd:''
      },
      record: {
        currentIndex: -1,
        currentIndex1: 0,
        currentIndex2: -1,
        chooseIndex: -1,
        types: ["存款", "提款", "转账", "虚拟币提现", "红利", "返水"], //0:"充值" ,1:"提款" 2:"转账" 3 :"虚拟币(提) 4 :"红利" 5:"返水"
        stateAsName: ["等待", "成功", "失败"],
        stateAsName1: ["等待", "进行中", "成功", "失败"],
        timeTypeAsName: ["今天", "昨天", "一周"],
        timeType: 0,
        state: -1, //0：等待处理, 1：处理完成, 2：失败 or 0：等待处理, 1：等待支付,2：支付完成,3：失败
        pageIndex: 1,
        pageCount: 0,
        type: 0,
        stateClass: ["w", "t", "f", "f"],
        stateClass1: ["w", "f", "t", "f"],
        list: [],
        last: "",
      },
      record1:{
        pageIndex: 1,
        pageCount: 0,
        list:[]
      },
      commend:{
        types: ["概述", "推荐", "汇总"],
        timeTypeAsName: ["今天", "昨天", "本周","本月"],
        timeTypeAsCode:[3,0,1,2],
        type: 0,
        dataType: 3,
        timeType: 0,
        pageIndex: 1,
        pageCount: 0,
        list: [],
        total: {
          depositamount: 0,
          commission: 0
        }
      },
      promo:{
        showIndex:-1,
        statusAsName: ["全部", "处理中", "完成", "取消"],
        statusAsCode: [-1, 0, 1, 2],
        timeTypeAsName: ["今天", "昨天", "本周"],
        timeTypeAsCode:[0,1,2],
        statusIndex: 0,
        timeIndex: 0,
        pageIndex: 1,
        pageCount: 0,
        list: [],
      },
      aff:{
        type:0,
        timeTypeAsName: ["今天", "昨天", "本周","本月"],
        timeTypeAsCode:[3,0,1,2],
        timeType: 0,
        types: ["概述", "报表", "结算","新增"],
        list: [],
        pageIndex: 1,
        pageCount: 0,
        totalActive:false,
        total: {
          bets: 0.0,
          winlost: 0.0,
          level: 0,
          depositAmount: 0.0,
          depositTimes: 0,
          withdrawAmount: 0.0,
          withdrawTimes: 0,
          promo: 0.0,
          bonus: 0.0,
          rebate: 0,
          turnover: 0.0,
          wd: 0.00,
          fee: 0.0,
          totalRealBankFee: 0.0,
          totalDepositFee: 0.0,
          totalWithdrawFee: 0.0
        },
        reportAccount:'',
        reportBalance:0,
      },
      affInside:{
        pageIndex: 1,
        pageCount: 0,
        list: [],
        type:0,  //0:充值, 1:提现, 2:奖励, 3:返水
      },
      affBill:{
        pageIndex: 1,
        pageCount: 0,
        list: [],
      },
      affReportData: {},
      member:{
        timeTypeAsName: ["今天", "昨天", "本周","本月"],
        timeTypeAsCode:[3,0,1,2],
        timeType: 0,
        pageIndex: 1,
        pageCount: 0,
        list: [],
        type:0,  //0:首存, 1:会员列表
      },
      register:{
        pageIndex: 1,
        pageCount: 0,
        list: [],
      },
      taskMenu:[],
      taskList:[],
      currentIndexTask:0,
      messageCount:0,
      siteMessage:{
        pageCount:1,
        pageIndex:1,
        list:[]
      },
      noticeMessage:{
        pageCount:1,
        pageIndex:1,
        list:[]
      },
      currentIndexNotice:0,
      currentIndexCommend:0,
      refData: {
        yesterdayData: 0,
        report: {

        },
        tp: {

        },
      },
      historyData: [],
      vipIndex:0,
      vipData:{
        vipDetailModels:[]
      },
      vipBetData:{},
      agentData: {},
      affcommissionData:{},
      affRulesData:{
        agentBillRuleModels: [],
        billNoteModel: {
          note: '',
          conditionedStatement: []
        }
      },
      currentIndexAffLink:0,
      services: [],
      appData: {},
      orderPlat: [
        { id: 11, gameName: "IMSP", showType: 0 },
        { id: 15, gameName: "XJ",   showType: 0 },
        { id: 9,  gameName: "PA",   showType: 0 },
        { id: 16, gameName: "DB",   showType: 0 },
        { id: 10, gameName: "IMES", showType: 0 },
        { id: 12, gameName: "TF",   showType: 0 },
        { id: 13, gameName: "LB",   showType: 0 },
        { id: 14, gameName: "KY",   showType: 0 },
        { id: 1, gameName: "PG",   showType: 0 }
      ],
      showOrderDate:false,
      order: {
        pageIndex: 1,
        pageCount: 0,
        settled: true,
        dateType: 1,
        gameName: 'IMSP',
        gameId: 11,
        list: [],
        totalData: {
        }
      },
      sign:true,
      verifyType: 0,
      captchaIns: null,
      requiredVerify: window.requiredVerify,
    }
  },
  watch: {
    promoShow(val) {
      if (val) {
        this.applicationPGPromoRecordAsync();
      }
    }
  },
  created(){
    this.userData.account = getStore("UserName") || '';
    if(this.userData.account !== ''){
      this.queryDetailsAsync();
      this.qeuryMessageCountAsync();
    }
    this.queryAppDataAsync();
    this.queryServiceLinesAsync();
  },
  mounted() {
    if (this.requiredVerify) {
      this.refreshCaptcha();
    }
  },
  methods: {
    handleClick(index,path) {
    if(this.currentIndex === index) {
      return;
    }

    this.currentIndex = index;
    this.$router.push(path);
    },
    async queryDetailsAsync() {
      let result = await queryDetails();
      if (!result.Message) {
        this.userData = result.Result;
        this.$nextTick(() => {
          if (this.qrcode) return;

          this.qrcode = new QRCode("qrcode_invite", {
            text: this.userData.levelurl+'?v=' + this.userData.friendcode,
            width: 100,
            height: 100,
          });
        });
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async loginAsync() {
      if (!/^[0-9A-Za-z_]{6,20}$/.test(this.userName)) {
        return this.showE1=true;
        //return this.$toast(this.lang._t1);
      }

      if (!/^[0-9A-Za-z]{6,20}$/.test(this.password)) {
       return this.showE2=true;
      }

      try{
        //Indicator.open(this.lang._t4);
        this.$toast.loading({
          message: 'loading...',
          forbidClick: false,
          loadingType: 'spinner',
        });
        await this.loadFingerId();
      }
      catch {
        // 忽略指纹加载异常，继续登录
      }
      finally{
        //Indicator.close();
        this.$toast.clear();
      }

      let result = await login(
        this.userName,
        this.password,
        this.phone,
        this.validate,
        window.fingerId
      );
      if (!result.Message) {
        if (!result.Result.Phone) {
          this.userData.account = result.Result.UserName;
          setStore("UserName", result.Result.UserName);
          setStore("Token", result.Result.Token);
          setStore("AgentAccess", result.Result.AgentAccess);
          this.maskShow = false;
          this.loginShow = false;
          this.queryDetailsAsync();
          this.qeuryMessageCountAsync();
          this.$toast.success("登录成功");
        }else{
          this.showConfirm = true;
          this.phone = "";
          this.loginPhone = result.Result.Phone;
        }
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async sendMessageForNotLoginAsync() {
      if (!/^[0-9A-Za-z_]{6,12}$/.test(this.userName)) {
        return this.showE3 = true;
      }

      if (!/^\d{8,11}$/.test(this.phone)) {
        return this.showE5 = true;
      }

      if (this.seconds !== 0) {
        return;
      }

      let result = await sendMessageForNotLogin(this.userName, this.phone, 10);
      if (!result.Message) {
        this.$toast.success("发送验证码成功");

        this.seconds = 120;

        this.time();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async registerAsync() {
      // if (this.isOk === false) {
      //   return this.$toast(this.lang._t9);
      // }

      // if (!this.agree) {
      //   return this.$toast(this.lang._t10);
      // }

      // if (this.ing === true) {
      //   return this.$toast(this.lang._t7);
      // }

      if (!/^[0-9A-Za-z_]{6,12}$/.test(this.userName)) {
         return this.showE3 = true;
      }

      if (!/[0-9A-Za-z]{6,20}$/.test(this.password)) {
        return this.showE4 = true;
        //return this.$toast(this.lang._t2);
      }

      if (!/^\d{8,11}$/.test(this.phone)) {
        return this.showE5 = true;
        //return this.$toast(this.lang._t3);
      }

      if (!/^[A-Za-z0-9]{4,10}$/.test(this.phoneCode)) {
        return this.showE6 = true;
      }

      //if (this.inviteCode && !/^[0-9A-Za-z]{5,50}$/.test(this.inviteCode)) {
        //return this.$toast(this.lang._t12);
      //}

      if (this.sign) {
        this.sign = false;
      } else {
        return;
      }

       try{
        //Indicator.open(this.lang._t4);
        this.$toast.loading({
          message: 'loading...',
          forbidClick: false,
          loadingType: 'spinner',
        });
        await this.loadFingerId();
      }
      catch {
        // 忽略指纹加载异常，继续登录
      }
      finally{
        //Indicator.close();
        this.$toast.clear();
      }

      let result = await register(
        this.userName,
        this.password,
        this.phone,
        this.phoneCode,
        this.inviteCode,
        this.validate,
        this.isSpreadRegister,
        window.fingerId
      );

      this.sign = true;
      if (!result.Message) {
        this.$toast.success("注册成功");
        this.userData.account = result.Result.UserName;
        setStore("UserName", result.Result.UserName);
        setStore("Token", result.Result.Token);
        this.maskShow = false;
        this.loginShow = false;
        this.qeuryMessageCountAsync();
        
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryPayListAsync() {
      let result = await queryPayList();
      if (!result.Message) {
        this.payList = result.Result;
        this.needToPayFeeAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async needToPayFeeAsync() {
      let result = await needToPayFee(this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].id);
      if (!result.Message) {
        this.feecent = Number(result.Result.feecent);
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async requestPayAsync() {
      if (this.amount == "") {
        return this.$toast.fail('请填写充值金额');
      }

      if (!this.payList[this.currentIndexDeposit]) {
        return this.$toast.fail('请选择充值渠道');
      }

      if (!this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant]) {
        return this.$toast.fail('请选择充值通道');
      }

      if (
        Number(this.amount) <
        this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].min
      ) {
        return this.$toast.fail('存款金额最低: ' + this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].min);
      }

      if (Number(this.amount) > this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].max) {
        return this.$toast.fail('存款金额最高: ' + this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].max);
      }

      if (this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].requirename &&(this.name.length < 2 || this.name.length > 30)) {
        return this.$toast.fail('请输入2-30位存款卡姓名');
      }

      let bank = "";

      if (this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].requirebank) {
        bank = this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].banklist[this.currentIndexBank].id;
      }


      if (!this.userData.realname) {
        return this.$toast.fail('请完善资料,再申请充值');
      }

      // if(!this.goDeposit&&this.tCurrentIndex!=-1){
      //     this.showFixCommend = true;
      //     return;
      //   }else{
      //     this.goDeposit=false;
      //   }

      let tempWindow = null;


      if (this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].method != "JSON" && this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].method != "QR") {
        tempWindow = window.open();
      }

      let result = await requestPay(this.amount, this.name, this.payList[this.currentIndexDeposit].merchants[this.currentIndexMerchant].id, bank, this.payList[this.currentIndexDeposit].promos[this.currentIndexPromo].s_value);
      if (!result.Message) {
        this.amount = "";
        if (result.Result.method === "URL") {
          tempWindow.location = result.Result.link;
        } else if (result.Result.method === "BANK") {
          result.Result.title = this.payList[this.currentIndexDeposit].dvalue;
          result.Result.channel =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].name;
          result.Result.min =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].min;
          result.Result.max =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].max;

          result.Result.isNeedUploadPayment =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].isNeedUploadPayment;

          result.Result.isNeedPullFixAmount = this.payList[this.currentIndexDeposit].merchants[
            this.currentIndexMerchant
          ].isNeedPullFixAmount;

          this.bankInfo = result.Result;
          this.showBank = true;

          let timer = setInterval(() => {
            this.seconds1--;
            if(this.seconds1 <= 0){
              this.showBank = false;
              this.seconds1 = 500;
              clearInterval(timer);
            }
          }, 1000);

          this.$once('hook:beforeDestroy', () => {            
            clearInterval(timer);
          });
        } else if (result.Result.method === "CRYPTO") {
          result.Result.title = this.payList[this.currentIndexDeposit].dvalue;
          result.Result.channel =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].name;
          result.Result.min =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].min;
          result.Result.max =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].max;

          this.showCrypto = true;
          this.cryptoInfo = result.Result;

          this.$nextTick(() => {
            this.qrcode_crypto = new QRCode("qrcode_crypto", {
              width: 120,
              height: 120,
              text: this.cryptoInfo.wallet,
            });
          });
          
        } else if (result.Result.method === "QR") {
          result.Result.title = this.payList[this.currentIndexDeposit].dvalue;
          result.Result.channel =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].name;
          result.Result.min =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].min;
          result.Result.max =
            this.payList[this.currentIndexDeposit].merchants[
              this.currentIndexMerchant
            ].max;

          this.showQr = true;
          this.cryptoInfo = result.Result;
          this.$nextTick(() => {
            this.qrcode_crypto = new QRCode("qrcode_crypto", {
              width: 120,
              height: 120,
              text: this.cryptoInfo.link,
            });
          });
        }
      } else {
        if (tempWindow != null) {
          tempWindow.close();
        }
        this.$toast.fail(result.Message);
      }
    },
    async queryWithdrawAsync() {
      let result = await this.queryWithdrawOption();
      if (!result.Message) {
        this.withdrawList = result.Result.withdrawBankInfo;
        this.banklist = result.Result.banklist;
        this.rate = result.Result.rates[0].rate;
        this.fastPay = result.Result.fastPay.fastpay;
        this.min = result.Result.fastPay.min;
        this.max = result.Result.fastPay.max;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async transferReceiveAllAsync() {
      let result = await transferReceiveAll();
      if (!result.Message) {
        this.queryDetailsAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryWithdrawOption(){
      return this.affShow===true ? qeuryUISettingForWithdrawV1() : queryWithdraw();
    },
    async requestWithdrawAsync() {
      if (!/^[0-9A-Za-z]{6,20}$/.test(this.wPwd)) {
        return this.$toast.fail('请输入6-20位字母或数字的提款密码');
      }

      if (!this.withdrawList[this.currentIndexWithdraw]) {
        return this.$toast.fail('不存在的提款卡');
      }

      if (!this.withdrawList[this.currentIndexWithdraw].banks[this.currentIndexWithdrawBank]) {
        return this.$toast.fail('请添加提款卡');
      }

      if (
        this.wAmount >
        this.withdrawList[this.currentIndexWithdraw].maxwithdrawperday
      ) {
        return this.$toast.fail('最大提款金额: ' + this.withdrawList[this.currentIndexWithdraw].maxwithdrawperday);
      }

      if(this.affShow){
        return this.agentWithdrawV1_SAsync();
      }

      let result = await requestWithdrawNew(
        this.wAmount,
        this.wPwd,
        this.withdrawList[this.currentIndexWithdraw].banks[this.currentIndexWithdrawBank].cardno,
        -1,
        this.withdrawList[this.currentIndexWithdraw].dkey,
        -1
      );
      if (!result.Message) {
        this.$toast.success(result.Result);
        this.wAmount = "";
        this.wPwd = "";
        this.queryDetailsAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async agentWithdrawV1_SAsync(){
      let result = await agentWithdrawV1_S(
        this.wAmount,
        this.withdrawList[this.currentIndexWithdraw].banks[this.currentIndexWithdrawBank].cardno,
        this.wPwd
      );
      if (!result.Message) {
        this.wAmount = "";
        this.wPwd = "";
        this.queryAgentWalletAsync(); 
        this.$toast.success("申请成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryAgentWalletAsync(){
      let result = await queryAgentWallet();
      if (!result.Message) {
        this.agentData.activeAmount = result.Result.activeAmount;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async betReportRequestAsync() {
      let result = await betReportRequest();
      if (!result.Message) {
        this.betReportData = result.Result;
      } else {
        this.betReportData.minTotalBet = '--';
        this.betReportData.remainingBet = '--';
        //this.popup(result.Message);
      }
    },
    async deleteCardAsync(cardNo, cardsec) {
      if (confirm("确定删除提款卡: " + cardNo + "?")) {
        let result = await deleteCard(cardsec);
        if (!result.Message) {
          this.$toast.success("操作成功");
          this.queryWithdrawAsync();
        } else {
          this.$toast.fail(result.Message);
        }
      }
    },
    async sendMessageForLoginAsync() {
      if (this.seconds !== 0) {
        return;
      }

      let result = await sendMessageForLogin(3);
      if (!result.Message) {
        this.$toast.success('验证码已发送至您的手机');

        this.seconds = 120;

        this.time();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async addCardAsync() {
      if (!this.banklist[this.currentIndexCardBank]) {
        return this.$toast.fail("请选择提款方式");
      }

      //银行卡
      if (this.banklist[this.currentIndexCardBank].category == 0) {
        if ((!/^[0-9]{6,21}$/.test(this.cardNo))) {
          return this.$toast.fail("请输入正确的银行卡号");
        }

        if (this.bankAddress.length < 2 || this.bankAddress.length > 200) {
          return this.$toast.fail("请输入正确支行2-200位字符");
        }
      }

      //虚拟币
      if (this.banklist[this.currentIndexCardBank].category == 1) {
        if (this.cardNo.length < 10) {
          return this.$toast.fail("请输入正确钱包地址");
        }

        if (this.bankAddress.length < 2) {
          return this.$toast.fail("请输入正确钱包名称");
        }
      }

      if (this.banklist[this.currentIndexCardBank].category == 2 || this.banklist[this.currentIndexCardBank].category == 3) {
        if (this.uploadImgs.length < 1) {
          return this.$toast.fail("请选择一张二维码图片");
        }
      }

      if (!/^[A-Za-z0-9]{4,10}$/.test(this.verifyCode)) {
        return this.$toast.fail("请输入正确验证码4-10位字母或数字");
      }

      let result = await addCard(
        this.banklist[this.currentIndexCardBank].id,
        this.cardNo,
        this.bankAddress,
        this.verifyCode,
        this.uploadImgs,
        this.banklist[this.currentIndexCardBank].category > 1 ? 1 : 0
      );
      if (!result.Message) {
        this.$toast.success('绑定成功');
        this.queryWithdrawAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async upadteDataAsync() {
      if (this.editData.sex != 0 && this.editData.sex != 1) {
        return this.$toast.fail('性别格式不正确');
      }

      if (this.editData.realName.length < 2 || this.editData.realName > 50) {
        return this.$toast.fail('姓名格式不正确'); 
      }

      if (this.editData.birthday) {
        if (this.editData.birthday.length != 10 || new Date(this.editData.birthday) == 'Invalid Date') {
          return this.$toast.fail('生日格式不正确'); 
        }
      }

      let result = await updateDetails(
        this.editData.realName,
        this.editData.sex,
        this.editData.birthday,
        this.editData.phone,
        this.editData.email,
        this.editData.qq,
        this.editData.fb
      );
      if (!result.Message) {
        this.userData.realname = this.editData.realName;
        this.$toast.success('完善资料成功');
        this.queryDetailsAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async updatePasswordAsync() {
      if (!/^[0-9A-Za-z]{6,20}$/.test(this.settings.pwd)) {
        return this.$toast.fail('当前密码格式不正确');
      }

      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(this.settings.newPwd)) {
        return this.$toast.fail('新密码格式不正确，请输入6-20位字符串');
      }

      if (this.settings.newPwd != this.settings.confirmPwd) {
        return this.$toast.fail('新密码与确认新密码不一致');
      }

      let result = await updatePassword(this.settings.pwd, this.settings.newPwd);
      if (!result.Message) {
        this.settings.pwd = "";
        this.settings.newPwd = "";
        this.settings.confirmPwd = "";
        this.$toast.success('修改成功');
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryRecordClick(){
      if(!this.affShow){
        this.queryRecordDetailsAsync(1,);
      }else{
        this.agentWithdrawRecordsAsync(1);
      }
    },
    async queryRecordDetailsAsync(pageIndex, add) {
      if (this.record.type + '_' + this.record.timeType + '_' + this.record.state != this.record.last) {
        add = false;
      }

      let result = await queryRecordDetails(
        this.record.type,
        this.record.timeType,
        this.record.state,
        pageIndex
      );
      if (!result.Message) {
        this.record.chooseIndex = this.record.currentIndex;
        result.Result.modelList.forEach(item => { item.active = false; });
        if (add) {
          this.record.list = this.record.list.concat(result.Result.modelList);
        } else {
          this.record.list = result.Result.modelList;
        }

        this.record.pageIndex = result.Result.pageIndex;
        this.record.pageCount = result.Result.totalPages;

        this.record.last = this.record.type + '_' + this.record.timeType + '_' + this.record.state;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryTaskCategoryUI_INRAsync() {
      let result = await queryTaskCategoryUI_INR();
      if (!result.Message) {
        this.taskMenu = result.Result.menus;
        this.taskList = result.Result.tasks;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async taskAsync(api,taskId) {
      let result = await postTask(api,taskId);
      if (!result.Message) {
        this.$toast.success("领取成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async downloadAppAsync() {
      let result = await downloadApp();
      if (!result.Message) {
        this.$toast.success("领取成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async firstDepositBonusAsync() {
      let result = await firstDepositBonus();
      if (!result.Message) {
        this.$toast.success("领取成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async firstUsdtDepositBonusAsync() {
      let result = await firstUsdtDepositBonus();
      if (!result.Message) {
        this.$toast.success("领取成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async referralFirstActivePlayerBonusAsync() {
      let result = await referralFirstActivePlayerBonus();
      if (!result.Message) {
        this.$toast.success("领取成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async appWeeklyBonusAsync() {
      let result = await appWeeklyBonus();
      if (!result.Message) {
        this.$toast.success("领取成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async firstDepositWeeklyBonusAsync() {
      let result = await firstDepositWeeklyBonus();
      if (!result.Message) {
        this.$toast.success("领取成功");
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryNoticePageAsync(pageIndex) {
      let result = await queryNoticePage(pageIndex, -1);
      if (!result.Message) {
        this.noticeMessage.pageIndex = result.Result.pageIndex;
        this.noticeMessage.pageCount = result.Result.totalPages;
        if (pageIndex == 1) {
          this.noticeMessage.list = result.Result.modelList;
        } else {
          this.noticeMessage.list = this.noticeMessage.list.concat(result.Result.modelList);
        }
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async readMessageAsync(){
      let result = await readMessage();
      if (!result.Message) {
        this.messageCount = 0;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryMessageCountAsync() {
      let result = await qeuryMessageCount();
      if (!result.Message) {
        this.messageCount = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async querySiteChatAsync(pageIndex) {
      let result = await querySiteChat(pageIndex);
      if (!result.Message) {
        if(pageIndex==1){
          this.readMessageAsync();
        }
        this.siteMessage.pageIndex = result.Result.pageIndex;
        this.siteMessage.pageCount = result.Result.totalPages;
        if (pageIndex == 1) {
          this.siteMessage.list = result.Result.modelList;
        } else {
          this.siteMessage.list = this.siteMessage.list.concat(result.Result.modelList);
        }
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryWeekCommisionAsync() {
      let result = await qeuryWeekCommision();
      if (!result.Message) {
        this.refData.yesterdayData = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryReferralPlayesDataAsync(pageIndex, add) {
      let result = await qeuryReferralPlayesData(this.commend.dataType, this.commend.timeTypeAsCode[this.commend.timeType], pageIndex);
      if (!result.Message) {
        if (add) {
          this.commend.list = this.commend.list.concat(result.Result.modelList);
        } else {
          this.commend.list = result.Result.modelList;
        }

        this.commend.total = result.Result.totalData;
        this.commend.pageIndex = result.Result.pageIndex;
        this.commend.pageCount = result.Result.totalPages;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryYestodayReferralReportAsync() {
      let result = await qeuryYestodayReferralReport();
      if (!result.Message) {
        this.refData.report = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryReferralReportHistoryAsync() {
      let result = await qeuryReferralReportHistory();
      if (!result.Message) {
        result.Result.forEach(item => {
          item.active = false;
        });
        this.historyData = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async qeuryVipDetailsAsync() {
      let result = await qeuryVipDetails();
      if (!result.Message) {
        this.vipData = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryAccountReportIntlAsync() {
      let result = await queryAccountReportIntl();
      if (!result.Message) {
        this.vipBetData = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async agentLoginAsync() {
    let t = getStore("AgentToken");
      if(this.agentData.account && t){
        this.queryAgentMonthlyCommissionAsync();
        this.queryAgentBillRulesINRAsync();
        return;
      }
      
      let token = getStore("AgentAccess");
      let result = await agentLogin(token);
      if (!result.Message) {
        setStore("AgentToken", result.Result.Token);
        this.agentData = result.Result.Data;
        this.$nextTick(() => {
          for (let i = 0; i < this.agentData.adlink.split(' ').length; i++) {
            document.getElementById("qrcode_invite_" + i).innerHTML = '';
            new QRCode("qrcode_invite_" + i, {
              text: this.agentData.adlink.split(' ')[i] + '/?v=' + this.agentData.adcode,
              width: 90,
              height: 90,
            });
          }
        })

        this.queryAgentMonthlyCommissionAsync();
        this.queryAgentBillRulesINRAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryAgentMonthlyCommissionAsync() {
      let result = await queryAgentMonthlyCommission();
      if (!result.Message) {
        this.affcommissionData = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryAgentBillRulesINRAsync() {
      let result = await queryAgentBillRulesINR();
      if (!result.Message) {
        this.affRulesData = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async playersFinanceReportListINRAsync(pageIndex, add) {
      let result = await playersFinanceReportListINR(pageIndex, this.aff.timeTypeAsCode[this.aff.timeType]);
      if (!result.Message) {
        result.Result.modelList.forEach(item => { item.active = false; });

        if (add) {
          this.aff.list = this.aff.list.concat(result.Result.modelList);
        } else {
          this.aff.list = result.Result.modelList;
        }

        this.aff.total = result.Result.totalData;
        this.aff.pageIndex = result.Result.pageIndex;
        this.aff.pageCount = result.Result.totalPages;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryServiceLinesAsync() {
      let result = await queryServiceLines();
      if (!result.Message) {
        this.services = result.Result.cs;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async agentQueryPlayerBalanceIntlAsync() {
      let result = await agentQueryPlayerBalanceIntl(this.aff.reportAccount);
      if (!result.Message) {
        this.aff.reportBalance = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryAppDataAsync() {
      let result = await queryAppData();
      if (!result.Message) {
        this.appData = result.Result;
        //this.generateQrcode();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async recordDetailsAsync(pageIndex, add) {
      let result = await recordDetails(pageIndex, this.affInside.type, -1, this.aff.timeTypeAsCode[this.aff.timeType], this.aff.reportAccount);
      if (!result.Message) {
        result.Result.modelList.forEach(item => { item.active = false; });
        if (add) {
          this.affInside.list = this.affInside.list.concat(result.Result.modelList);
        } else {
          this.affInside.list = result.Result.modelList;
        }

        this.affInside.pageIndex = result.Result.pageIndex;
        this.affInside.pageCount = result.Result.totalPages;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async agentBillRecordsAsync(pageIndex, add) {
      let result = await agentBillRecords(pageIndex, 4);
      if (!result.Message) {
        result.Result.modelList.forEach(item => { item.active = false; });
        if (add) {
          this.affBill.list = this.affBill.list.concat(result.Result.modelList);
        } else {
          this.affBill.list = result.Result.modelList;
          this.affBill.list.total = result.Result.totalData;
        }

        this.affBill.pageIndex = result.Result.pageIndex;
        this.affBill.pageCount = result.Result.totalPages;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryAgentMonthlyReportDataAsync() {
      let result = await queryAgentMonthlyReportData();
      if (!result.Message) {
        this.affReportData = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async agentFirstDepositRecordsAsync(pageIndex, add) {
      let result = await agentFirstDepositRecords(pageIndex, this.member.timeTypeAsCode[this.member.timeType]);
      if (!result.Message) {
        result.Result.modelList.forEach(item => { item.active = false; });
        if (add) {
          this.member.list = this.member.list.concat(result.Result.modelList);
        } else {
          this.member.list = result.Result.modelList;
        }

        this.member.pageIndex = result.Result.pageIndex;
        this.member.pageCount = result.Result.totalPages;
      } else {
        this.$$toast.fail(result.Message);
      }
    },
    async agentRegisterRecordsAsync(pageIndex, add) {
      let result = await agentRegisterRecords(pageIndex, this.member.timeTypeAsCode[this.member.timeType]);
      if (!result.Message) {
        result.Result.modelList.forEach(item => { item.active = false; });
        if (add) {
          this.register.list = this.register.list.concat(result.Result.modelList);
        } else {
          this.register.list = result.Result.modelList;
        }

        this.register.pageIndex = result.Result.pageIndex;
        this.register.pageCount = result.Result.totalPages;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async agentWithdrawRecordsAsync(pageIndex, add) {
      const today = new Date();

      // 结束时间：明天
      const end = new Date(today);
      end.setDate(end.getDate() + 1);

      // 开始时间：往前推 3 个月（保持同一天，如果不存在会自动回退）
      const start = new Date(today);
      start.setMonth(start.getMonth() - 3);

      const startStr = this.formatDate(start);
      const endStr = this.formatDate(end);

      let result = await agentWithdrawRecords(
        pageIndex,
        startStr,
        endStr,
      );

      if (!result.Message) {
        result.Result.modelList.forEach(item => { item.active = false; });
        if (add) {
          this.record1.list = this.record1.list.concat(result.Result.modelList);
        } else {
          this.record1.list = result.Result.modelList;
        }
        this.record1.pageIndex = result.Result.pageIndex;
        this.record1.pageCount = result.Result.totalPages;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryOrderListByGameAsync(pageIndex, add) {
      var result = await queryOrderListByGame(pageIndex, this.order.gameId, this.order.dateType, this.order.settled);
      if (!result.Message) {
        if (add) {
          this.order.list = this.order.list.concat(result.result);
        } else {
          this.order.list = result.result;
        }

        this.order.totalData = result.totalData;

        this.order.pageIndex = result.pageInfo.pageIndex;
        this.order.pageCount = result.pageInfo.pageCount;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async applicationPGPromoRecordAsync() {
      const timeType = this.promo.timeTypeAsCode[this.promo.timeIndex];
      const status = this.promo.statusAsCode[this.promo.statusIndex];
      let result = await applicationPGPromoRecord(timeType, status);
      if (!result.Message) {
        this.promo.list = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    refreshCaptcha() {
      let t = this;
      if (typeof window.initNECaptcha !== "function") {
        t.$toast.fail("验证码组件未加载，请稍后重试");
        return;
      }
      window.initNECaptcha(
        {
          element: "#captcha",
          captchaId: "efc8a56cc30744959f0ce5c4846145de",
          lang:'zh-CN',
          mode: "popup",
          width: "340px",
          onClose: function () {
            t.captchaIns.refresh();
          },
          onVerify: function (err, data) {
            if (!err) {
              t.validate = data.validate;
              if (t.verifyType == 0) {
                t.loginAsync();
              } else {
                t.registerAsync();
              }
            } else {
              //this.popup(this.lang._t16);
            }
          },
        },
        function (instance) {
          t.captchaIns = instance;
        },
        function (err) {
          t.$toast.fail('验证码加载失败'+err);
        }
      );
    },
    verify() {
      if (this.captchaIns) {
        if (!/^[0-9A-Za-z_]{6,20}$/.test(this.userName)) {
          return this.showE1=true;
        }

        if (!/^[0-9A-Za-z]{6,20}$/.test(this.password)) {
          return this.showE2=true;
        }

        this.verifyType = 0;
        this.captchaIns.popUp();
      } else {
        this.$toast.fail('正在加载验证码，请稍等...');
      }
    },
    verifyForRegister() {
      if (this.captchaIns) {
        if (!/^[0-9A-Za-z_]{6,12}$/.test(this.userName)) {
          return this.showE3 = true;
        }
        
        if (
          !/[0-9A-Za-z]{6,20}$/.test(this.password)
        ) {
          return this.showE4 = true;
        }

        if (!/^\d{8,11}$/.test(this.phone)) {
          return this.showE5 = true;
        //return this.$toast(this.lang._t3);
        }

        if (!/^[A-Za-z0-9]{4,10}$/.test(this.phoneCode)) {
          return this.showE6 = true;
        }

        this.verifyType = 1;
        this.captchaIns.popUp();
      } else {
        this.$toast.fail('正在加载验证码，请稍等...');
      }
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0'); // 月份 0-11
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    memberClick(){
      if(this.member.type==0){
        this.agentFirstDepositRecordsAsync(1);
      }else if(this.member.type==1){
        this.agentRegisterRecordsAsync(1);
      }
    },
    clickService(){
      window.open(this.services[0].services, '_blank');
    },
    openApp(url) {
      //var domain = (document.domain || window.location.host || '').toLowerCase().replace('www.', '');
      if ( !this.userData.account) {
        return this.$toast.fail('请登录后下载');
      }

      window.open(url, '_blank');
    },
    clickRecord(index){
      if(index == this.record.type){
        return;
      }
      this.record.type = index;
      //this.record.timeType = 0;
      this.record.state = -1;
      this.record.pageIndex = 1;
      this.record.pageCount = 0;
      this.record.list = [];
      this.queryRecordDetailsAsync(1, false);
    },
    clickCommend(index){
      if(index == this.commend.type){
        return;
      }
      this.commend.type = index;
      if(this.commend.type==0){
        this.qeuryWeekCommisionAsync();
      }else if(this.commend.type == 1){
        this.qeuryReferralPlayesDataAsync(1);
      }else if(this.commend.type == 2){
        this.qeuryYestodayReferralReportAsync(1);
        this.qeuryReferralReportHistoryAsync();
      }
    },
    clickAff(index){
      if(index == this.aff.type){
        return;
      }
      this.aff.type = index;
      if(this.aff.type==0){
        this.queryAgentBillRulesINRAsync();
      }else if(this.aff.type==1){
        this.playersFinanceReportListINRAsync(1);
      } else if(this.aff.type==2){
        this.agentBillRecordsAsync(1);
        this.queryAgentMonthlyReportDataAsync();
      }
      else if(this.aff.type==3){
        this.agentFirstDepositRecordsAsync(1);
        this.agentRegisterRecordsAsync(1);
      }
    },
    addCardType(){
      if(this.banklist[this.currentIndexCardBank].category < 2){
        this.addCardAsync();
      }else{
        this.prepareUpload();
      }
    },
    time() {
      let t = this;
      this.timer = setTimeout(() => {
        t.seconds--;

        if (t.seconds > 0) {
          t.time();
        }
      }, 1000);
    },
    addImg() {
      let inputDOM = this.$refs.inputer;
      let oldLen = this.imgLen;
      let len = inputDOM.files.length + oldLen;
      if (len > 1) {
        //return Toast("最多可上传4张，您还可以上传" + (4 - oldLen) + "张");

        //this.showSuccess = true;
        //this.msg = "Up to 4 photos can be uploaded. You can also upload" + (4 - oldLen);
        this.$toast.fail('只能选择一个二维码图片！');
        return;// Toast(this.msg);
      }

      for (let i = 0; i < inputDOM.files.length; i++) {
        let size = Math.floor(inputDOM.files[i].size / 1024);
        if (size > 5 * 1024 * 1024) {
          //Toast("请选择5M以内的图片！");

          //this.showSuccess = true;
          //this.msg = "请选择5M以内的图片！";
          this.$toast.fail('请选择5M以内的二维码图片！');
          return; // Toast(this.msg);
        }

        this.imgLen++;
        this.$set(
          this.imgs,
          inputDOM.files.name + "?" + new Date().getTime() + i,
          inputDOM.files[i]
        );
      }

      this.$refs.inputer.value = null;
    },
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    delImg(key) {
      this.$delete(this.imgs, key);
      this.imgLen--;

      this.$refs.inputer.value = null;
    },
    prepareUpload() {
      if (Object.keys(this.imgs).length < 1) {
        return this.$toast.fail('请选择至少一张二维码图片');
      }

      if (this.uploadImgs.length > 0) {
        return this.addCardAsync();
      }

      for (let key in this.imgs) {
        var reader = new FileReader();

        let t = this;
        reader.onload = function (e) {
          t.uploadImgs.push(e.target.result);
          if (t.uploadImgs.length == t.imgLen) {
            t.addCardAsync();
          }
        };

        reader.readAsDataURL(this.imgs[key]);
      }
    },
    showDeposit(){
      if(this.userData.account === ''){
        this.maskShow = true;
        this.loginShow = true;
        return;
      }

      this.maskShow = true;
      this.walletShow = true;
      this.walletIndex = 0;
      this.currentIndexDeposit=0;
      this.currentIndexMerchant=0;
      this.currentIndexWithdraw=0;
      this.currentIndexWithdrawBank=0;  
      this.queryPayListAsync();
      if(this.rate === 0){
        this.queryWithdrawAsync();
      }
    },
    showCommend(){
      if(this.userData.account === ''){
        this.maskShow = true;
        this.loginShow = true;
        return;
      }

      this.commendShow=true;
      this.currentIndexCommend=0;
      this.qeuryWeekCommisionAsync();
    },
    loginout(){
      this.userData.account = '';
      removeStore('Token');
      removeStore('UserName');
      removeStore('AgentAccess');
      this.$toast.fail('已退出登录');
    },
    handleMenuClick(){
      if(this.userData.account === ''){
        this.maskShow = true;
        this.loginShow = true;
        return;
      }
      this.menuShow = true;
    },
    clickRecordOption(index){
      if(index == this.showRecordOption){
        this.showRecordOption = -1;
      }else{
        this.showRecordOption = index;
      }
    },
    clickCommendOption(index){
      if(index == this.showCommendOption){
        this.showCommendOption = -1;
      }else{
        this.showCommendOption = index;
      }
    },
    /** 加载 Fingerprint 客户端（仅加载一次） */
    async getFpClient() {
      if (this.fpClient) return this.fpClient
      const apiKey = process.env.VUE_APP_FPJS_API_KEY || '2r1xjMWV52VZkwRjM1tP'
      this.fpClient = await FingerprintJS.load({
        apiKey,
        region: 'ap'
      })
      return this.fpClient
    },

    /** 获取访客 ID 并写入 window.fingerId（登录/注册等流程用） */
    async loadFingerId() {
      const fp = await this.getFpClient()
      const result = await fp.get()
      window.fingerId = result.visitorId
      return result.visitorId
    },

    /** 仅获取 visitorId，不写入 window */
    async getVisitorId() {
      const fp = await this.getFpClient()
      const result = await fp.get()
      return result.visitorId
    },

    /** 获取完整识别结果（含 visitorId、confidence 等） */
    async getVisitorData() {
      const fp = await this.getFpClient()
      return await fp.get()
    },
    doCopy(text) {
      const str = text != null ? String(text) : '';
      this.$copyText(str).then(() => this.copy()).catch(() => this.copyError());
    },
    copy() {
      this.$toast.success("复制成功");
    },
    copyError() {
      this.$toast.fail("复制失败");
    },
    onSwipeChange(index){
      this.vipIndex=index;
      console.log(this.vipIndex);
    }
  }
}
</script>

<style>

html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}

#app .mmm{
width:100%;
display: flex;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}



body {
  font-family: 'Microsoft YaHei UI', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif!important;
  font-size: 0.16rem;
  color: #ffffff;
  background: #181818;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}



ul,
ol {
  list-style: none;
  margin: 0;
  padding: 0;
}

li {
  margin: 0;
  padding: 0;
}

dl,
dd {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

p{
margin: 0;
padding: 0;
}

button,
input,
textarea {
  outline: none;
  font-family: inherit;
}

/* 禁止 number 类型 input 控件的默认样式（去除数字输入框右侧的增减箭头） */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.menu{
  width: 0.8rem;
  background: #181818;
}

.menu dl dd{
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #9e9e9e;
  position: relative;
  
  font-weight: bold;
}
.menu dl dd:hover{
  background: #282828;
}
.menu dl dd div{
display: flex;
flex-wrap: wrap;
justify-content: center;
}


.menu dl dd div img{
  width:0.3rem;
  height:0.3rem;
  display: block;
  /*filter: brightness(0) saturate(100%) invert(65%) sepia(0%) saturate(0%) hue-rotate(166deg) brightness(85%) contrast(90%);*/
}



.menu dl dd div span{
display: block;
font-size: 0.2rem;
margin-top: 0.08rem;
width: 100%;
text-align: center;
}

.menu dl dd:nth-child(1){
height:0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}
.menu dl dd:nth-child(1):hover{
  transform: rotate(360deg);
}
.menu dl dd:nth-child(1) img{
  width:0.4rem;
  height: 0.4rem;
}

.menu dl dd.on{
  color: #FF00A7;
}

.menu dl dd.on::before{
  content: '';
  display: block;
  width: 0.04rem;
  height: 0.75rem;
  border-radius: 0.4rem;
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
  position: absolute;
  right: 0;
}

.center{
width:100%;
padding:0 0.16rem;
}

.nav{
  width: 100%;
  background: #181818;
  height: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav .logo{
  width: 1.44rem;
  height: 0.56rem;
  background: url('@/img/logo.png') no-repeat center;
  background-size: 100% 100%;
}
.nav dl{
margin-right: 0.16rem;
}
.nav .btns-nologin{
  width:3.68rem;
  height: 0.48rem;
  line-height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav .btns-nologin dd{
  margin-left: 0.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #282828;
  border-radius: 0.16rem; 
  transition: all 0.3s ease;  
}
.nav .btns-nologin dd:hover{
 background: #383838;
  transform: scale(1.1);
  transition: all 0.3s ease;
}   

.nav .btns-nologin dd img{
  width: 0.2rem;
  height: 0.2rem;
  display: block;
}

.nav .btns-nologin dd:nth-child(1),.nav .btns-nologin dd:nth-child(2){
  width: 0.48rem;
  height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav .btns-nologin dd:nth-child(3),.nav .btns-nologin dd:nth-child(4){
  width: 1.12rem;
  height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.btns-nologin dd:nth-child(4){
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%)!important;
}

.nav .btns-login{
  height: 0.48rem;
  line-height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav .btns-login dd{
  margin-left: 0.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #282828;
  border-radius: 0.16rem;
}

.nav .btns-login dd:hover{
background: #383838;
  transform: scale(1.1);
  transition: all 0.3s ease;
}
.nav .btns-login dd img{
  width: 0.2rem;
  height: 0.2rem;
  display: block;
}

.nav .btns-login dd:nth-child(1),.nav .btns-login dd:nth-child(2),.nav .btns-login dd:nth-child(5){
  width: 0.48rem;
  height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav .btns-login dd:nth-child(3){
width: 1.92rem;
height: 0.48rem;
display: flex;
align-items: center;
justify-content: space-between;
}
.nav .btns-login dd:nth-child(3) span.balance{
width:1.1rem;
display: block;
padding:0 0.04rem;
font-family: Montserrat;
font-weight: 800;
font-style: ExtraBold;
font-size: 0.14rem;
leading-trim: NONE;
line-height: 100%;
letter-spacing: 0px;

}
.nav .btns-login dd:nth-child(3) span.refresh{
display: block;
    width: .24rem;
    height: .24rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPASURBVHgB7ZyLbdswEIbPQQbICOoE8QbVBs0GdSdIOoGVCepOYG+QdAJrAzsTUBs0neDvEZQQw/GRlEU9bPIDDkH4PJ/41lFEiUQikUhcKjMaGAB3/CdnyVjuWeYsd/X/h1S1vLO8sZQs+9ls9k7XhjYKy5Jli+5sWZ5YMrp0+EfkCGMUm7FyujQGMMwxiuWBeiDoGATT7Ndkxpgx2LA88zhVSQlYx+JUOOcpqE+44keWvxgfxbKw6HkSKX3nFgQzKy1Znlpk0zPRK5nZqWLZ67DDGQqmNWqZ1/KVPs90NlZc3k/6rO9JY3Da8DM6zOy0gx+6dRXoMKhy3jnLpm4lPuxwNNtJCSk0umJPRRvD3FFAuLyFZ/3q0EhSIgpJC+MEN8wJXQoPPVSjh5SAQgJ3t1IscxoIzwe2q9P2ayAu6xfs6DGi11Yj6KXHwxeHbqLuFAKYfm+joJGBX5cLbyC4m3FBE+EcI1FXuIy1pfwXmhgwXX0YA3H+B0vZCiOMOS5gxiQFT6RyvFaPuiKSV7FfbHufvoG9a+vzJq9N7NkraZiduURBI4NA0LlAPrZQNAEQCKn8G0flGclHF88UATeOeKn/VtxlNxQBLgN9E8JLioRbKQIfbx9O8ZumwzhdHfLsNYnBeShsXSwXwkuKCJuB7oXwN4oIm4Gk7cOeIsJmoEwIj2oMEvcf0uqyl9P/CeNaB0VPVK1B07ZnpBbkICoDQXaZqaQ8sbWgTAivpAyxGUh6V/dPyhCbgaTdQVSLXxHIh/i5lMd23FFQAHp3TPIE5lV4JkS3b0Ho+ax3aCC/19va8sU0BuVC+B+yEIWBYFzyMiH6lc4s9Gq6GOTBeevKe/UtiI2g/SczIdp5nn1L3WmcMScHzNaiEKL1q6uSOhTui8JlOi90czxHO9Y0MWD3NuuuL9qzpIkAc3FGQiHERRicx+hGchhHs6AQWCpYORTQTXssJ861Q7cVhUKqoY7zcQPOaCBgPPCVQ6cdhUSqpY7zdW/rtcvh46KeC4XQD0yq6SA+g/9VgAUF5MAwPreLFPpozVJtR2m0kXwvsyiYMeJsD3wYh4ol/K9dad06jYdBXhzCDH6P5E9FxglCr8D1WUx16Aha/ygtzRlO44zZ5sdqF52it0vA0iOxpF+ghdttj+jW1ebumhXbXqyVY5J2yWPFSjJ7n+80DiXLjzHdkr2AcTxXGI4t0u3nKzLMMTCz3RPCfVigwECr9bE+TaFnp5zM7NR8liI7SlqRufyrZ7nm8m95lZ+mSCQSiUSiF/4D06gBU/Qvl5gAAAAASUVORK5CYII=) no-repeat 50%;
    background-size: contain;
    margin: 0 .08rem;
    cursor: pointer;
    transition: all 0.3s ease;
} 
.nav .btns-login dd:nth-child(3) span.refresh:hover{
transform: rotate(360deg);
}

.nav .btns-login dd:nth-child(4){
width:0.84rem;
height: 0.48rem;
display: flex;
justify-content: space-around;
align-items: center;
}

.nav .btns-login dd:nth-child(4) img{
width: 0.4rem;
height: 0.4rem;
display: block; 
}
.nav .btns-login dd:nth-child(5){
position: relative;
}
.nav .btns-login dd:nth-child(5).active::after {
content: '';
display: block;
width: 0.06rem;
height: 0.06rem;
background: #ff0000;
border-radius: 50%;
position: absolute;
top: 0.12rem;
right: 0.12rem;

}
.mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask .login{
  width: 3.75rem;
  height: 7.23rem;
  background: #181818;
  border-radius: 0.16rem;
  overflow: hidden;
}

.mask .login .logb{
width:100%;
height:2.18rem;
background: url('@/img/logbanner.jpg') no-repeat center center;
background-size: contain;
position: relative;
}

.mask .login .logb .title{
font-size: 0.28rem;
color: #ffffff;
font-family: Montserrat;
font-weight: 900;
font-size: 0.24rem;
line-height: 2.18rem;
padding-left: 0.3rem;
}

.mask .login .logb .close{
width: 0.24rem;
height: 0.24rem;
background: url('@/img/close.png') no-repeat center center;
background-size: contain;
position: absolute;
top: 0.24rem;
right: 0.24rem;
cursor: pointer;
}

.mask .login .form{
padding: 0.16rem;
}
.mask .login .form .form-item{
margin: 0.08rem 0;
}
.mask .login .form .form-item div{
width:100%;
height: 0.48rem;
background: #202020;
border-radius: 0.16rem;
padding: 0 0.08rem;
display: flex;
align-items: center;
}
.mask .login .form .form-item p{
font-size: 0.14rem;
font-weight: bold;
color:#999;
padding: 0.08rem 0;
}
.mask .login .form .form-item div input{
border: none;
height: 0.48rem;
line-height: 0.48rem;
color: #ffffff;
background: transparent;
font-size: 0.14rem;
padding: 0 0.08rem;
padding-left: 0.3rem;
}

.mask .login .form .form-item div.user::before{
content: '';
display: block;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/user.png') no-repeat center center;
background-size: contain;
position: absolute;
opacity: 0.5;
} 
.mask .login .form .form-item div.pwd::before{
content: '';
display: block;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/pwd.png') no-repeat center center;
background-size: contain;
position: absolute;
opacity: 0.5;
} 

.mask .login .form .form-item div.phone::before{
content: '';
display: block;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/ph.png') no-repeat center center;
background-size: contain;
position: absolute;
opacity: 0.5;
} 

.mask .login .form .form-item div.phone .left{
font-size: 0.14rem;
font-weight: bold;
color:#999;
padding-left:0.24rem;
}

.mask .login .form .form-item div.phone input{
padding-left:0.08rem;
}

.mask .login .form .form-item div .getcode{
display: block;
width: 1.2rem;
height: 0.34rem;
line-height: 0.34rem;
text-align: center;
font-size: 0.14rem;
font-weight: bold;
cursor: pointer;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius: 0.08rem;
}

.mask .login .form .form-item .error_line{
font-size: 0.12rem;
color: #cf0000;
padding: 0.08rem 0;
}

.mask .login .btns{
padding:0 0.16rem;
}

.mask .login .btns button,
.mask .login .btns a.forget_pwd,
.mask .login .btns a.register
{
display: block;
}

.mask .login .btns button{
width:100%;
height: 0.48rem;
line-height: 0.48rem;
text-align: center;
color:#fff;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius: 0.08rem; 
cursor: pointer;
transition: all 0.3s ease;
border: none;
outline: none;
font-size: 0.16rem;
font-weight: bold;
}
.mask .login .btns button:hover{
background: linear-gradient(180deg, #8800FF 0%, #FF00A7 100%);
}

.mask .login .btns a.forget_pwd{
color:#FF00A7;
font-weight: bold;
font-size: 0.14rem;
cursor: pointer;
padding:0.16rem 0;
text-align: center;
}

.mask .login .btns a.register{
font-size: 0.14rem;
padding:0.16rem 0;
text-align: center;
}

.mask .login .btns a.register span{
color:#FF00A7;
font-weight: bold;
cursor: pointer;
}
.menu-list{
position: fixed;
top: 0;
left: -2.95rem;
width: 2.95rem;
height: 100%;
background: #0f0f0f;
z-index: 1000;
padding: 0.16rem;
transition: all 0.3s ease;
}

.menu-list.on{
left:0;
transition: all 0.3s ease;
}
.menu-list .top{
display: flex;
align-items: center;
/*height:0.5rem;*/
}
.menu-list .top p:first-child{
cursor: pointer;
transition: all 0.3s ease;
}
.menu-list .top p:first-child:hover{
transform: rotate(180deg);
}
.menu-list .top p:first-child img{
width: 0.4rem;
height: 0.4rem;
display: block;
}

.menu-list .top p:last-child img{
width: 1.44rem;
height: 0.56rem;
display: block;
margin-left:0.08rem;
}

.menu-list .info{
width:100%;
height:0.64rem;
border-radius: 0.08rem;
background:  linear-gradient(180deg, rgba(255, 0, 167, 0.1) 0%, rgba(136, 0, 255, 0.3) 100%);
display: flex;
align-items: center;
padding: 0.08rem;
font-size: 0.12rem;
font-family: Montserrat;
font-weight: 600;
margin-top:0.16rem;
}
.menu-list .info div:last-child{
width:2rem;
}
.menu-list .info div img{
width: 0.48rem;
height: 0.48rem;
display: block;
}

.menu-list .info div dl{
display: flex;
align-items: center;
justify-content: space-between;
padding-left: 0.08rem;
margin: 0.02rem 0;
}

.menu-list .info dl dd.balance{
font-weight: 800;
font-size: 0.16rem;

}
.menu-list .info dl dd span.vip{
display: inline-block;
width:0.4rem;
height:0.16rem;
line-height:0.16rem;
text-align: center;
font-size: 0.1rem;
color: #fff;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius: 0.08rem;
margin-left:0.08rem
}
.menu-list .info dl dd span.copy{
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/copy.png') no-repeat center center;
background-size: contain;
opacity: 0.4;
}
.menu-list .info dl dd span.refresh{
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/refresh.png') no-repeat center center;
background-size: contain;
opacity: 0.4;
}
.menu-list .dw{
width:100%;
height:0.37rem;
margin-top: 0.16rem;
}
.menu-list .dw ul{
display: flex;
align-items: center;
justify-content: space-between;
}
.menu-list .dw ul li{
width:1.275rem;
height:0.37rem;
line-height:0.37rem;
text-align: center;
font-size: 0.14rem;
font-weight:600;
color:#fff;
border-radius: 0.08rem;
background: #202020;
}

.menu-list .dw ul li:nth-child(2){
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
}

.menu-list .settings{
width:100%;
}

.menu-list .settings ul{
background: #202020;
border-radius: 0.08rem;
padding: 0.08rem;
margin-top: 0.16rem;
}

.menu-list .settings ul li{
height:0.48rem;
line-height: 0.48rem;
font-size: 0.14rem;
font-weight: bold;
cursor: pointer;  
transition: all 0.3s ease;
position: relative;
display: flex ;
align-items: center;
}

.menu-list .settings ul:first-child li:nth-child(1)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/sts1.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
} 
.menu-list .settings ul:first-child li:nth-child(2)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/sts2.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .settings ul:first-child li:nth-child(3)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/sts3.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .settings ul:first-child li:nth-child(4)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/sts4.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .settings ul:first-child li:nth-child(5)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/sts6.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .settings ul:first-child li:nth-child(6)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/sts5.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
} 
.menu-list .settings ul:last-child li:nth-child(1)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/user.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .settings ul:last-child li:nth-child(2)::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/sts9.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .app{
margin-top:0.16rem;
}
.menu-list .app p{
font-weight: bold;
display: flex;
align-items: center;
padding:0.08rem 0;
}

.menu-list .app p::before{
content: '';
display: block;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/download.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;

}
    

.menu-list .app ul{
display: flex;
align-items: center;
justify-content: space-between;
}
.menu-list .app ul li{
width:1.35rem;
height:0.4rem;
cursor: pointer;
}

.menu-list .logout{
width:100%;
height:0.48rem;
line-height:0.48rem;
font-size: 0.14rem;
font-weight: 600;
color:#fff;
cursor: pointer;
border-radius: 0.08rem;
border: 1px solid #fff;
display: flex;
align-items: center;
padding: 0 0.08rem;
margin-top:0.16rem;
}

.menu-list .logout::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/menu.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .tools{
width:100%;
margin-top:0.16rem;
}

.menu-list .tools ul{
display: flex;
justify-content: space-between;
}

.menu-list .tools ul li{
width:1.275rem;
height:0.48rem;
line-height:0.48rem;
text-align: center;
font-size: 0.14rem;
font-weight:600;
color:#fff;
cursor: pointer;
border-radius: 0.08rem;
background: #202020;  
display: flex;
align-items: center;
padding: 0 0.08rem;
}

.menu-list .tools ul li:first-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/csl1.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.menu-list .tools ul li:last-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/csl2.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet{
width: 3.75rem;
height:7.8rem;
border-radius: 0.08rem;
background: #181818;
z-index: 1000;
padding: 0 0.16rem;
font-family: Montserrat;
position: relative;
}

.mask .wallet p.title{
width: 100%;
height: 0.5rem;
display: flex;
align-items: center;
justify-content: space-between;
position: absolute;
top:0;
left:0;
padding: 0 0.16rem;
background: #181818;
border-radius: 0.08rem;
}

.mask .wallet p.title a{
  margin-right: 0.4rem;
  border-bottom: 1px solid #fff;
  cursor: pointer;
}

.mask .wallet p.title span{
font-weight: bold;
font-size: 0.18rem;
}

.mask .wallet p.title span.close{
display: block;
position: absolute;
top: 0.14rem;
right: 0.16rem;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/close.png') no-repeat center center;
background-size: contain;
cursor: pointer;
transition: all 0.3s ease;
}
.mask .wallet p.title span.close:hover{
transform: rotate(360deg);
}


.mask .wallet .content{
height: 100%;
padding-top:0.5rem;
overflow-y: scroll;
padding-bottom: 1rem;
}

/* 滚动条不占用页面宽度，移动端隐藏效果 */
.mask .wallet .content {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */
}

/* Webkit 浏览器（Chrome, Safari）隐藏滚动条 */
.mask .wallet .content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background: transparent;
  display: none;
}





.mask .wallet .types{
margin-top: 0.16rem;
}

.mask .wallet .types ul{
display: flex;
}

.mask .wallet .types ul li{
width: 1.2rem;
height: 0.48rem;
line-height: 0.48rem;
text-align: center;
font-weight: 600;
border-radius: 0.08rem;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;  
transition: all 0.3s ease;
} 
.mask .wallet .types ul li:hover{
 scale: 1.05;
}
.mask .wallet .types ul li.on{
background: #202020;
border-radius: 0.08rem;
}

.mask .wallet .types ul li:last-child{
margin-left: 0.08rem;
}

.mask .wallet .types ul li:first-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/deposit.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .types ul li:last-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/withdraw.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.mask .wallet .deposit{
margin-top: 0.16rem;
}
.mask .wallet .deposit .option ul{
display: flex;
flex-wrap: wrap;
gap: 0.08rem;    /* 设置子元素之间的横纵间隙相等 */
justify-content: flex-start; /* 保证子元素从左向右排列, 换行后依旧从左开始 */
}
.mask .wallet .deposit .option ul li{
width:1.09rem;
height:0.48rem;
border-radius: 0.08rem;
background: #202020;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
}

.mask .wallet .deposit .option ul li.on{
border: 1px solid #F400B0;
}

.mask .wallet .deposit .option ul li img{
width:0.32rem;
height:0.32rem;
}

.mask .wallet .deposit .option p{
height:0.32rem;
line-height:0.32rem;
text-align: center;
font-size: 0.12rem;
color: #999;
cursor: pointer;
border-radius: 0.08rem;
background: #202020;
margin-top:0.08rem;
}

.mask .wallet .deposit .merchants{
margin-top: 0.16rem;
}

.mask .wallet .deposit .merchants p{
font-size: 0.14rem;
color: #999;
}

.mask .wallet .deposit .merchants ul{
display: flex;
flex-wrap: wrap;
gap: 0.08rem;
justify-content: flex-start;
margin-top: 0.08rem;
}

.mask .wallet .deposit .merchants ul li{
width:1.09rem;
height:0.48rem;
border-radius: 0.16rem;
background: #202020;
font-size: 0.14rem;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
}

.mask .wallet .deposit .merchants ul li.on{
border: 1px solid #F400B0;
}

.mask .wallet .deposit .merchants ul li span{
color:#999;
font-weight: 300;
}
.mask .wallet .deposit .amount{
margin-top: 0.16rem;
}
.mask .wallet .deposit .amount p{
width: 100%;
height:0.21rem;
display: flex;
align-items: center;
justify-content: space-between;
font-size: 0.14rem;
color:#999;
}

.mask .wallet .deposit .amount p span span{
color:#F400B0;
}

.mask .wallet .deposit .amount ul.abox{
width: 100%;
height:0.98rem;
display: flex;
flex-direction: column;
justify-content: space-between;
border-radius: 0.08rem;
background: #202020;
padding: 0.12rem;
margin-top: 0.08rem;
}

.mask .wallet .deposit .amount ul.abox li{
display: flex;
align-items: center;
}

.mask .wallet .deposit .amount ul.abox li:first-child{
width: 100%;
height:0.24rem;
}

.mask .wallet .deposit .amount ul.abox li:first-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/cny.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .deposit .amount ul.abox li.usdt:first-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/usdt.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}


.mask .wallet .deposit .amount ul.abox li:first-child input{
width: 100%;
height:100%;
border: none;
outline: none;
background: transparent;
color: #fff;
}

.mask .wallet .deposit .amount ul.abox li:last-child{
width: 100%;
height:0.34rem;
background: #FFFFFF08;
border-radius: 0.08rem;
color:#999;
padding: 0 0.08rem;
}

.mask .wallet .deposit .amount ul.abox li:last-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/cny.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .deposit .amount ul.abox li:last-child span{
font-size: 0.12rem;
}

.mask .wallet .deposit .amount ul.faster{
display: flex;
flex-wrap: wrap;
gap: 0.08rem;
justify-content: flex-start;
margin-top: 0.08rem;
}

.mask .wallet .deposit .amount ul.faster li{
width: 0.7975rem;
height: 0.48rem;
border-radius: 0.08rem;
background: #202020;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
font-size: 0.14rem;
font-weight: 500;
color: #fff;
}

.mask .wallet .deposit .amount ul.faster li.on{
border: 1px solid #F400B0;
}

.mask .wallet .deposit .promotion{
margin-top: 0.16rem;
}

.mask .wallet .deposit .promotion p{
font-size: 0.14rem;
color: #999;
}

.mask .wallet .deposit .promotion ul{
display: flex;
flex-wrap: wrap;
gap: 0.08rem;
justify-content: flex-start;
margin-top: 0.08rem;
}

.mask .wallet .deposit .promotion ul li{
width: 100%;
height: 0.64rem;
border-radius: 0.08rem;
background: #202020;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;  
padding:0 0.12rem;
display: flex;
align-items: center;
position: relative;
}

.mask .wallet .deposit .promotion ul li.on{
border: 1px solid #F400B0;
}

.mask .wallet .deposit .promotion ul li.on::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/psld.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
position: absolute;
right: 0.08rem;
}

.mask .wallet .btns{
/*width: 100%;
height: 0.8rem;
background: #181818;
display: flex;
align-items: center;
justify-content: center;
position: absolute;
bottom: 0;
left: 0;
padding: 0 0.16rem;
border-radius: 0.16rem;*/
margin-top: 0.16rem;
}
.mask .wallet .btns a{
display: block;
width: 100%;
height: 0.48rem;
line-height: 0.48rem;
text-align: center;
font-weight: 600;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius: 0.08rem;
cursor: pointer;
}

.mask .wallet .btns a.back{
background:#202020;
margin-top: 0.16rem;
}

.mask .wallet .deposit .name{
margin-top: 0.16rem;
}

.mask .wallet .deposit .name p{
font-size: 0.14rem;
color: #999;
}


.mask .wallet .deposit .name div{
width: 100%;
height: 0.48rem;
background: #202020;
border-radius: 0.08rem;
padding: 0 0.08rem;
margin-top: 0.08rem;
}

.mask .wallet .deposit .name div input{
width: 100%;
height: 100%;
border: none;
outline: none;
background: transparent;
color: #fff;
}


.mask .wallet .deposit .receivable{
margin-top: 0.16rem;
}

.mask .wallet .deposit .receivable .info{
width: 100%;
height: 1.24rem;
background: #202020;
border-radius: 0.16rem;
padding: 0.16rem;
margin-top: 0.08rem;
}
.mask .wallet .deposit .receivable .info p{
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
}

.mask .wallet .deposit .receivable .info ul{
display: flex;
flex-direction: column;
gap: 0.08rem;
justify-content: space-between;
}
.mask .wallet .deposit .receivable .info ul li:first-child{
display: flex;
justify-content: space-between;
height: 0.24rem;
line-height: 0.24rem;
font-weight: 500;
}

.mask .wallet .deposit .receivable .info ul li:first-child span{
display:flex;
align-items: center;

}
.mask .wallet .deposit .receivable .info ul li:first-child span:first-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/cny.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .deposit .receivable .info ul li:first-child span.usdt:first-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/usdt.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .deposit .receivable .info ul li:first-child span:last-child{
cursor: pointer;
}
.mask .wallet .deposit .receivable .info ul li:first-child span:last-child::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/copy.png') no-repeat center center;
background-size: contain;
margin-left: 0.08rem;
}

.mask .wallet .deposit .receivable .info ul li:last-child{
height: 0.31rem;
line-height: 0.31rem;
font-size: 0.12rem;
text-align: center;
background: #FFFFFF08;
border-radius: 0.08rem;
}

.mask .wallet .deposit .receivable .address{
margin-top: 0.16rem;
background: #202020;
border-radius: 0.16rem;
padding: 0.16rem;
}

.mask .wallet .deposit .receivable .address p{
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
}

.mask .wallet .deposit .receivable .address ul{
display: flex;
flex-direction: column;
gap: 0.08rem;
justify-content: space-between;
}

.mask .wallet .deposit .receivable .address ul li:first-child{
font-size: 0.14rem;
color: #fff;
font-weight: 600;
margin-bottom: 0.08rem;
cursor: pointer;
display: flex;
align-items: center;
}

.mask .wallet .deposit .receivable .address ul li:first-child::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/copy.png') no-repeat center center;
background-size: contain;
margin-left: 0.08rem;
}

.mask .wallet .deposit .receivable .address ul li:last-child{
width: 100%;
height:1.2rem;
display: flex;
justify-content: center;
}

.mask .wallet .deposit .receivable a{
display: block;
width: 100%;
height: 0.48rem;
line-height: 0.48rem;
text-align: center;
font-weight: 600;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius: 0.08rem;
margin-top: 0.16rem;
cursor: pointer;
}

.mask .wallet .deposit .receivable .bank{
margin-top: 0.16rem;
background: #202020;
border-radius: 0.16rem;
padding: 0.16rem;
}


.mask .wallet .deposit .receivable .bank p{
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
}


.mask .wallet .deposit .receivable .bank ul{
display: flex;
flex-direction: column;
gap: 0.08rem;
justify-content: space-between;
}

.mask .wallet .deposit .receivable .bank ul li{
height: 0.4rem;;
line-height: 0.4rem;
border-radius: 0.08rem;
background: #FFFFFF08;
padding: 0 0.12rem;
font-weight: 500;
display: flex;
align-items: center;
position: relative;
cursor: pointer;
}

.mask .wallet .deposit .receivable .bank ul li:nth-child(1)::after,
.mask .wallet .deposit .receivable .bank ul li:nth-child(2)::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/copy.png') no-repeat center center;
background-size: contain;
position: absolute;
right: 0.08rem;
}

.mask .wallet .deposit .receivable .bank  div {
font-size: 0.12rem;
color: #999;
font-weight: 300;
display: flex;
align-items: center;
margin-top: 0.08rem;
}

.mask .wallet .deposit .receivable .bank div::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/note.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

div#qrcode_crypto{
min-width:1.2rem;
min-height:1.2rem;
display: flex;
justify-content: center;
align-items: center;
background: #fff;
border-radius: 0.08rem;
}

.mask .wallet .withdraw{
margin-top: 0.16rem;
}

.mask .wallet .withdraw .option ul{
display: flex;
flex-wrap: wrap;
gap: 0.08rem;
justify-content: flex-start;
}

.mask .wallet .withdraw .option ul li{
width: 1.09rem;
    height: 0.48rem;
    border-radius: 0.08rem;
    background: #202020;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.mask .wallet .withdraw .option ul li.on{
border: 1px solid #FF00A7;
}

.mask .wallet .withdraw .option ul li img{
width: 0.32rem;
height: 0.32rem;
}
.mask .wallet .withdraw .amount{
margin-top: 0.16rem;
}
.mask .wallet .withdraw .amount p{
display: flex;
justify-content: space-between;
align-items: center;
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
}

.mask .wallet .withdraw .amount p span:last-child{
font-size: 0.14rem;
color: #fff;
}


.mask .wallet .withdraw .amount div{
width: 100%;
height: 0.48rem;
border-radius: 0.08rem;
background: #202020;
padding: 0 0.12rem;
display: flex;
align-items: center;
}

.mask .wallet .withdraw .amount div::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/cny.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .withdraw .amount div.usdt::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/usdt.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .withdraw .amount div input{
width: 100%;
height: 100%;
border: none;
background: transparent;
outline: none;
font-size: 0.14rem;
color: #fff;
}

.mask .wallet .withdraw .amount span.desc{
font-size: 0.12rem;
color: rgb(227, 56, 56);
font-weight: 600;
margin-bottom: 0.08rem;
}

.mask .wallet .withdraw .amount span.desc.done{
  color: rgb(31, 187, 37);
}

.mask .wallet .withdraw .banks{
margin-top: 0.16rem;
}

.mask .wallet .withdraw .banks ul{
display: flex;    
flex-direction: column;
gap: 0.16rem;
justify-content: space-between;
}

.mask .wallet .withdraw .banks ul li{
width:100%;
height:0.82rem;
display: flex;
justify-content: space-between;
align-items: center;
background: #202020;
border-radius: 0.16rem;
padding: 0.16rem;
position: relative;
cursor: pointer;
}
.mask .wallet .withdraw .banks ul li.on{
 border: 1px solid #FF00A7;
}

.mask .wallet .withdraw .banks ul li a{
position: absolute;
right: -1px;
top: -1px;
width: 0.42rem;
height: 0.23rem;
line-height: 0.23rem;
text-align: center;
background: #19AD4D;
border-radius: 0 0.08rem 0 0.08rem;
font-size: 0.12rem;

}

.mask .wallet .withdraw .banks ul li div p{
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
font-weight: 300;
}

.mask .wallet .withdraw .banks ul li div span{
font-size: 0.14rem;
} 

.mask .wallet .withdraw .banks ul li.add{
border: 2px dashed #202020;
height:1.01rem;
background: #181818;
border-radius: 0.16rem;
padding: 0.24rem;
cursor: pointer;
flex-direction: column;
justify-content: space-between;
}

.mask .wallet .withdraw .banks ul li.add p{
background: url('@/img/add.png') no-repeat center center;
background-size: contain;
width: 0.24rem;
height: 0.24rem;
}

.mask .wallet .withdraw .banks ul li.add span{
font-size: 0.14rem;
color: #999;
}

.mask .wallet .withdraw .pwd{
margin-top: 0.16rem;
}

.mask .wallet .withdraw .pwd p{
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
}

.mask .wallet .withdraw .pwd div{
width: 100%;
height: 0.48rem;
border-radius: 0.08rem;
background: #202020;
padding: 0 0.12rem;
display: flex;
align-items: center;
} 

.mask .wallet .withdraw .pwd div input{
width: 100%;
height: 100%;
border: none;
background: transparent;
outline: none;
font-size: 0.14rem;
color: #fff;
}

.mask .wallet .withdraw  .crypto{
margin-top: 0.16rem;
}

.mask .wallet .withdraw .crypto .t{
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
}

.mask .wallet .withdraw .crypto .i{
display: flex;
justify-content: space-between;
align-items: center;
margin-bottom: 0.08rem;
position: relative;
}
.mask .wallet .withdraw .crypto .i span{
display: flex;
align-items: center;
font-size: 0.14rem;
}
.mask .wallet .withdraw .crypto .i span:last-child{
font-weight: 600;
}

.mask .wallet .withdraw .crypto .i span:first-child::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/usdt.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .wallet .withdraw .crypto .b{
display: block;
height:0.34rem;
line-height: 0.34rem;
background: #202020;
border-radius: 0.08rem;
padding: 0 0.12rem;
color: #999;
} 

.mask .wallet .withdraw .crypto .b span{
color: #F400B0;
}

.mask .wallet .card{
margin-top: 0.16rem;
}

.mask .wallet .card ul{
display: flex;
justify-content: space-between;
}

.mask .wallet .card ul li{
width: 1.675rem;
height: 0.48rem;
border-radius: 0.08rem;
background: #202020;
display: flex;
align-items: center;
cursor: pointer;
font-size: 0.14rem;
color: #999;
padding: 0 0.08rem;
position: relative;
}
.mask .wallet .card ul li::after{
content: '';
display: block;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/down.png') no-repeat center center;
background-size: contain;
position: absolute;
right: 0.08rem;
}

.mask .wallet .card ul li div{
display: flex;
align-items: center;
}

.mask .wallet .card ul li div img{
width: 0.24rem;
height: 0.24rem;
margin-right: 0.08rem;
}

.mask .wallet .card ul li div span{
font-size: 0.14rem;
color: #999;
}


/* 使滚动条变细且不占用元素宽度 */
.mask .wallet .card ul li dl::-webkit-scrollbar {
  width: 3px; /* 滚动条宽度细 */
  background: transparent;
}

.mask .wallet .card ul li dl::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 2px;
}

.mask .wallet .card ul li dl {
  scrollbar-width: thin;         /* Firefox */
  scrollbar-color: #444 transparent; /* Firefox */
}

.mask .wallet .card ul li dl{
width:100%;
height: 5rem;
position: absolute;
left:0;
top:0.56rem;
border-radius: 0.08rem;
overflow: auto;
z-index: 11;
background: #181818;
}

.mask .wallet .card ul li dl dd{
width:100%;
height:0.48rem;
display: flex;
align-items: center;
padding: 0 0.08rem;
background: #202020;
border-radius: 0.08rem;
margin-bottom: 0.08rem;
cursor: pointer;
}

.mask .wallet .card ul li dl dd.on{
border: 1px solid #F400B0;
}

.mask .wallet .card ul li dl dd img{
margin-right: 0.08rem;
width: 0.24rem;
height: 0.24rem;
}

.mask .wallet .card ul li dl dd span{
font-size: 0.14rem;
color: #999;
}

.mask .wallet .card .ibox{
margin-top: 0.16rem;
}
.mask .wallet .card .ibox div.c{
margin-bottom: 0.08rem;
}
.mask .wallet .card .ibox div.c div{
width: 100%;
height: 0.48rem;
border-radius: 0.08rem;
background: #202020;
padding: 0 0.12rem;
display: flex;
align-items: center;
}
.mask .wallet .card .ibox div.c p.t{
font-size: 0.14rem;
color: #999;
margin-bottom: 0.08rem;
}

.mask .wallet .card .ibox div.c div input{
width: 100%;
height: 100%;
border: none;
background: transparent;
outline: none;
font-size: 0.14rem;
color: #fff;
} 

.mask .wallet .card .ibox div.c div.v{
display: flex;
align-items: center;
}

.mask .wallet .card .ibox div.c div.v a{
width: 2rem;
height: 0.32rem;
line-height: 0.32rem;
text-align: center;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
border-radius: 0.08rem;
font-size: 0.14rem;
cursor: pointer;
}

.mask .wallet .card .ibox div.add{
border: 2px dashed #202020;
height:1.01rem;
background: #181818;
border-radius: 0.16rem;
padding: 0.24rem;
cursor: pointer;
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: center;
margin: 0.16rem auto;
position: relative;
}

.mask .wallet .card .ibox div.add p{
background: url('@/img/add.png') no-repeat center center;
background-size: contain;
width: 0.24rem;
height: 0.24rem;
}

.mask .wallet .card .ibox div.add span{
font-size: 0.14rem;
color: #999;
}

#upload-input {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
opacity: 0;
cursor: pointer;
z-index: 10;
}

.mask .wallet .card .ibox div.addc {
  width: 3.43rem;
  height: 1.01rem;
  border-radius: 16px;
  border: 0.03rem dashed #202020;
  margin: 0.16rem auto;
  position: relative;
}

.mask .wallet .card .ibox div.addc a {
  display: block;
  width: 0.24rem;
  height: 0.24rem;
  background: url("~@/img/add.png")no-repeat center;
  background-size: contain;
  margin: 0 auto;
  margin-top: 0.24rem;
}

.mask .wallet .card .ibox div.addc p {
  text-align: center;
  color: #999;
  margin-top: 0.08rem;
}

.mask .wallet .card .ibox div.addc span.del {
display: block;
    width: 1rem;
    height: .4rem;
    line-height: .4rem;
    text-align: center;
    border-radius: .08rem;
    background: rgba(0, 0, 0, .5647058823529412);
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -.5rem;
    margin-top: -.2rem;
    cursor: pointer;
}

.mask .settings{  
  width: 3.75rem;
  height: 7.8rem;
  border-radius: 0.16rem;
  background: #181818;
  position: relative;
  font-family: Montserrat;
}

.mask .settings p.title{
  width: 100%;
    height: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 0.16rem;
    background: #181818;
    border-radius: 0.08rem;
    font-size: 0.18rem;
    font-weight: 600;
}

.mask .settings .close{
  display: block;
    position: absolute;
    top: 0.14rem;
    right: 0.16rem;
    width: 0.24rem;
    height: 0.24rem;
    background: url('@/img/close.png') no-repeat center center;
    background-size: contain;
    cursor: pointer;
    transition: all 0.3s ease;
}
.mask .settings .close:hover{
  transform: rotate(180deg);
}

.mask .settings .content{
  padding: 0.16rem;
  margin-top: 0.52rem;
}

.mask .settings .content .option{
  display: flex;
  align-items: center;
}

.mask .settings .content .option p{
  width:1.2rem;
  height:0.48rem;
  line-height: 0.48rem;
  text-align: center;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right:0.08rem;
}

.mask .settings .content .option p:first-child::before{
  content: '';
  display: block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('@/img/info.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .settings .content .option p:last-child::before{
  content: '';
  display: block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('@/img/pwd.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .settings .content .option p.on{
  background: #202020;
  border-radius: 0.08rem;
}

.mask .settings .content .info{
  margin-top: 0.16rem;
}

.mask .settings .content .info .ibox{
  margin-bottom: 0.16rem;
}




.mask .settings .content .info .ibox .t{
  font-size: 0.14rem;
  color: #999;
  margin-bottom: 0.08rem;
}

.mask .settings .content .info .ibox .s{
display: flex;
justify-content: space-between;
align-items: center;
}

.mask .settings .content .info .ibox .s span{
display: block;
width:1.6rem;
height:0.48rem;
line-height: 0.48rem;
text-align: center;
cursor: pointer;
border-radius: 0.16rem;
background: #202020;
}

.mask .settings .content .info .ibox .s span.on{
border:1px solid #F400B0;
}

.mask .settings .content .info .ibox input{
  width: 100%;
  height: 0.48rem;
  border-radius: 0.08rem;
  background: #202020;
  border: none;
  outline: none;
  font-size: 0.14rem;
  color: #fff;
  padding: 0 0.12rem;
} 

.mask .settings .content .info a{
  display: block;
  width: 100%;
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
  border-radius: 0.08rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.mask .record{
width: 3.75rem;
height:7.8rem;
border-radius: 0.08rem;
background: #181818;
z-index: 1000;
padding: 0 0.16rem;
font-family: Montserrat;
position: relative;
overflow: hidden;
}

.mask .record p.title{
width: 100%;
height: 0.5rem;
display: flex;
align-items: center;
justify-content: space-between;
position: absolute;
top:0;
left:0;
padding: 0 0.16rem;
background: #181818;
border-radius: 0.08rem;
z-index: 1;
}

.mask .record p.title a{
  margin-right: 0.4rem;
  border-bottom: 1px solid #fff;
  cursor: pointer;
}

.mask .record p.title span{
font-weight: bold;
font-size: 0.18rem;
display: flex;
align-items: center;
}
.mask .record p.title span.acc{
font-size: 0.14rem;
 cursor: pointer;
}
.mask .record p.title span.acc::before{
 content: '';
 display: block;
 width: 0.24rem;
 height: 0.24rem;
 background: url('@/img/back.png') no-repeat center center;
 background-size: contain;
 margin-top: 0.03rem;

}

.mask .record p.title span.close{
display: block;
position: absolute;
top: 0.14rem;
right: 0.16rem;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/close.png') no-repeat center center;
background-size: contain;
cursor: pointer;
transition: all 0.3s ease;
}
.mask .record p.title span.close:hover{
transform: rotate(360deg);
}


.mask .record .content{
height: 100%;
padding-top:0.5rem;
overflow-y: scroll;
padding-bottom: 1rem;
 scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */
  margin-top:0.16rem;
}

/* Webkit 浏览器（Chrome, Safari）隐藏滚动条 */
.mask .record .content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background: transparent;
  display: none;
}
.mask .record .content .option{
display: flex;
flex-direction: column;
gap:0.16rem;
}
.mask .record .content .option .dd{
width:100%;
height:0.53rem;
border-radius: 0.08rem;
background: #202020;
padding: 0 0.16rem;
display: flex;
align-items: center;
font-size: 0.14rem;
font-weight: 600;
color: #999;
cursor: pointer;
position: relative;
} 

.mask .record .content .option .dd::after{
  content: '';
  display: block;
  width: 0.24rem;
  height: 0.24rem;
  background: url('@/img/down.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  right: 0.08rem;
}

.mask .record .content .option .dd dl{
  width:100%;
  padding: 0.08rem;  
  position: absolute;
  top: 0.6rem;
  left: 0;
  background: #202020;
  border-radius: 0.08rem;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap:0.08rem;
  overflow: hidden;
}

.mask .record .content .option .dd dl.active {
  opacity: 1;
  pointer-events: auto;
  max-height: 500px;
}


.mask .record .content .option .dd dl dd{
  width:100%;
  height:0.4rem;
  line-height: 0.4rem;
  padding:0 0.08rem;
  cursor: pointer;
  border-radius: 0.08rem;
}

.mask .record .content .option .dd dl dd.on{
  border: 1px solid #F400B0;
}

.mask .record .content .option a{
  display: block;
  width: 100%;
  height: 0.48rem;
  line-height: 0.48rem;
  text-align: center;
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
  border-radius: 0.08rem;
  font-weight: 600;
  cursor: pointer;
}

.mask .record .content ul.nopt,.mask .record .content ul.topt{
display: flex;
flex-wrap: wrap;
justify-content: flex-start;
gap:0.16rem;
}

.mask .record .content ul.nopt li,.mask .record .content ul.topt li{
width: 1rem;
height:0.48rem;
line-height: 0.48rem;
text-align: center;
font-weight: 600;
background: #202020;
border-radius: 0.08rem;
cursor: pointer;
}

.mask .record .content ul.topt li.on{
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
}

.mask .record .content ul.nopt li,.mask .record .content ul.topt li{
display: flex;
justify-content: center;
align-items: center;
background: #181818;
}

.mask .record .content ul.nopt li:first-child::before{
  content: '';
  width:0.16rem;
  height:0.16rem;
  background: url("@/img/msg1.png") center center no-repeat;
  background-size: contain;
  margin-right: 0.08rem;
  display: block;
}

.mask .record .content ul.nopt li:last-child::before{
  content: '';
  width:0.16rem;
  height:0.16rem;
  background: url("@/img/msg2.png") center center no-repeat;
  background-size: contain;
  margin-right: 0.08rem;
  display: block;
}


.mask .record .content ul.nopt li.on{
background: #202020;;
}

.mask .record .content dl.task{
display: flex;
flex-direction: column;
gap:0.16rem;
margin-top: 0.16rem;
}

.mask .record .content dl.task dd{
width:100%;
height: 0.95rem;
border-radius: 0.16rem;
background: #202020;
padding: 0.16rem;
display: flex;
flex-direction: column;
justify-content: space-between;
position: relative;
}

.mask .record .content dl.task dd p{

font-size: 0.14rem;
color:#999;
font-weight: bold;
}

.mask .record .content dl.task dd div{
display: flex;
justify-content: space-between;
}

.mask .record .content dl.task dd div span{
font-size: 0.18rem;
font-weight: bold;
display: flex;
align-items: center;
}

.mask .record .content dl.task dd div span::before{
  content: '';
  width:0.16rem;
  height:0.16rem;
  background: url("@/img/cny.png") center center no-repeat;
  background-size: contain;
  margin-right: 0.08rem;
  display: block;
}

.mask .record .content dl.task dd div a{
width:0.52rem;
height:0.34rem;
line-height: 0.34rem;
text-align: center;
font-size: 0.12rem;
font-weight: 600;
border-radius: 0.08rem;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
}

.mask .record .content dl.task dd span.times{
width:0.5rem;
height:0.29rem;
line-height: 0.29rem;
text-align: center;
font-size: 0.14rem;
font-weight: 600;
border-radius: 0 0.16rem 0 0.16rem;
background: #FFFFFF1A;
position: absolute;
top:0;
right:0
}

.mask .record .content dl.notice{
display: flex;
flex-direction: column;
gap:0.16rem;
margin-top: 0.16rem;
}

.mask .record .content dl.notice dd{
width:100%;
border-radius: 0.16rem;
background: #202020;
padding: 0.16rem;
display: flex;
flex-direction: column;
justify-content: space-between;
position: relative;
gap:0.08rem;
}

.mask .record .content dl.notice dd p{
font-weight: 600;
}


.mask .record .content dl.notice dd div{
min-height: 0.6rem;
word-break: break-all;
  white-space: pre-line;
  font-size: 0.12rem;
  color:#999;
}

  .mask .record .content dl.notice dd span{
    font-size: 0.12rem;
    color:#FFFFFF33;
  }

.list-box{
width: 100%;
}
.list-box dl{
display: flex;
flex-direction: column;
gap:0.08rem;
}

.list-box dl dd {
height:0.53rem;
padding:0 0.16rem;
}

.list-box dl dd div{
width: 100%;
height: 0.53rem;
line-height: 0.53rem;
font-size: 0.14rem;
color: #999;
display: flex;
align-items: center;
}


.list-box dl dd div span{
display: block;
}

.list-box dl dd.b div span{
font-weight: 600;
color:#fff;
display: flex;
align-items: center;
gap:0.08rem;
}

.list-box dl dd div span:nth-child(1){
width:2.4rem;

}

.list-box dl dd div span img{
width:0.16rem;
height:0.16rem;
}

.list-box dl dd div span:nth-child(2){
width:2.4rem;
}

.list-box dl dd div span:nth-child(3){
width:2.7rem;
}
.list-box dl dd.b{
background: #202020;
border-radius: 0.16rem;
overflow: hidden;
cursor: pointer;
}
.list-box dl dd.b div{
position: relative;

}

.list-box dl dd.b div::after{
  content: '';
  display: block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('@/img/down.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  right: 0

}

.list-box dl dd.b.active{
height: auto;
padding-bottom: 0.08rem;
}

.list-box dl dd p{
display: flex;
justify-content: space-between;
margin-bottom:0.08rem;
font-size:0.14rem;
}

.list-box dl dd p span{
padding: 0.04rem 0.08rem;
border-radius: 0.04rem;
}

.list-box dl dd p span.o{
display: block;
width:0.51rem;
height:0.22rem;
line-height:0.22rem;
text-align: center;
background: #2e2e2e;
padding: 0;
font-size: 0.12rem;
}

.list-box dl dd p span.o.f{
background: #FF00001A;
}

.list-box dl dd p span.o.c{
background:#00D9FF1A;
}

.list-box dl dd p span.o.t{
background: #00FF0A1A;
}

 dl dd.n{
background: #202020;
border-radius: 0.16rem;
height: auto;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding-bottom: 0.16rem;
}

dl dd.n span{
font-size:0.14rem;
color:#999;
}

dl dd.n img{
width:1rem;
height:1rem;
}

dl dd.m{
font-size:0.14rem;
color:#999;
text-align: center;
cursor: pointer;
background: transparent !important;
}

.list-box dl dd p span:first-child{
color:#999
}

.record .f {
  color: #ff0000 !important;
}

.record .t {
  color: #00FF0A !important;
}

.record .c {
  color: #00D9FF !important;
}

.record .w {
  color: #FFA100 !important;
}

.mask .record .content .qr{
  width: 100%;
  background: #202020;
  border-radius: 0.16rem;
  padding: 0.16rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.16rem;
  margin-top:0.16rem;
}

.mask .record .content .qr .title{
display: flex;
justify-content: space-between;
align-items: center;
}

.mask .record .content .qr .title p{
font-size: 0.14rem; 
color: #999;
}

.mask .record .content .qr .title ul{
display: flex;
gap: 0.08rem;
}

.mask .record .content .qr .title ul li{
width:0.36rem;
height:0.23rem;
line-height:0.23rem;
text-align: center;
background: #FFFFFF1A;
border-radius: 0.04rem;
font-size: 0.1rem;
color: #999;
cursor: pointer;
}

.mask .record .content .qr .title ul li.on{
color: #fff;
}

.mask .record .content div.i{
width: 100%;
height: 1.08rem;
display: flex;
justify-content: center;
}

.mask .record .content .qr>p{
height:0.41rem;
line-height:0.41rem;
background: #FFFFFF08;
border-radius: 0.08rem;
padding: 0 0.16rem;
font-size: 0.14rem;
display: flex;
justify-content: space-between;
align-items: center;
}


.mask .record .content .qr>p>span:first-child{
width: 100%;
overflow: hidden;
white-space: nowrap;
  text-overflow: ellipsis;
}


.mask .record .content .qr>p>span:last-child{
display: block;
background: url('@/img/copy.png') no-repeat center center;
background-size: contain;
width: 0.16rem;
height: 0.16rem;
cursor: pointer;
}

.mask .record .content .qr>p span span {
color: #999;
font-weight: 300;
}

.mask .record .content .qr .i .qrbox{
width: 1.08rem;
height: 1.08rem;
background: #fff;
border-radius: 0.16rem;
padding: 0.04rem;

display: flex;
justify-content: center;
align-items: center;
}

.mask .record .content .aff-balane{
  margin-top: 0.16rem;
  padding: 0.16rem;
  border-radius: 0.16rem;
  background: #202020;
  height:0.95rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.mask .record .content .aff-balane p{
font-size: 0.14rem;
color:#999;
}

.mask .record .content .aff-balane div{
display: flex;
justify-content: space-between;
align-items: center;
height: 0.34rem  
}
.mask .record .content .aff-balane div span{
font-size: 0.18rem;
font-weight: 900;
display: flex;
align-items: center;
}

.mask .record .content .aff-balane div span::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/cny.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .record .content .aff-balane div a{
display: block;
width: 0.54rem;
height: 0.34rem;
line-height: 0.34rem;
text-align: center;
font-size: 0.12rem;
font-weight: 600;
border-radius: 0.08rem;
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
color: #fff;
cursor: pointer;
}

.mask .record .content .btips{
border-radius: 0.16rem;
padding: 0.16rem;
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: center;
border: 3px dashed hsla(0,0%,100%,.09803921568627451);
text-align: center;
font-size: 0.14rem;
margin-top: 0.16rem;
line-height: 0.2rem;
}

.mask .record .content .btips p{
font-weight: bold;
}

.mask .record .content .btips span{
color: #999;
}

.mask .record .content .data{
margin-top: 0.16rem;
padding: 0.16rem;
border-radius: 0.16rem;
background: #202020;
}

.mask .record .content .data ul{
display: flex;
justify-content: space-between;
gap: 0.16rem;
flex-wrap: wrap;
}

.mask .record .content .data ul li{
width:1.42rem;
display: flex;
justify-content: center;
flex-direction: column;
text-align: center;
gap:0.04rem;
}

.mask .record .content .data ul li p{
font-size: 0.14rem;
color: #999;
}

.mask .record .content .data ul li span{
font-size: 0.14rem;
font-weight: bold;
display: flex;
align-items: center;
margin: 0 auto;
}

.mask .record .content .data ul li span::before{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/cny.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .udata{
width: 3.75rem;
height:7.8rem;
border-radius: 0.08rem;
background: #181818;
z-index: 1000;
padding: 0 0.16rem;
font-family: Montserrat;
position: relative;
}

.mask .udata .title{
width: 100%;
height: 0.5rem;
display: flex;
align-items: center;
justify-content: space-between;
position: absolute;
top:0;
left:0;
padding: 0 0.16rem;
background: #181818;
border-radius: 0.08rem;
z-index: 1;
}

.mask .udata .title span{
font-size: 0.18rem;
font-weight: 600;
color: #fff;
}

.mask .udata .title a{
  margin-right: 0.4rem;
  border-bottom: 1px solid #fff;
  cursor: pointer;
}

.mask .udata .title .close{
display: block;
position: absolute;
top: 0.14rem;
right: 0.16rem;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/close.png') no-repeat center center;
background-size: contain;
cursor: pointer;
transition: all 0.3s ease;
}

.mask .udata .title .close:hover{
transform: rotate(180deg);
}
.mask .udata .content{
    height: 100%;
    padding-top: 0.5rem;
    overflow-y: scroll;
    padding-bottom: 1rem;
}

.mask .udata .content::-webkit-scrollbar {
  width: 3px; /* 滚动条宽度细 */
  background: transparent;
}
.mask .udata .content .user{
  margin-top: 0.16rem;
  border-radius: 0.16rem;
  height: 1.38rem;
  background: linear-gradient(180deg, rgba(255, 0, 167, 0.1) 0%, rgba(136, 0, 255, 0.3) 100%);
  position: relative;
  display: flex;
  justify-content: center;
      align-items: center;
}

.mask .udata .content .user dl{
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
}

.mask .udata .content .user dl dd:nth-child(1){
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mask .udata .content .user dl dd:nth-child(1) span:first-child{
  width: 0.48rem;
  height: 0.48rem;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid #fff;
  display: block;
}

.mask .udata .content .user dl dd:nth-child(1) span:first-child img{
  width: 0.48rem;
  height: 0.48rem;
  display: block;
}

.mask .udata .content .user dl dd:nth-child(1) span:last-child{
  display: block;
  width:0.4rem;
  height:0.16rem;
  line-height: 0.16rem;
  text-align: center;
  font-size: 0.1rem;
  font-weight: bold;
  background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
  border-radius: 0.04rem;
  margin-top:-0.03rem;
}

.mask .udata .content .user dl dd:nth-child(2){
  width:100%;
  font-weight: 1000;
  position: relative;
  display: flex;
  align-items: center;
}

.mask .udata .content .user dl dd:nth-child(2)::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/edit.png') no-repeat center center;
background-size: contain;
opacity: 0.6;
margin-left: 0.08rem;
margin-top: 0.02rem;
}

.mask .udata .content .count{
  margin-top: 0.16rem;
  border-radius: 0.16rem; 
}
.mask .udata .content .count p.t{
  font-size: 0.14rem;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
}
.mask .udata .content .count p.t::before{
content: '';
display: block;
width: 0.24rem;
height: 0.24rem;
background: url('@/img/stat.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}

.mask .udata .content .count div{
  background: #202020;
  border-radius: 0.16rem;
  padding: 0.16rem 0;
  margin-top: 0.16rem;
  height: 1.4rem;
}

.mask .udata .content .count div ul{
  display: flex;
  justify-content: space-between;
  gap: 0.16rem;
  flex-wrap: wrap;
}

.mask .udata .content .count div ul li{
  width: 30%;
  height:0.5rem;
  text-align: center;
}

.mask .udata .content .count div ul li p{
  font-size: 0.14rem;
  color: #999;
}

.mask .udata .content .count div ul li p.i{
  color: #E8B554;
  font-weight: bold;
}

.mask .udata .content .count div ul li span{
  font-size: 0.14rem;
  font-weight: 600;
  color: #fff;
}


.mask .udata .content .membership{
margin-top: 0.16rem;
}

.mask .udata .content .membership p.t{
  font-size: 0.14rem;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
} 

.mask .udata .content .membership p.t::before{
  content: '';
  display: block;
  width: 0.24rem;
  height: 0.24rem;
  background: url('@/img/vip.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .udata .content .membership .v-banner{
width:3.1rem;
height:1.74rem;
border-radius: 0.16rem;
overflow: hidden;
margin: 0 auto;
margin-top: 0.16rem;
}

.mask .udata .content .membership .v-banner div.vip{
width:3.1rem;
height:1.74rem;
display: block;
}

.mask .udata .content .membership .v-banner div.vip.vip_1{
background: url('@/img/vip1.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_2{
background: url('@/img/vip2.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_3{
background: url('@/img/vip3.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_4{
background: url('@/img/vip4.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_5{
background: url('@/img/vip5.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_6{
background: url('@/img/vip6.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_7{
background: url('@/img/vip7.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_8{
background: url('@/img/vip8.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_9{
background: url('@/img/vip9.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip.vip_10{
background: url('@/img/vip10.png') no-repeat center center;
background-size: contain;
}

.mask .udata .content .membership .v-banner div.vip .progress{
padding-top:1.2rem;
padding-left: 0.32rem;
}
.mask .udata .content .membership .v-banner div.vip .progress p{
font-size: 0.12rem;
color:#999;
}
.mask .udata .content .membership .v-banner div.vip .progress div{
width: 85%;
height: 0.04rem;
border-radius: 0.16rem;
background: #999;
margin-top:0.08rem;
}

.mask .udata .content .membership .v-banner div.vip .progress div span{
display: block;
width: 80%;
height: 0.04rem;
background: #fff;
border-radius: 0.16rem;
}

.mask .udata .content .bonus{
margin-top: 0.16rem;
}

.mask .udata .content .bonus ul{
display: flex;
flex-wrap: wrap;
gap:0.16rem;
justify-content: space-between;
padding: 0 0.32rem;
}

.mask .udata .content .bonus ul li{
width: 1.2rem;
height:0.47rem;
display: flex;
align-items: center;
font-size: 0.12rem;
}


.mask .udata .content .bonus ul li:nth-child(1)::before{
  content: '';
  display: block;
  width: 0.38rem;
  height: 0.38rem;
  background: url('@/img/vl1.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .udata .content .bonus ul li:nth-child(2)::before{
  content: '';
  display: block;
  width: 0.38rem;
  height: 0.38rem;
  background: url('@/img/vr1.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .udata .content .bonus ul li:nth-child(3)::before{
  content: '';
  display: block;
  width: 0.38rem;
  height: 0.38rem;
  background: url('@/img/vl2.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .udata .content .bonus ul li:nth-child(4)::before{
  content: '';
  display: block;
  width: 0.38rem;
  height: 0.38rem;
  background: url('@/img/vr2.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .udata .content .bonus ul li:nth-child(5)::before{
  content: '';
  display: block;
  width: 0.38rem;
  height: 0.38rem;
  background: url('@/img/vl3.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .udata .content .bonus ul li:nth-child(6)::before{
  content: '';
  display: block;
  width: 0.38rem;
  height: 0.38rem;
  background: url('@/img/vr3.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.08rem;
}

.mask .udata .content .bonus ul li span{
color: #999;
}

.mask .record .content .aff-list div{
font-size: 0.14rem;
padding: 0 0.16rem;
}
.mask .record .content .aff-list div.tt{
color:#999
}

.mask .record .content .aff-list div.tb{
background: #202020;
border-radius: 0.16rem;
}

.mask .record .content .aff-list div p{
display: flex;
justify-content: space-between;
padding: 0.16rem;
}

.mask .record .content .aff-list div p span{
text-align: center;

}

.mask .record .content .aff-rules{  
margin-top: 0.16rem;
}

.mask .record .content .aff-rules p{
  font-size: 0.14rem;
  color:#999;
  font-weight: bold;
}
.mask .record .content .aff-rules div{
margin-top: 0.16rem;
  font-size: 0.14rem;
  color:#999;
  line-height: 0.24rem;
}


.mask .record p.title a {
width: 1.5rem;
height: 0.32rem;
display: flex;
align-items: center;
justify-content: space-between;
border:none;
background: #202020;
border-radius: 0.08rem;

}

.mask .record p.title a span.balance{
width:0.82rem;
display: block;
padding:0 0.04rem;
font-family: Montserrat;
font-size: 0.14rem;
leading-trim: NONE;
line-height: 100%;
letter-spacing: 0px;

}
.mask .record p.title a span.refresh{
   display: block;
    width: .16rem;
    height: .16rem;
    background: url("@/img/refresh.png") no-repeat 50%;
    background-size: contain;
    margin: 0 .08rem;
    cursor: pointer;
    transition: all 0.3s ease;
} 
.mask .record p.title a span.refresh:hover{
 transform: rotate(360deg);
}

.mask .record .content .inside{

}

.mask .record .content .inside ul{
display: flex;
justify-content: flex-start;
flex-wrap: wrap;
gap: 0.08rem;
}

.mask .record .content .inside ul li{
width: 0.78rem;
height: 0.4rem;
line-height: 0.4rem;
text-align: center;
background: #202020;
border-radius: 0.08rem;
font-weight: 600;
font-size: 0.14rem;
cursor: pointer;
}

.mask .record .content .inside ul li.on{
border: 1px solid #F400B0;
}

.footer{
width:100%;
height:auto;
background: #000;
padding: 0.16rem;
display: flex;
justify-content: center;
padding: 0.32rem 0;
flex-wrap: wrap;
}

.footer div{
margin:0 0.24rem;
}

.footer p{
color:#999;
font-weight: bold;
}

.footer ul{
display: flex;
gap: 0.08rem;
margin-top:0.24rem;
}

.footer div:nth-child(1) ul li{
width: 0.4rem;
height: 0.4rem;
border-radius: 0.08rem;
}

.footer div:nth-child(2) ul li:first-child{
width:1.35rem;
height:0.4rem;
}

.footer div:nth-child(2) ul li:last-child{
width:1.2rem;
height:0.4rem;
}

.footer div:nth-child(3) ul li{
width:0.63rem;
height:0.4rem;
}

.footer div:nth-child(3) ul li:nth-child(1){
background: url('@/img/g1.png') no-repeat center center;
background-size: contain;
}

.footer div:nth-child(3) ul li:nth-child(2){
background: url('@/img/g2.png') no-repeat center center;
background-size: contain;
}

.footer div:nth-child(3) ul li:nth-child(3){
background: url('@/img/g3.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(4){
background: url('@/img/g4.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(5){
background: url('@/img/g5.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(6){
background: url('@/img/g6.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(7){
background: url('@/img/g7.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(8){
background: url('@/img/g8.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(9){
background: url('@/img/g9.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(10){
background: url('@/img/g10.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(11){
background: url('@/img/g11.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(12){
background: url('@/img/g12.png') no-repeat center center;
background-size: contain;
} 

.footer div:nth-child(3) ul li:nth-child(13){
background: url('@/img/g13.png') no-repeat center center;
background-size: contain;
}

.mask .record .content .game-list ul{
display: flex;
gap: 0.08rem;
flex-wrap: wrap;
}

.mask .record .content .game-list ul li{
width: 0.622rem;
height: 0.37rem;
line-height: 0.37rem;
text-align: center;
background: #202020;
border-radius: 0.08rem;
font-weight: 600;
font-size: 0.14rem;
cursor: pointer;
}

.mask .record .content .game-list ul li.on{
background: linear-gradient(180deg, #FF00A7 0%, #8800FF 100%);
}

.mask .record .content .total{
margin-top: 0.16rem;
}

.mask .record .content .total dl{
display: flex;
justify-content: space-between;
}

.mask .record .content .total dl dd{

  font-size: 0.14rem;
  color: #999;
  font-weight: 600;
} 

.mask .record .content .total dl dd span{
  font-size: 0.14rem;
  color: #fff;
  font-weight: 600;
}

.mask .record .content .btn{
margin: 0.16rem 0;
}

.mask .record .content .btn dl{
display: flex;
justify-content: space-between;
} 

.mask .record .content .btn dl dd{
width:1.09rem;
height:0.37rem;
line-height: 0.37rem;
text-align: center;
background: #202020;
border-radius: 0.08rem;
font-size: 0.14rem;
color: #999;
cursor: pointer;
position: relative;
}

.mask .record .content .btn dl dd.on{
border: 1px solid #F400B0;
color: #fff;
}

.mask .record .content .btn dl dd ul{
width:100%;
position: absolute;
top: 0.42rem;
left: 0;
background: #202020;
border-radius: 0.08rem;
padding: 0.08rem;
z-index: 3;
}

.mask .record .content .btn dl dd ul li{
font-size: 0.14rem;
color: #999;
cursor: pointer;
}

.mask .record .content .btn dl dd ul li.on{
color:#F400B0;
}

.mask .record .content .option1{
}

.mask .record .content .option1 ul{
display: flex;
gap: 0.08rem;
}

.mask .record .content .option1 ul li{
width:0.72rem;
height:0.37rem;
line-height: 0.37rem;
text-align: center;
background: #202020;
border-radius: 0.08rem;
font-size: 0.14rem;
font-weight: bolder;
color: #F4F4F4;
cursor: pointer;
display: flex;
justify-content: center;
  align-items: center;
  position: relative;
  border: 1px solid #FFFFFF7F;

}

.mask .record .content .option1 ul li::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/down.png') no-repeat center center;
background-size: contain;
margin-left: 0.08rem;
}

.mask .record .content .option1 ul li.on::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('@/img/up.png') no-repeat center center;
background-size: contain;
margin-left: 0.08rem;
}


.mask .record .content .option1 ul li dl{
width:100%;
position: absolute;
top: 0.45rem;
left: 0;
background: #505050;
border-radius: 0.08rem;
z-index: 3;
}

.mask .record .content .option1 ul li dl dd{
font-size: 0.14rem;
color: #FFFFFF7F;
font-weight: 400;
cursor: pointer;
}

.mask .record .content .option1 ul li dl dd.on{
border-radius: 0.08rem;
background: #FFDD00;
color: #772200;
}
.list-box1 {
margin: 0.16rem 0;
}
.list-box1 dl dd.b{
padding:0 0.12rem;
padding-bottom: 0.08rem;
border-radius: 0.08rem;
background: #FFFFFF0C;
border: 1px solid #FFFFFF19;
margin-bottom: 0.16rem;
}
.list-box1 dl dd.b div{
 display: flex;
 justify-content: space-between;
}

.list-box1 dl dd.b div.tt{
padding: 0.08rem 0;
border-bottom: 1px solid #FFFFFF19;
font-weight: bold;
}

.list-box1 dl dd.b div:not(.tt){
padding:0.04rem 0;
}
.list-box1 dl dd.b div:not(.tt) p span{
font-size: 0.14rem;
color:#FFFFFFB2;
}

.list-box1 dl dd.b div:not(.tt) p span span{
color:#FFFFFF;
}




table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.16rem 0;
}

table thead tr th {
background: #FFFFFF0C;
border: 1px solid #FFFFFF19;
padding: 0.12rem 0.08rem;
font-size: 0.14rem;
color: #fff;
text-align: center;
}

table tr td {
border: 1px solid #FFFFFF19;
padding: 0.12rem 0.08rem;
font-size: 0.14rem;
color: #fff;
text-align: center;
}


.mask .record .content.p{
font-size: 0.14rem;
}


.rule p{
margin:0.16rem 0;
}


@media screen and (max-width: 1600px) {
 .center{
  padding: 0 0.1rem;
 }
}

@media screen and (max-width: 1366px) {
 .center{
  padding: 0 0.12rem;
 }
}

@media screen and (max-width: 1024px) {
 .center{
  padding: 0 0.08rem;
 }
}

</style>
